/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/cs/seznam-politiku/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "+TBW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (e, target, node, place, effect, offset) {
  var tipWidth = node.clientWidth;
  var tipHeight = node.clientHeight;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, target.clientWidth, target.clientHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffset_X = _calculateOffset.extraOffset_X,
      extraOffset_Y = _calculateOffset.extraOffset_Y;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft;

  // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offset_X = defaultOffset[place].l;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offset_X = defaultOffset[place].r;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offset_Y = defaultOffset[place].t;
    return mouseY + offset_Y + extraOffset_Y;
  };
  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offset_Y = defaultOffset[place].b;
    return mouseY + offset_Y + extraOffset_Y;
  };

  // Judge if the tooltip has over the window(screen)
  var outsideVertical = function outsideVertical() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideLeft = function outsideLeft() {
    var _outsideVertical = outsideVertical(),
        result = _outsideVertical.result,
        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority


    if (result && outsideHorizontal().result) {
      return { result: false }; // No need to change, if change to vertical will out of space
    }
    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
      result = true; // If vertical ok, but let out of side and right won't out of side
      newPlace = 'right';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideRight = function outsideRight() {
    var _outsideVertical2 = outsideVertical(),
        result = _outsideVertical2.result,
        newPlace = _outsideVertical2.newPlace;

    if (result && outsideHorizontal().result) {
      return { result: false }; // No need to change, if change to vertical will out of space
    }
    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };

  var outsideHorizontal = function outsideHorizontal() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
      result = true;
      newPlace = 'right';
    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideTop = function outsideTop() {
    var _outsideHorizontal = outsideHorizontal(),
        result = _outsideHorizontal.result,
        newPlace = _outsideHorizontal.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideBottom = function outsideBottom() {
    var _outsideHorizontal2 = outsideHorizontal(),
        result = _outsideHorizontal2.result,
        newPlace = _outsideHorizontal2.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };

  // Return new state to change the placement to the reverse if possible
  var outsideLeftResult = outsideLeft();
  var outsideRightResult = outsideRight();
  var outsideTopResult = outsideTop();
  var outsideBottomResult = outsideBottom();

  if (place === 'left' && outsideLeftResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideLeftResult.newPlace }
    };
  } else if (place === 'right' && outsideRightResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideRightResult.newPlace }
    };
  } else if (place === 'top' && outsideTopResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideTopResult.newPlace }
    };
  } else if (place === 'bottom' && outsideBottomResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideBottomResult.newPlace }
    };
  }

  // Return tooltip offset position
  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
};

// Get current mouse offset
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;
  var targetWidth = currentTarget.clientWidth;
  var targetHeight = currentTarget.clientHeight;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }
  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
};

// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {OBject} {left: {Number}, top: {Number}}
 */
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top = void 0;
  var right = void 0;
  var bottom = void 0;
  var left = void 0;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return { top: top, bottom: bottom, left: left, right: right };
};

// Consider additional offset into position calculation
var calculateOffset = function calculateOffset(offset) {
  var extraOffset_X = 0;
  var extraOffset_Y = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
  }
  for (var key in offset) {
    if (key === 'top') {
      extraOffset_Y -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffset_Y += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffset_X -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffset_X += parseInt(offset[key], 10);
    }
  }

  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
};

// Get the offset of the parent elements
var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;
  while (currentParent) {
    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;

  return { parentTop: parentTop, parentLeft: parentLeft };
};

/***/ }),

/***/ "/+BW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nodeList) {
  var length = nodeList.length;
  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }
  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
};

/***/ }),

/***/ "/7Sf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Icon = function Icon(props, context) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', _extends({
    alt: '',
    src: (context.hostname || '') + '/static/images/' + props.name + '.svg'
  }, _extends({}, props, { name: undefined })));
};

Icon.contextTypes = {
  hostname: __WEBPACK_IMPORTED_MODULE_1_react__["default"].PropTypes.string
};

/* unused harmony default export */ var _unused_webpack_default_export = (Icon);

/***/ }),

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export subscribers */
/* unused harmony export getCurrentUrl */
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Router; });
/* unused harmony export Route */
/* unused harmony export Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	if (opts === void 0) opts = EMPTY$1;

	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	var aAttr = a.attributes || EMPTY$1,
	    bAttr = b.attributes || EMPTY$1;
	if (aAttr.default) {
		return 1;
	}
	if (bAttr.default) {
		return -1;
	}
	var diff = rank(aAttr.path) - rank(bAttr.path);
	return diff || aAttr.path.length - bAttr.path.length;
}

function segmentize(url) {
	return strip(url).split('/');
}

function rank(url) {
	return (strip(url).match(/\/+/g) || '').length;
}

function strip(url) {
	return url.replace(/(^\/+|\/+$)/g, '');
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				return routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.slice().sort(pathRankSort).map(function (vnode) {
			var attrs = vnode.attributes || {},
			    path = attrs.path,
			    matches = exec(url, path, attrs);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
			return false;
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* unused harmony default export */ var _unused_webpack_default_export = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "/qIm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("pwNi");


/***/ }),

/***/ "2DKW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {}
            }
        }
    }

    return targetComponent;
};

/***/ }),

/***/ "2O6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__("X5xa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_visual_Spinner__ = __webpack_require__("Zcn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PoliticianDetail_PoliticianPage__ = __webpack_require__("BQTq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PoliticianList_PoliticianListPage__ = __webpack_require__("GV47");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: 130px;\n  height: 100%;\n'], ['\n  padding-top: 130px;\n  height: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n'], ['\n  height: 100%;\n']);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }









// import Home from 'async!./home';
// import Profile from 'async!./profile';

var Content = __WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].div(_templateObject);

var FullScreen = __WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].div(_templateObject2);

var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__components_visual_Spinner__["a" /* default */], null);

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      props: typeof document !== 'undefined' ? JSON.parse(document.getElementById('props').innerHTML) : null

      /** Gets fired when the route changes.
      *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
      *	@param {string} event.url	The newly routed URL
      */
    }, _this.handleRoute = function (e) {
      /* global dataLayer */
      if (typeof dataLayer !== 'undefined') {
        console.log(e.url, 'dataLayer.push({ event: "page" })');
        dataLayer.push({ event: 'page' });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  App.prototype.render = function render() {
    var _this2 = this;

    var props = this.state.props;

    if (false) {
      fetch(('' + window.location).split('?')[0] + '/props.json').then(function (r) {
        return r.json();
      }).then(function (v) {
        _this2.setState({ props: v });
      });
    }
    if (!props || props.devel) return _ref;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      FullScreen,
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        Content,
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_1_preact_router__["a" /* Router */],
          { onChange: this.handleRoute },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__components_PoliticianDetail_PoliticianPage__["a" /* default */], _extends({ path: '/cs/seznam-politiku/:sub' }, props)),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_PoliticianList_PoliticianListPage__["a" /* default */], _extends({ path: '/cs/seznam-politiku/' }, props))
        )
      )
    );
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "3Tsa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
  };

  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */
  target.rebuild = function () {
    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
  };

  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */
  target.show = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY
      var e = { currentTarget: event.detail.target };
      this.showTooltip(e, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
    }
  };
};

var _constant = __webpack_require__("4ISx");

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatibale with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  var event = void 0;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, { detail: opts });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true);
    event.detail = opts;
  }

  window.dispatchEvent(event);
}; /**
    * Static methods for react-tooltip
    */

/***/ }),

/***/ "4ISx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "5wwt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var withDimensions = function withDimensions(Component) {
  var WithDimensions = function (_React$Component) {
    _inherits(WithDimensions, _React$Component);

    function WithDimensions() {
      _classCallCheck(this, WithDimensions);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    WithDimensions.prototype.render = function render() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Component, _extends({ dimensions: this.context.windowDimensions }, this.props));
    };

    return WithDimensions;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["default"].Component);

  WithDimensions.contextTypes = {
    windowDimensions: __WEBPACK_IMPORTED_MODULE_1_react__["default"].PropTypes.object
  };
  return WithDimensions;
};

/* harmony default export */ __webpack_exports__["a"] = (withDimensions);

/***/ }),

/***/ "6dK+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__("U9d9");

function isObjectObject(o) {
  return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor, prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};

/***/ }),

/***/ "928Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PieChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActivityChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visual__ = __webpack_require__("qyj1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("Uyz7");





var hasData = function hasData(data) {
  return data && !(data.green === 0 && data.red === 0);
};
var PieChart = function PieChart(_ref) {
  var data = _ref.data,
      gender = _ref.gender,
      title = _ref.title;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { marginBottom: -7 } },
      title
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__visual__["e" /* Chart */], {
      data: hasData(data) ? [['Podpora', 'Procenta'], ['Podporuje', data.green], [gender === 'M' ? 'Nepřítomen' : 'Nepřítomna', data.grey], ['Blokuje', data.red]] : [['', { role: 'annotation' }], ['', 0], ['', 100], ['', 0]],
      options: {
        pieHole: 0.7,
        colors: [__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].green, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].grey, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].red],
        width: 250,
        height: 140,
        pieSliceText: 'none',
        pieStartAngle: 180,
        chartArea: { left: 0, top: 20, right: 0, bottom: 20 },
        legend: hasData(data) ? {
          position: 'labeled',
          maxLines: 3,
          textStyle: { color: 'gray', fontSize: 12 }
        } : 'none',
        tooltip: { trigger: 'none' },
        sliceVisibilityThreshold: 0
      }
    })
  );
};

var LineChart = function LineChart(_ref2) {
  var _ref2$percent = _ref2.percent,
      percent = _ref2$percent === undefined ? -1 : _ref2$percent,
      color = _ref2.color;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { display: 'inline-block', width: 250 } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          width: 220,
          height: 10,
          backgroundColor: '#e6e6e6',
          display: 'inline-block'
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
        style: {
          width: percent >= 0 ? percent * 2.2 : 0,
          height: 10,
          backgroundColor: color
        }
      })
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      {
        style: {
          fontSize: '12px',
          paddingLeft: '5px',
          fontWeight: 'bold',
          position: 'relative',
          top: -1
        }
      },
      percent >= 0 && percent + '%'
    )
  );
};

var ActivityChart = function ActivityChart(_ref3) {
  var _ref3$data = _ref3.data,
      data = _ref3$data === undefined ? {} : _ref3$data,
      nospace = _ref3.nospace;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          marginBottom: nospace ? -15 : 10,
          marginLeft: nospace ? 0 : -30
        }
      },
      'Aktivita'
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          fontSize: 14,
          lineHeight: '1em',
          textAlign: 'left',
          width: 250,
          height: 140,
          marginTop: 23
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        {
          style: {
            marginBottom: 5
          }
        },
        'Pro p\u0159ijet\xED funk\u010Dn\xEDch z\xE1kon\u016F'
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(LineChart, { percent: data.green, color: '#8ec641' }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        {
          style: {
            marginBottom: 5,
            marginTop: 15
          }
        },
        'Blokov\xE1n\xED a oslabov\xE1n\xED z\xE1kon\u016F'
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(LineChart, { percent: data.red, color: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].red })
    )
  );
};

/***/ }),

/***/ "932e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getContentRect(node, types) {
  var calculations = {};

  if (types.indexOf('client') > -1) {
    calculations.client = {
      top: node.clientTop,
      left: node.clientLeft,
      width: node.clientWidth,
      height: node.clientHeight
    };
  }

  if (types.indexOf('offset') > -1) {
    calculations.offset = {
      top: node.offsetTop,
      left: node.offsetLeft,
      width: node.offsetWidth,
      height: node.offsetHeight
    };
  }

  if (types.indexOf('scroll') > -1) {
    calculations.scroll = {
      top: node.scrollTop,
      left: node.scrollLeft,
      width: node.scrollWidth,
      height: node.scrollHeight
    };
  }

  if (types.indexOf('bounds') > -1) {
    var rect = node.getBoundingClientRect();
    calculations.bounds = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  }

  if (types.indexOf('margin') > -1) {
    var styles = getComputedStyle(node);
    calculations.margin = {
      top: parseInt(styles.marginTop),
      right: parseInt(styles.marginRight),
      bottom: parseInt(styles.marginBottom),
      left: parseInt(styles.marginLeft)
    };
  }

  return calculations;
}

exports.default = getContentRect;
module.exports = exports['default'];

/***/ }),

/***/ "9qb7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "B8h0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var CellRadio = function CellRadio(_ref) {
  var text = _ref.text,
      value = _ref.value,
      checked = _ref.checked,
      onCheck = _ref.onCheck;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: checked ? 'cell-input active' : 'cell-input' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'label',
      { htmlFor: 'amountMonthly' + value },
      text
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'radio', id: 'uniform-amountMonthly' + value },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { className: checked ? 'checked' : '' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
          type: 'radio',
          id: 'amountMonthly' + value,
          name: 'amountMonthly',
          value: value,
          onChange: onCheck,
          checked: checked
        })
      )
    )
  );
};

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'anchor-100', id: 'zapojte-se' });

var _ref3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'header',
  { className: 'section-head' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'h2',
    null,
    'Pomozte prosadit z\xE1kony Rekonstrukce st\xE1tu'
  )
);

var _ref4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'h3',
  null,
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'b',
    null,
    'Chci p\u0159isp\u011Bt'
  ),
  ' na monitoring slib\u016F'
);

var _ref5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { className: 'cell-set last' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: 'cell ib' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'input-1' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'input' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
          type: 'text',
          name: 'otherAmountMonthly',
          id: 'otherAmountMonthly',
          className: 'text',
          placeholder: 'Jin\xE1 \u010D\xE1stka'
        })
      )
    ),
    ' ',
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'input-2' },
      'K\u010D'
    )
  )
);

var _ref6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { className: 'more-divider' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: 'btn-wrapper' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'button',
      {
        type: 'submit',
        id: 'send',
        name: 'send',
        className: 'btn',
        value: 'send'
      },
      'Darovat'
    )
  ),
  ' '
);

var _ref7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'h3',
  null,
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'b',
    null,
    'Chci v\u011Bd\u011Bt'
  ),
  ', kdo pro z\xE1kony hlasoval'
);

var _ref8 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { className: 'cell-set' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: 'cell' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'ib' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'input-1' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
          type: 'text',
          name: 'MMERGE3',
          id: 'MMERGE3',
          required: 'required',
          className: 'text',
          placeholder: 'Va\u0161e PS\u010C'
        })
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'input-2' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
          type: 'text',
          name: 'EMAIL',
          id: 'EMAIL',
          className: 'text',
          placeholder: 'V\xE1\u0161 e-mail'
        })
      )
    )
  )
);

var _ref9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'p',
  null,
  'P\u0159idejte se k dal\u0161\xEDm ',
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'b',
    null,
    '42 898'
  ),
  ' voli\u010D\u016F, kte\u0159\xED dostanou informace, kdo z politik\u016F dodr\u017E\xED sliby.'
);

var _ref10 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { className: 'more-divider' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: 'btn-wrapper' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'button',
      {
        type: 'submit',
        id: 'send',
        name: 'send',
        className: 'btn',
        value: 'send'
      },
      'Hl\xEDd\xE1m sliby!'
    )
  ),
  ' '
);

var _ref11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'h3',
  null,
  'Mapa str\xE1nek'
);

var _ref12 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'ul',
  { className: 'sitemap clearfix' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs' },
      'Rekonstrukce st\xE1tu'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/seznam-politiku' },
      'Politici'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/zapoj-se' },
      'Zapoj se'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/o-projektu' },
      'O n\xE1s'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/pro-media' },
      'Pro m\xE9dia'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/archiv-novinek' },
      'Aktuality'
    )
  )
);

var _ref13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'ul',
  null,
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/en' },
      'English'
    )
  )
);

var _ref14 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'h3',
  null,
  'Kontaktujte n\xE1s'
);

var _ref15 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'ul',
  null,
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: 'mailto:info@rekonstrukcestatu.cz' },
      'info@rekonstrukcestatu.cz'
    )
  )
);

var _ref16 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'h3',
  null,
  'Z\xE1kony'
);

var _ref17 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'ul',
  { className: 'clearfix' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/pruhledne-financovani-politickych-stran-a-volebnich-kampani' },
      '01 - Politika bez tajn\xFDch sponzor\u016F'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/elektronicka-majetkova-priznani-ke-dni-nastupu-do-funkce' },
      '02 - Majetkov\xE1 p\u0159izn\xE1n\xED politik\u016F'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/smlouvy-na-internetu' },
      '03 - Smlouvy na internetu'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/zruseni-anonymnich-akcii' },
      '04 - Zru\u0161en\xED anonymn\xEDch akci\xED'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/odborne-nominace-do-dozorcich-rad' },
      '05 - Konec trafik ve st\xE1tn\xEDch firm\xE1ch'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/odpolitizovani-statni-spravy' },
      '06 - Odpolitizov\xE1n\xED st\xE1tn\xED spr\xE1vy'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/statni-zastupitelstvi-bez-politickych-zasahu-do-vysetrovani' },
      '07 - Nez\xE1visl\xE9 vy\u0161et\u0159ov\xE1n\xED korupce'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/pruhledny-legislativni-proces' },
      '08 - Z\xE1kony bez p\u0159\xEDlepk\u016F'
    )
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: '/cs/rozsireni-kontrolnich-pravomoci-nku' },
      '09 - Roz\u0161\xED\u0159en\xED pravomoc\xED NK\xDA'
    )
  )
);

var _ref18 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { className: 'grid_24' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'p',
    { className: 'copy' },
    '\xA9 Rekonstrukce st\xE1tu 2017 - V\u0161echna pr\xE1va vyhrazena.'
  )
);

var Footer = function (_React$PureComponent) {
  _inherits(Footer, _React$PureComponent);

  function Footer() {
    _classCallCheck(this, Footer);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this));

    _this.state = { checked: 500 };
    _this.onCheck = _this.onCheck.bind(_this);
    return _this;
  }

  Footer.prototype.onCheck = function onCheck(evt) {
    this.setState({ checked: Number.parseInt(evt.target.value, 10) });
  };

  Footer.prototype.render = function render() {
    var _this2 = this;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { minWidth: 512 } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'block alt-2' },
        _ref2,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            className: 'row',
            style: { maxWidth: '100%', textAlign: 'center' }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { className: 'grid_24', style: { maxWidth: '100%', margin: 0 } },
            _ref3
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              className: 'grid_10 suffix_2 omega',
              style: { display: 'inline-block', textAlign: 'left' }
            },
            _ref4,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'form',
              {
                role: 'form',
                className: 'std form-donate',
                id: 'donateminform',
                method: 'get',
                encType: 'application/x-www-form-urlencoded',
                action: '/cs/zapoj-se#donate',
                noValidate: true,
                'data-error-element': 'label',
                'data-error-class': 'error'
              },
              ' ',
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { className: 'amount-radio-set' },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'div',
                  { className: 'cell-set ib hl' },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(CellRadio, {
                    checked: this.state.checked === 300,
                    onCheck: this.onCheck,
                    text: '300 K\u010D',
                    value: 300
                  }),
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(CellRadio, {
                    checked: this.state.checked === 500,
                    onCheck: this.onCheck,
                    text: '500 K\u010D',
                    value: 500
                  }),
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(CellRadio, {
                    checked: this.state.checked === 1000,
                    onCheck: this.onCheck,
                    text: '1000 K\u010D',
                    value: 1000
                  }),
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(CellRadio, {
                    checked: this.state.checked === 0,
                    onCheck: this.onCheck,
                    text: 'jin\xE1',
                    value: 0
                  })
                ),
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'div',
                  {
                    className: 'custom-amount',
                    style: {
                      display: this.state.checked === 0 ? 'block' : 'none'
                    }
                  },
                  _ref5
                )
              ),
              _ref6
            ),
            ' '
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              className: 'grid_12 alpha',
              style: { display: 'inline-block', textAlign: 'left' }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { className: 'newsletter alt', id: 'newsletter-form-wrapper-4' },
              _ref7,
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'form',
                {
                  role: 'form',
                  className: 'std form-newsletter',
                  id: 'newsletter',
                  method: 'post',
                  encType: 'application/x-www-form-urlencoded',
                  action: 'https://rekonstrukcestatu.us4.list-manage.com/subscribe/post?u=5d66fd73a6a5bb1624ddc06a0&id=c62bdfab00',
                  noValidate: true,
                  'data-error-element': 'label',
                  'data-error-class': 'error',
                  onSubmit: function onSubmit(evt) {
                    if (_this2.props.gaSubscribeId && typeof ga !== 'undefined') {
                      evt.preventDefault();
                      evt.persist();

                      ga('send', 'event', 'subscribe', 'newsletter', _this2.props.gaSubscribeId, {
                        hitCallback: function hitCallback() {
                          evt.target.submit();
                        }
                      });
                    }
                  }
                },
                _ref8,
                _ref9,
                _ref10
              )
            )
          )
        )
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'footer' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            className: 'row',
            style: { maxWidth: '100%', textAlign: 'center' }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              className: 'grid_7 suffix_1 omega',
              style: { display: 'inline-block', textAlign: 'left' }
            },
            _ref11,
            _ref12,
            _ref13,
            _ref14,
            _ref15
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              className: 'grid_7 suffix_1 omega',
              style: { display: 'inline-block', textAlign: 'left' }
            },
            _ref16,
            _ref17
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              className: 'grid_8 alpha',
              style: { display: 'inline-block', textAlign: 'left' }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('iframe', {
              src: '//www.facebook.com/plugins/likebox.php?href=https%3A%2F%2Fwww.facebook.com%2FRekonstrukceStatu&width=310&height=290&colorscheme=light&show_faces=true&header=true&stream=false&show_border=false&appId=263765047137953',
              scrolling: 'no',
              frameBorder: '0',
              style: {
                border: 'none',
                overflow: 'hidden',
                width: 310,
                height: 290
              },
              allowTransparency: 'true'
            })
          )
        )
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'footer-bar' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            style: { position: 'relative', maxWidth: 950, margin: '0 auto' }
          },
          _ref18,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'p',
            {
              style: {
                lineHeight: '58px',
                float: 'right',
                margin: 0,
                position: 'absolute',
                right: 15,
                top: 0
              }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'a',
              {
                href: 'https://blog.skorepa.info',
                style: { color: '#959595', textDecoration: 'none' }
              },
              'Jakub Sko\u0159epa'
            )
          )
        )
      )
    );
  };

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["default"].PureComponent);

/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),

/***/ "BQTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip__ = __webpack_require__("W+bh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PoliticianSummary__ = __webpack_require__("c9yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PoliticianChartTabs__ = __webpack_require__("Jh+o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PoliticianVotes__ = __webpack_require__("Iv0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("Uyz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout__ = __webpack_require__("KuMu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Chevron__ = __webpack_require__("isZO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Page__ = __webpack_require__("QYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout_Header__ = __webpack_require__("YXHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PoliticianList_PoliticianListIntro__ = __webpack_require__("am7w");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9__layout_Header__["a" /* default */], { hasTooltip: true });

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_6__layout__["a" /* Block */],
  null,
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10__PoliticianList_PoliticianListIntro__["b" /* Explainer */], null)
);

var _ref3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__layout__["d" /* MailBlock */], { gaId: 'detail-politika-top' });

var _ref4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_react_tooltip___default.a, { multiline: true, effect: 'solid', 'class': 'tooltip' });

var PoliticianPage = function (_Component) {
  _inherits(PoliticianPage, _Component);

  function PoliticianPage(props) {
    _classCallCheck(this, PoliticianPage);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = { visibleRest: 0 // 0 = all
    };return _this;
  }

  PoliticianPage.prototype.getVotes = function getVotes(rest) {
    var _this2 = this;

    if (rest === 0) {
      return Array(9).fill(0).map(function (e, i) {
        return _this2.getVotes(i + 1);
      }).reduce(function (a, b) {
        return a.concat(b);
      });
    }
    var o = this.props['rest' + rest];
    return o ? o.votes.map(function (v, i) {
      return _extends({}, v, {
        restName: o.restName,
        i: rest + '.' + i
      });
    }) : [];
  };

  PoliticianPage.prototype.render = function render() {
    var _this3 = this;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { minWidth: 512 } },
      _ref,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_6__layout__["a" /* Block */],
        { style: { padding: '40px 0 0 0' } },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__PoliticianSummary__["a" /* default */], _extends({}, this.props, {
          party: this.props.parties[this.props.person.party] || {}
        })),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__PoliticianChartTabs__["a" /* default */], _extends({}, this.props, {
          visibleRest: this.state.visibleRest,
          setVisibleRest: function setVisibleRest(n) {
            return _this3.setState({ visibleRest: n });
          }
        }))
      ),
      _ref2,
      _ref3,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* colors */].grey,
            paddingBottom: 40,
            transition: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* transition */]
          }
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__Chevron__["a" /* default */], { color: __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* colors */].yellow }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__layout__["a" /* Block */],
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__PoliticianVotes__["a" /* default */], {
            small: this.props.small,
            votes: this.getVotes(this.state.visibleRest),
            person: this.props.person
          })
        )
      ),
      _ref4
    );
  };

  return PoliticianPage;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var PoliticianPageWithDimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__layout__["e" /* withDimensions */])(function (props) {
  var width = props.dimensions.width;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(PoliticianPage, _extends({}, props, { small: width < 930, dimensions: undefined }));
});

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_8__Page__["a" /* default */],
    { hostname: props.hostname },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(PoliticianPageWithDimensions, props)
  );
});

/***/ }),

/***/ "C4qV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map != 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: {} };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) ctx = null;

            for (var i = 0, list = this.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties(anonymous.prototype, prototypeAccessors);

        return anonymous;
    }();
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window != 'undefined' && typeof document != 'undefined' && window.document === document;

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        return requestAnimationFrame;
    }

    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Detect whether running in IE 11 (facepalm).
var isIE11 = typeof navigator != 'undefined' && /Trident\/.*rv:11/.test(navigator.userAgent);

// MutationObserver should not be used if running in Internet Explorer 11 as it's
// implementation is unreliable. Example: https://jsfiddle.net/x2r3jpuz/2/
//
// It's a real bummer that there is no other way to check for this issue but to
// use the UA information.
var mutationObserverSupported = typeof MutationObserver != 'undefined' && !isIE11;

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;

    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;

    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;

    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) {
        return observer.broadcastActive();
    });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
    var propertyName = ref.propertyName;

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */
ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = Array.prototype.slice.call(arguments, 1);

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement != 'undefined') {
        return function (target) {
            return target instanceof SVGGraphicsElement;
        };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof SVGElement && typeof target.getBBox === 'function';
    };
}();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly != 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;

    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;

    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    /**
     * Reference to the observed element.
     *
     * @type {Element}
     */
    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function ResizeObserverSPI(callback, controller, callbackCtx) {
    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];

    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();

    /**
     * Reference to the callback function.
     *
     * @private {ResizeObserverCallback}
     */
    this.callback_ = callback;

    /**
     * Reference to the associated ResizeObserverController.
     *
     * @private {ResizeObserverController}
     */
    this.controller_ = controller;

    /**
     * Public ResizeObserver instance which will be passed to the callback
     * function and used as a value of it's "this" binding.
     *
     * @private {ResizeObserver}
     */
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
    var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap != 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = function ResizeObserver$1(callback) {
    if (!(this instanceof ResizeObserver$1)) {
        throw new TypeError('Cannot call a class as a function');
    }

    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof ResizeObserver != 'undefined') {
        // eslint-disable-next-line no-undef
        return ResizeObserver;
    }

    return ResizeObserver$1;
}();

/* harmony default export */ __webpack_exports__["default"] = (index);

/***/ }),

/***/ "DVzP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aa4c72eb5d8bc3ff6d5ea7bee275467c.png";

/***/ }),

/***/ "DsvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");



var Select = function Select(_ref) {
  var list = _ref.list,
      value = _ref.value,
      _onChange = _ref.onChange;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        width: 326,
        paddingLeft: 20,
        paddingBottom: 20,
        display: 'inline-block',
        textAlign: 'left'
      }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'selector' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        (list.filter(function (e) {
          return e.key === value;
        })[0] || { value: '' }).value
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'select',
        { value: value, onChange: function onChange(e) {
            return _onChange(e.target.value);
          } },
        list.map(function (e) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'option',
            {
              key: e.key,
              value: e.key,
              disabled: e.disabled,
              style: e.disabled ? {
                fontStyle: 'italic',
                fontSize: 15
              } : {}
            },
            e.value
          );
        })
      )
    )
  );
};
/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),

/***/ "EmMn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e83ba7bd1061ff4c7d99f7a4cc829420.png";

/***/ }),

/***/ "F6cP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e9546ed0f8b003a34d85eb5475cd1b69.png";

/***/ }),

/***/ "FIjd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("Uyz7");




var Support = function Support(_ref) {
  var support = _ref.support,
      margin = _ref.margin,
      administration = _ref.administration,
      small = _ref.small;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { marginTop: '15px', display: 'inline-block' } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          fontSize: small ? '16px' : '22px',
          height: small ? 40 : 50,
          fontWeight: 600,
          lineHeight: '20px',
          display: 'inline-block',
          color: '#fff',
          padding: small ? '12px 15px 5px 15px' : '17px 20px 10px 20px',
          marginBottom: 10,
          marginRight: margin ? 50 : 0,
          backgroundColor: administration ? __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* colors */].darkGrey : __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* supportColors */][support] || __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* supportColors */].nehlasuje
        },
        'data-tip': administration ? __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* administrationDisclaimer */] : '',
        'data-class': 'gt930 tooltip'
      },
      administration ? 'člen vlády' : support
    )
  );
};
/* harmony default export */ __webpack_exports__["a"] = (Support);

/***/ }),

/***/ "GV47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PoliticianListIntro__ = __webpack_require__("am7w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PoliticianListFilter__ = __webpack_require__("MMx/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PoliticianList__ = __webpack_require__("mzXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("Uyz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page__ = __webpack_require__("QYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_Header__ = __webpack_require__("YXHF");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var defaultState = {
  type: '',
  party: '',
  region: '',
  name: ''
};

var Separator = function Separator() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          position: 'absolute',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fff',
          padding: 10,
          color: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* colors */].middleGrey
        }
      },
      'Sen\xE1to\u0159i'
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
      style: { width: '100%', height: 1, backgroundColor: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* colors */].middleGrey }
    })
  );
};

var fullname = function fullname(name) {
  return name.firstname + ' ' + name.surname;
};

var hideIf = function hideIf(fnc) {
  return function (p) {
    return fnc(p) ? _extends({}, p, { hidden: true }) : p;
  };
};

var shouldBeDisplayed = function shouldBeDisplayed(state, p) {
  if (state.type && p.person.type !== state.type) return false;
  if (state.party && p.person.party !== state.party) return false;
  if (state.region && !p.person.regions.includes(state.region)) return false;
  if (state.name && !new RegExp(state.name.toLowerCase()).exec(fullname(p.person.name).toLowerCase())) return false;
  return true;
};

var mapHidden = function mapHidden(state, list) {
  return list.map(hideIf(function (p) {
    return !shouldBeDisplayed(state, p);
  }));
};
var filterHidden = function filterHidden(state, list) {
  return list.filter(function (p) {
    return shouldBeDisplayed(state, p);
  });
};

/* global window, $ */

var toQueryString = function toQueryString(obj) {
  return Object.keys(obj).filter(function (key) {
    return obj[key];
  }).map(function (key) {
    return key + '=' + obj[key];
  }).reduce(function (a, b) {
    return a ? a + '&' + b : b;
  }, '');
};
var fromQueryString = function fromQueryString(str) {
  var ret = {};
  decodeURIComponent(str).split('&').map(function (s) {
    return s.split('=');
  }).forEach(function (_ref) {
    var key = _ref[0],
        value = _ref[1];

    ret[key] = value;
  });
  return ret;
};

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__layout_Header__["a" /* default */], null);

var _ref3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__PoliticianListIntro__["a" /* default */], null);

var _ref4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Separator, null);

var PoliticianListPage = function (_Component) {
  _inherits(PoliticianListPage, _Component);

  function PoliticianListPage(props) {
    _classCallCheck(this, PoliticianListPage);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = defaultState;
    _this.parties = _this.props.list.map(function (p) {
      return p.person.party;
    }).filter(function (value, index, self) {
      return self.indexOf(value) === index;
    });
    _this.setFilter = function (key) {
      return function (val) {
        console.log('setFilter', key, val);
        var state = void 0;
        if (key === 'name') {
          state = _extends({}, defaultState, {
            name: val
          });
        } else {
          var _extends2;

          state = _extends({}, _this.state, (_extends2 = {}, _extends2[key] = val, _extends2.name = '', _extends2));
        }
        _this.setState(state);
        if (typeof window !== 'undefined' && window.history) {
          var url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + toQueryString(state);
          window.history.replaceState(state, $('title').text(), url);
        }
      };
    };
    return _this;
  }

  PoliticianListPage.prototype.componentDidMount = function componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState(window.history && window.history.state || _extends({}, defaultState, fromQueryString(window.location.href.split('?')[1])));
  };

  PoliticianListPage.prototype.render = function render() {
    console.log('Rendering PoliticianListPage');
    var list = mapHidden(this.state, this.props.list);

    var surnamesorter = function surnamesorter(a, b) {
      return a.person.name.surname.localeCompare(b.person.name.surname);
    };

    var listMOP = list.filter(function (p) {
      return p.person.type === 'MOP';
    }).sort(surnamesorter);
    var listSenate = list.filter(function (p) {
      return p.person.type !== 'MOP';
    }).sort(surnamesorter);

    var hasMOP = listMOP.some(function (p) {
      return !p.hidden;
    });
    var hasSenator = listSenate.some(function (p) {
      return !p.hidden;
    });
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_5__Page__["a" /* default */],
      { hostname: this.props.hostname },
      _ref2,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { minWidth: 512 } },
        _ref3,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__PoliticianListFilter__["a" /* default */], {
          setFilter: this.setFilter,
          filters: this.state,
          list: this.props.list,
          filterFunc: filterHidden,
          parties: this.parties
        }),
        hasMOP ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__PoliticianList__["a" /* default */], { list: listMOP, parties: this.props.parties }) : null,
        hasMOP && hasSenator ? _ref4 : null,
        hasSenator ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__PoliticianList__["a" /* default */], { list: listSenate, parties: this.props.parties }) : null,
        !hasMOP && !hasSenator ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__PoliticianList__["a" /* default */], { list: [], parties: this.props.parties }) : null
      )
    );
  };

  return PoliticianListPage;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PoliticianListPage);

/***/ }),

/***/ "Iq6+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTypes;
var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];

function getTypes(props) {
  var allowedTypes = [];
  types.forEach(function (type) {
    if (props[type]) {
      allowedTypes.push(type);
    }
  });
  return allowedTypes;
}
module.exports = exports['default'];

/***/ }),

/***/ "Iv0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_padstart__ = __webpack_require__("aEuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_padstart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_padstart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("Uyz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svgs__ = __webpack_require__("Jv3S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoverable__ = __webpack_require__("ieDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TooltipBubble__ = __webpack_require__("KIZG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visual__ = __webpack_require__("qyj1");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var positivityToColor = function positivityToColor(val) {
  return val === 1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].green : val === -1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].red : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey;
};

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["b" /* PanacekWhite */], null);

var Positivity = function Positivity(_ref) {
  var val = _ref.val;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        backgroundColor: positivityToColor(val),
        display: 'inline-block',
        padding: '5px 25px 5px 15px',
        color: 'white',
        position: 'relative',
        height: 36
      }
    },
    'STANOVISKO ',
    _ref2,
    ':',
    ' ',
    val === 1 ? 'POZITIVNÍ' : val === -1 ? 'NEGATIVNÍ' : 'NEUTRÁLNÍ',
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
      style: {
        display: 'inline-block',
        borderRight: '15px solid ' + __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].grey,
        borderTop: '18px solid transparent',
        borderBottom: '18px solid transparent',
        width: '20px',
        height: '100%',
        position: 'absolute',
        right: 0,
        top: 0
      }
    })
  );
};

var Paragraph = function Paragraph() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$fullness = _ref3.fullness,
      fullness = _ref3$fullness === undefined ? 1 : _ref3$fullness,
      _ref3$color = _ref3.color,
      color = _ref3$color === undefined ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].green : _ref3$color;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { position: 'relative', height: 110 } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          position: 'absolute',
          top: 20,
          left: '50%',
          transform: 'translateX(-50%)'
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["c" /* Paragraph */], { portion: 1 - fullness }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["c" /* Paragraph */], { color: color, offset: 1 - fullness, portion: fullness })
    )
  );
};

var _ref5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_5__TooltipBubble__["a" /* default */],
  { width: 250, offset: 0.22 },
  'V\xC1HA UKAZUJE JAK\xDD VLIV M\u011ALO DAN\xC9 HLASOV\xC1N\xCD NA OSUD Z\xC1KONA'
);

var VoteLeftColumn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__hoverable__["a" /* default */])(function (_ref4) {
  var data = _ref4.data,
      hover = _ref4.hover,
      onMouseEnter = _ref4.onMouseEnter,
      onMouseLeave = _ref4.onMouseLeave;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        height: '100%',
        position: 'relative',
        display: 'table'
      }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          lineHeight: '1em',
          fontStyle: 'italic',
          textDecoration: 'underline',
          display: 'table-row',
          height: '33%'
        }
      },
      data.restName
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { display: 'table-row', height: '33%' } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Paragraph, {
        fullness: data.weight,
        color: positivityToColor(data.positivity)
      })
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        style: { display: 'table-row', height: '33%', paddingBottom: 10 }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { display: 'table-cell', verticalAlign: 'bottom' } },
        hover && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { style: { position: 'relative' } },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { style: { position: 'absolute', left: '50%' } },
            _ref5
          )
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            style: {
              fontSize: '1.5em',
              lineHeight: '1em',
              textAlign: 'center'
            }
          },
          data.weight.toFixed(2)
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { style: { textAlign: 'center', marginTop: -3 } },
          'v\xE1ha'
        )
      )
    )
  );
});

var VoteMiddleColumn = function VoteMiddleColumn(_ref6) {
  var data = _ref6.data;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { paddingRight: 40, paddingLeft: 15 } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { paddingLeft: 25 } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Positivity, { val: data.positivity })
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          fontSize: '1.4em',
          lineHeight: '1.2em',
          textTransform: 'uppercase',
          minHeight: 100,
          paddingTop: 20,
          paddingBottom: 40
        }
      },
      data.description
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: data.standpoint ? {} : { display: 'none' } },
      ' ',
      'NA\u0160E STANOVISKO PODROBN\u011A: ',
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'i',
        null,
        data.standpoint
      )
    )
  );
};

var voteToColor = function voteToColor(data) {
  if (data.vote === '@') return 'gray';else if (data.positivity === 0) return 'gray';else if (data.vote === 'ANO') return data.positivity === 1 ? 'green' : 'red';else return data.positivity !== 1 ? 'green' : 'red';
};

var Result = function Result(_ref7) {
  var data = _ref7.data,
      type = _ref7.type,
      _ref7$style = _ref7.style,
      style = _ref7$style === undefined ? {} : _ref7$style;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'a',
    {
      target: 'blank',
      href: type === 'MOP' ? 'https://www.psp.cz/sqw/hlasy.sqw?g=' + data.link : data.link,
      style: _extends({
        color: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].greyOnGrey
      }, style)
    },
    data.result.slice(0, 1).toUpperCase(),
    data.result.slice(1),
    ': ',
    data.date
  );
};

var _ref9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["d" /* ThumbsUp */], null);

var _ref10 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["e" /* ThumbsDown */], null);

var VoteThumb = function VoteThumb(_ref8) {
  var person = _ref8.person,
      data = _ref8.data,
      style = _ref8.style;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: _extends({}, style, {
        color: {
          gray: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].greyOnGrey,
          green: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].green,
          red: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].red
        }[voteToColor(data)],
        fontSize: '2em'
      })
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          display: 'table-cell',
          verticalAlign: 'middle',
          paddingBottom: 30
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            display: 'inline-block',
            paddingRight: voteToColor(data) === 'gray' ? 0 : 10
          }
        },
        {
          ANO: 'pro',
          NE: 'proti',
          'zdržel se': person.gender === 'M' ? 'zdržel se' : 'zdržela se',
          '@': person.gender === 'M' ? 'nepřítomen' : 'nepřítomna'
        }[data.vote] || 'chyba'
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { display: 'inline-block', transform: 'translateY(5px)' } },
        {
          gray: '',
          green: _ref9,
          red: _ref10
        }[voteToColor(data)]
      )
    )
  );
};

var VoteHead = function VoteHead(_ref11) {
  var person = _ref11.person,
      data = _ref11.data,
      style = _ref11.style;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: style },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      person.name.firstname + ' '
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      person.name.surname + ' '
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      function () {
        if (data.vote === '@') return person.gender === 'M' ? 'byl:' : 'byla:';
        return person.gender === 'M' ? 'hlasoval:' : 'hlasovala:';
      }()
    )
  );
};
var VoteRightColumn = function VoteRightColumn(_ref12) {
  var person = _ref12.person,
      data = _ref12.data;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        textAlign: 'center',
        height: '100%',
        display: 'table',
        width: '100%'
      }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VoteHead, {
      style: {
        marginTop: 15,
        marginBottom: 30,
        display: 'table-row',
        height: '33%'
      },
      person: person,
      data: data
    }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VoteThumb, {
      person: person,
      data: data,
      style: {
        display: 'table-row',
        height: '33%'
      }
    }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          display: 'table-row',
          height: '33%'
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Result, {
        data: data,
        type: person.type,
        style: {
          verticalAlign: 'bottom',
          paddingBottom: 30,
          display: 'table-cell'
        }
      })
    )
  );
};

var Column = function Column(_ref13) {
  var children = _ref13.children,
      width = _ref13.width,
      borderLeft = _ref13.borderLeft,
      _ref13$style = _ref13.style,
      style = _ref13$style === undefined ? {} : _ref13$style;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: _extends({
        width: width,
        display: width && 'table-cell',
        borderLeft: borderLeft,
        borderTop: '1px solid ' + __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey,
        borderRight: '1px solid ' + __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey,
        borderBottom: '1px solid ' + __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey,
        verticalAlign: 'top',
        padding: 10,
        height: 'inherit',
        minHeight: 240
      }, style)
    },
    children
  );
};

var Vote = function Vote(_ref14) {
  var data = _ref14.data,
      person = _ref14.person,
      small = _ref14.small;
  return small ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      Column,
      { width: undefined, style: { borderBottom: null } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VoteMiddleColumn, { data: data })
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { display: 'table', marginBottom: 15, width: '100%' } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { display: 'table-row', height: 1 } },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          Column,
          {
            width: '30%',
            borderLeft: '1px solid ' + (data.positivity === 1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].green : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].red),
            style: { position: 'relative', padding: 0 }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              style: {
                display: 'inline-block',
                position: 'absolute',
                paddingLeft: 70,
                width: '100%',
                height: '100%',
                verticalAlign: 'middle'
              }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              {
                style: {
                  display: 'inline-block',
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  paddingRight: 10
                }
              },
              data.restName
            )
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { style: { display: 'inline-block', padding: 10 } },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Paragraph, {
              fullness: data.weight,
              color: positivityToColor(data.positivity)
            }),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { style: { display: 'table-cell', verticalAlign: 'bottom' } },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                {
                  style: {
                    fontSize: '1.5em',
                    lineHeight: '1em',
                    textAlign: 'center'
                  }
                },
                data.weight.toFixed(2)
              ),
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { style: { textAlign: 'center', marginTop: -3 } },
                'v\xE1ha'
              )
            )
          )
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          Column,
          {
            width: '40%',
            style: {
              textAlign: 'center',
              verticalAlign: 'middle',
              paddingTop: 30
            }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VoteHead, { data: data, person: person }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VoteThumb, {
            data: data,
            person: person,
            style: { display: 'inline-block' }
          })
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          Column,
          {
            width: '30%',
            style: { textAlign: 'center', verticalAlign: 'middle' }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Result, { data: data, type: person.type })
        )
      )
    )
  ) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { display: 'table', minHeight: 240, marginBottom: 15 } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { display: 'table-row', height: 1 } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        Column,
        {
          width: 110,
          borderLeft: '1px solid ' + (data.positivity === 1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].green : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].red)
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VoteLeftColumn, { data: data })
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        Column,
        { width: 590, height: 500 },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VoteMiddleColumn, { data: data })
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        Column,
        { width: 250 },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(VoteRightColumn, { data: data, person: person })
      )
    )
  );
};

var NoVoteYet = function NoVoteYet(_ref15) {
  var person = _ref15.person;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        fontSize: '1.2em',
        textAlign: 'center',
        color: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].darkGrey
      }
    },
    function () {
      if (person.type === 'MOP') {
        if (person.gender === 'M') return 'Poslanec';
        return 'Poslankyně';
      }
      if (person.gender === 'M') return 'Senátor';
      return 'Senátorka';
    }(),
    ' ',
    'nem\u011Bl',
    person.gender === 'M' ? '' : 'a',
    ' mand\xE1t b\u011Bhem \u017E\xE1dn\xE9ho hlasov\xE1n\xED o tomto RESTu'
  );
};

var byDate = function byDate(a, b) {
  var map = function map(date) {
    return date.split('.').reverse().map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_padstart___default()(s, 4, '0');
    }).join('');
  };
  if (map(a.date) < map(b.date)) return 1;
  return -1;
};

var NoKeyVotes = function NoKeyVotes() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        fontSize: '1.2em',
        textAlign: 'center',
        color: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].darkGrey
      }
    },
    'Zat\xEDm neprob\u011Bhla \u017E\xE1dn\xE1 kl\xED\u010Dov\xE1 hlasov\xE1n\xED.'
  );
};

var _ref16 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'h3',
  null,
  'Hlasov\xE1n\xED podrobn\u011B'
);

var _ref17 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(NoKeyVotes, null);

var PoliticianVotes = function (_Component) {
  _inherits(PoliticianVotes, _Component);

  function PoliticianVotes() {
    _classCallCheck(this, PoliticianVotes);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = { importantOnly: true };
    _this.handleImportantOnly = _this.handleImportantOnly.bind(_this);
    return _this;
  }

  PoliticianVotes.prototype.handleImportantOnly = function handleImportantOnly(checked) {
    this.setState({ importantOnly: checked });
  };

  PoliticianVotes.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        votes = _props.votes,
        person = _props.person,
        small = _props.small;

    var filteredVotes = votes.sort(byDate).filter(function (vote) {
      return vote.weight > 0.3 || !_this2.state.importantOnly;
    });
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { textAlign: 'center' } },
        _ref16
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_6__visual__["b" /* Checkbox */],
        {
          id: 'important-votes-only',
          checked: this.state.importantOnly,
          onChange: this.handleImportantOnly
        },
        'Pouze kl\xED\u010Dov\xE1 hlasov\xE1n\xED'
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        null,
        votes.length <= 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(NoVoteYet, { person: person }) : filteredVotes.length > 0 ? filteredVotes.map(function (vote) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Vote, { small: small, key: vote.i, data: vote, person: person });
        }) : _ref17
      )
    );
  };

  return PoliticianVotes;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PoliticianVotes);

/***/ }),

/***/ "Jh+o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("X5xa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("Uyz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svgs__ = __webpack_require__("Jv3S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TooltipBubble__ = __webpack_require__("KIZG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoverDisabler__ = __webpack_require__("xkb/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Charts__ = __webpack_require__("928Z");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  text-align: center;\n  padding: 7px 0;\n  background-color: ', ';\n  color: ', ';\n  opacity ', ';\n'], ['\n  cursor: pointer;\n  text-align: center;\n  padding: 7px 0;\n  background-color: ', ';\n  color: ', ';\n  opacity ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  border-top: 11px solid ', ';\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  width: 20px;\n  position: absolute;\n  left: 50%;\n  margin-left: -10px;\n  opacity: ', ';\n'], ['\n  border-top: 11px solid ', ';\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  width: 20px;\n  position: absolute;\n  left: 50%;\n  margin-left: -10px;\n  opacity: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  display: inline-block;\n  padding: 0 4px;\n  margin: 0 0 15px 0;\n\n  font-size: 16px;\n  font-weight: bold;\n  position: relative;\n  ', ' {\n    pointer-events: none;\n    transition: opacity 0.2s ease-in-out;\n    opacity: 0;\n    left: 50%;\n    position: absolute;\n  }\n\n  :hover ', ' {\n    opacity: ', ';\n  }\n  :hover ', ' {\n    border-top: 11px solid black;\n  }\n  :hover ', ' {\n    background-color: black;\n    color: white;\n  }\n'], ['\n  width: ', ';\n  display: inline-block;\n  padding: 0 4px;\n  margin: 0 0 15px 0;\n\n  font-size: 16px;\n  font-weight: bold;\n  position: relative;\n  ', ' {\n    pointer-events: none;\n    transition: opacity 0.2s ease-in-out;\n    opacity: 0;\n    left: 50%;\n    position: absolute;\n  }\n\n  :hover ', ' {\n    opacity: ', ';\n  }\n  :hover ', ' {\n    border-top: 11px solid black;\n  }\n  :hover ', ' {\n    background-color: black;\n    color: white;\n  }\n']);



function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }










var fullfillmentToCategory = function fullfillmentToCategory(f) {
  if (!f || f === '0') return 'nopledge';
  var fullfillment = typeof f === 'string' && f.toLowerCase();
  if (Number.isFinite(Number(fullfillment))) return 'fail';
  return {
    '': 'nopledge',
    'plní slib': 'ok',
    nepřítomen: 'notpresent',
    nehlasoval: 'didnotvote',
    nehlasovalo: 'novoteyet',
    slíbil: 'novotepledge',
    schváleno: 'ratifiedPreMandate',
    nehodnoceno: 'noVoteRatifed'
  }[fullfillment] || 'failtext';

  /*
   & = panáček
   * měl mandát - grafy ano
      *
        * grey  nezavázal se ""
        * red   porušil slib number
        * green drží slib "plní slib"
        * grey  Nezúčastnil se žádného hodnoceného hlasování //  "nepřítomen"
     * neměl mandát - hodnotíme, grafy ne
      *
        * grey  Neměl příležitost hlasovat (v rámci svého madnátu)  "nehlasoval"
        * green Příslíbil podporu &, ale zatím neměl příležitost hlasovat. "slíbil"
        * grey  Schváleno před začátkem tohoto mandátu "schváleno"
        * grey  Nedošlo k žádnému hodnotitelnému hlasování "nehodnoceno"
  */
};

var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["f" /* PanacekNoSupport */], null);

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["g" /* PanacekBlack */], null);

var _ref3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["g" /* PanacekBlack */], null);

var fullfillmentToText = function fullfillmentToText(fullfillment, gender) {
  var panacek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    fail: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      fullfillment,
      'x poru\u0161il',
      gender === 'M' ? '' : 'a',
      ' slib',
      panacek && _ref
    ),
    nopledge: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      'Nesl\xEDbil',
      gender === 'M' ? '' : 'a',
      ' podporu'
    ),
    ok: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      'Dr\u017E\xED slib ',
      panacek && _ref2
    ),
    notpresent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      'Nez\xFA\u010Dastnil',
      gender === 'M' ? '' : 'a',
      ' se \u017E\xE1dn\xE9ho hodnocen\xE9ho hlasov\xE1n\xED'
    ),

    didnotvote: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      'Nem\u011Bl',
      gender === 'M' ? '' : 'a',
      ' p\u0159\xEDle\u017Eitost hlasovat.'
    ),
    novoteyet: 'O tomto restu se ještě nehlasovalo.',
    novotepledge: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      'P\u0159isl\xEDbil',
      gender === 'M' ? '' : 'a',
      ' podporu',
      panacek && ' ',
      panacek && _ref3,
      ', ale zat\xEDm nem\u011Bl',
      gender === 'M' ? '' : 'a',
      ' ',
      'p\u0159\xEDle\u017Eitost hlasovat.'
    ),
    ratifiedPreMandate: 'Schváleno před začátkem mandátu',
    noVoteRatifed: 'Nedošlo k žádnému hodnotitelnému hlasování'
  }[fullfillmentToCategory(fullfillment)];
};

var fullfillmentToColor = function fullfillmentToColor(fullfillment) {
  return {
    fail: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].red,
    nopledge: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey,
    ok: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].green,
    notpresent: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey,
    didnotvote: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey,
    nehlasovalo: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey,
    novotepledge: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].green,
    ratifiedPreMandate: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey,
    noVoteRatifed: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].middleGrey
  }[fullfillmentToCategory(fullfillment)];
};

var RestTabInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject, function (props) {
  return props.isSelected ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].darkGrey : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].grey;
}, function (props) {
  return props.isSelected && 'white';
}, function (props) {
  return props.opacity;
});

var RestTabTriangle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject2, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].darkGrey, function (props) {
  return props.opacity;
});

var RestTabOuter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hoverDisabler__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject3, function (props) {
  return props.small ? '20%' : '10%';
}, __WEBPACK_IMPORTED_MODULE_4__TooltipBubble__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__TooltipBubble__["a" /* default */], function (props) {
  return props.hoverDisable ? 0 : 1;
}, RestTabTriangle, RestTabInner));

var _ref4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(RestTabTriangle, null);

var RestTab = function RestTab(props) {
  var no = props.no,
      isSelected = props.isSelected,
      comment = props.comment,
      name = props.name,
      gender = props.gender,
      small = props.small;

  var tabState = ('' + props.tabState).toLowerCase();

  var opacity = {
    novote: 0.5,
    preMandate: 0.5,
    novotepledge: 0.5
  }[fullfillmentToCategory(tabState)] || 1;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    RestTabOuter,
    { small: small },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_4__TooltipBubble__["a" /* default */],
      {
        width: 450,
        offset: small ? {
          0: 0.1,
          1: 0.305,
          3: 0.69,
          4: 0.9,
          5: 0.1,
          6: 0.305,
          8: 0.69,
          9: 0.9
        }[no] || 0.5 : {
          0: 0.1,
          1: 0.305,
          8: 0.69,
          9: 0.9
        }[no] || 0.5
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { fontSize: '1em' } },
        no ? name : 'Všechny zákony'
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { color: fullfillmentToColor(tabState) } },
        fullfillmentToText(tabState, gender, false)
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { fontSize: '.85em', lineHeight: '1.5em' } },
        comment || ''
      )
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      RestTabInner,
      {
        onClick: props.onClick,
        isSelected: isSelected,
        opacity: opacity
      },
      no ? 'REST ' + no : 'VŠE'
    ),
    no ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
      style: {
        position: 'absolute',
        right: 4,
        top: 0,
        height: '100%',
        width: 7,
        backgroundColor: fullfillmentToColor(tabState),
        opacity: opacity
      }
    }) : null,
    !isSelected || small ? null : _ref4
  );
};

var RestTabs = function RestTabs() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      gender = _ref5.gender,
      _ref5$onTabSwitch = _ref5.onTabSwitch,
      onTabSwitch = _ref5$onTabSwitch === undefined ? function () {
    return undefined;
  } : _ref5$onTabSwitch,
      selectedTab = _ref5.selectedTab,
      _ref5$tabStates = _ref5.tabStates,
      tabStates = _ref5$tabStates === undefined ? [] : _ref5$tabStates,
      _ref5$comments = _ref5.comments,
      comments = _ref5$comments === undefined ? [] : _ref5$comments,
      _ref5$names = _ref5.names,
      names = _ref5$names === undefined ? [] : _ref5$names,
      _ref5$small = _ref5.small,
      small = _ref5$small === undefined ? false : _ref5$small;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { textAlign: 'center', transition: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* transition */] } },
    Array(10).fill(0).map(function (v, i) {
      return i;
    }).map(function (i) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(RestTab, {
        small: small,
        key: i,
        no: i,
        onClick: function onClick() {
          return onTabSwitch(i);
        },
        isSelected: selectedTab === i,
        tabState: tabStates[i],
        comment: comments[i],
        name: names[i - 1],
        gender: gender
      });
    })
  );
};

var HCenter = function HCenter(_ref6) {
  var children = _ref6.children;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: { position: 'absolute', left: '50%', transform: 'translateX(-50%)' }
    },
    children
  );
};

var ArrowLeftColumn = function ArrowLeftColumn(_ref7) {
  var person = _ref7.person,
      rotate = _ref7.rotate;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        display: 'inline-block',
        verticalAlign: 'middle',
        color: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].grey,
        position: 'relative',
        marginTop: 40,
        transform: rotate ? 'translate(-5px, 15px)' : 'translate(-15px, 0px)',
        transition: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* transition */]
      }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { position: 'absolute', left: 0 } },
      person.type === 'MOP' ? '50%' : '75%'
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { width: 100, height: 85, position: 'relative' } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'svg',
        {
          width: '272px',
          height: '226px',
          viewBox: '0 0 136 113',
          style: {
            position: 'absolute',
            left: -86,
            top: -70,
            transform: rotate ? 'rotate(-30deg)' : undefined,
            transition: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* transition */]
          }
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].grey,
          d: 'M65.03,53.71l9.37,1.46c-1.03,2.4-1.33,4.28-2.15,5.44 c6.23-2.88,13.28-6.91,20.31-10.93l-18.4-13.02c-0.3,1.86,0.55,4.53,0.78,7.1c-5.7-0.24-26.91,0.92-29,13.36l-2.32,13.8 c0.31,1.99-0.11,4.52,0.19,6.51C44.66,72.38,50.71,51.47,65.03,53.71z'
        })
      )
    )
  );
};

var ArrowRightColumn = function ArrowRightColumn(_ref8) {
  var person = _ref8.person,
      rotate = _ref8.rotate;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        display: 'inline-block',
        verticalAlign: 'middle',
        color: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].grey,
        position: 'relative',
        marginTop: 40,
        transform: rotate ? 'translate(5px, 15px)' : 'translate(15px, 0px)',
        transition: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* transition */]
      }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { position: 'absolute', right: 0 } },
      person.type === 'MOP' ? '50%' : '25%'
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          width: 100,
          height: 85,
          position: 'relative',
          transform: rotate ? 'rotate(30deg)' : undefined,
          transition: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* transition */]
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'svg',
        {
          width: '272px',
          height: '226px',
          viewBox: '0 0 136 113',
          style: { position: 'absolute', left: -86, top: -70 }
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].grey,
          d: 'm 71.13,53.71 -9.37,1.46 c 1.03,2.4 1.33,4.28 2.15,5.44 C 57.68,57.73 50.63,53.7 43.6,49.68 L 62,36.66 c 0.3,1.86 -0.55,4.53 -0.78,7.1 5.7,-0.24 26.91,0.92 29,13.36 l 2.32,13.8 c -0.31,1.99 0.11,4.52 -0.19,6.51 C 91.5,72.38 85.45,51.47 71.13,53.71 Z'
        })
      )
    )
  );
};

var _ref10 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["f" /* PanacekNoSupport */], null);

var GraphSection = function GraphSection(_ref9) {
  var header = _ref9.header,
      person = _ref9.person,
      data = _ref9.data,
      fullfillment = _ref9.fullfillment,
      gender = _ref9.gender,
      small = _ref9.small;

  var colStyle = {
    width: '50%',
    height: 300,
    position: 'relative',
    display: 'inline-block',
    transition: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* transition */]
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        textAlign: 'center',
        paddingTop: 20,
        transition: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* transition */]
      }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'h2',
        null,
        header
      )
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { height: '3em', marginTop: -25, position: 'relative' } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)'
          }
        },
        function () {
          var text = fullfillmentToText(fullfillment, gender);
          if (text) return text;
          if (fullfillment) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'span',
            null,
            fullfillment.replace('porušil', gender === 'M' ? 'porušil' : 'porušila'),
            _ref10
          );
          return gender === 'M' ? 'Nezavázal se' : 'Nezavázala se';
        }()
      )
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { width: '100%', overflow: 'hidden' } },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ArrowLeftColumn, { person: person, rotate: small }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            style: {
              display: 'inline-block',
              verticalAlign: 'middle',
              marginTop: 15
            }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__Charts__["a" /* PieChart */], {
            data: data && data.total,
            gender: person.gender,
            title: 'Celkov\u011B'
          })
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(ArrowRightColumn, { person: person, rotate: small })
      )
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { height: 170 } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: _extends({}, colStyle, { transform: small ? '' : 'translateX(-50px)' })
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          HCenter,
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__Charts__["a" /* PieChart */], {
            data: data && data.voting,
            gender: person.gender,
            title: 'Hlasov\xE1n\xED'
          })
        )
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: _extends({}, colStyle, { transform: small ? '' : 'translateX(50px)' })
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          HCenter,
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__Charts__["b" /* ActivityChart */], { data: data && data.activity })
        )
      )
    )
  );
};

var PoliticianChartTabs = function PoliticianChartTabs(props) {
  var visibleRest = props.visibleRest,
      setVisibleRest = props.setVisibleRest,
      pledge = props.pledge,
      person = props.person,
      small = props.small;

  var data = props[props.visibleRest ? 'rest' + visibleRest : 'all'];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(RestTabs, {
      gender: person.gender,
      selectedTab: visibleRest,
      onTabSwitch: setVisibleRest,
      tabStates: pledge.fullfillment,
      comments: pledge.comments,
      small: small,
      names: new Array(9).fill(0).map(function (v, i) {
        return props['rest' + (i + 1)].restName;
      })
    }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(GraphSection, {
      small: small,
      gender: person.gender,
      data: data,
      person: props.person,
      header: visibleRest ? data.restName : 'Hodnocení za všechny zákony',
      fullfillment: pledge.fullfillment[visibleRest]
    })
  );
};
/* harmony default export */ __webpack_exports__["a"] = (PoliticianChartTabs);

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css__ = __webpack_require__("rq4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("2O6T");



/* eslint-disable */
if (typeof document !== 'undefined') {
  var _gaq = _gaq || [];
  _gaq.push(['_setAccount', 'UA-39222424-1']);
  _gaq.push(['_trackPageview']);(function () {
    var ga = document.createElement('script');
    ga.type = 'text/javascript';
    ga.async = true;
    ga.src = (document.location.protocol == 'https:' ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ga, s);
  })();
}
/* eslint-enable */

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */]);

/***/ }),

/***/ "Jv3S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Bubble; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ThumbsUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ThumbsDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PanacekBlack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PanacekWhite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PanacekNoSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Paragraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RankIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RankArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HamburgerMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("Uyz7");




var Bubble = function Bubble() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    { height: '25.830862', width: '31', y: '0px', x: '0px', viewBox: '0 0 31 25.830862' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
      style: { fill: '#d9d9d9', stroke: '#696969', strokeWidth: 3 },
      d: 'M 18.8843,1.6941 C 23.267,2.2764 29.5,5.3333 29.5,10.0886 c 0,0.1456 -0.0974,0.8734 -0.2435,1.3101 -0.1461,0.4853 -0.3896,1.019 -0.7304,1.5528 -0.5844,0.9704 -1.5096,2.0865 -2.5808,2.9599 -0.5358,0.4367 -1.2175,0.7764 -1.6557,1.2616 -0.1461,0.097 -0.1461,0.2911 -0.1461,0.4367 0,0.3397 -0.0487,0.9219 -0.0487,1.019 0,1.9894 1.12,3.9304 2.4347,5.8713 -2.2399,-1.1646 -5.1617,-3.4451 -6.866,-5.9684 -1.3635,0.1456 -2.9217,0.3397 -4.3339,0.3397 -3.7496,0 -9.5444,-1.116 -12.6609,-5.192 C 2.2304,13.097 1.5,11.3987 1.5,10.6224 V 9.7489 C 1.6461,9.1181 1.6948,8.4388 1.987,7.8566 3.9835,3.538 9.6322,1.9852 12.7974,1.597 13.0896,1.5485 13.7713,1.5 13.9174,1.5 h 3.1165 c 0.1461,0 1.2661,0.1456 1.8504,0.1941 z'
    })
  );
};

var ThumbsUp = function ThumbsUp() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    { height: '53', width: '60', viewBox: '0 0 60 53' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
      d: 'M 33.242188 0.5 C 29.676286 0.5 27.406388 6.6742186 28.054688 8.9492188 C 28.054688 13.174219 24.165334 19.350591 19.302734 22.275391 C 18.330234 22.600591 17.681503 23.900391 17.033203 23.900391 C 16.060603 23.900391 15.412072 22.275681 14.763672 21.300781 C 12.170272 20.975881 7.9551406 20.974609 7.3066406 20.974609 C 6.0100406 20.974609 1.4725 21.299219 0.5 21.949219 L 0.5 51.199219 C 0.5 51.849319 1.1484564 52.175 1.4726562 52.5 L 14.763672 52.5 C 15.412072 51.5249 15.736466 50.2251 16.384766 49.25 C 20.274866 49.575 24.812925 50.875781 28.703125 50.550781 L 47.181641 50.224609 C 48.478341 49.899409 49.775428 48.6001 50.423828 47.625 C 51.072128 46.6499 50.423966 44.699509 51.072266 43.724609 C 52.044766 41.774409 54.960938 41.125 54.960938 39.5 C 54.960938 38.8501 53.988281 38.199509 53.988281 37.224609 C 53.988281 34.949509 57.230469 34.625 57.230469 31.375 C 57.230469 30.3999 56.582031 29.425491 56.582031 28.775391 C 56.582031 27.475591 59.5 25.524409 59.5 24.224609 C 59.5 21.624509 58.2027 19.349319 54.3125 18.699219 L 46.208984 18.699219 C 45.560684 18.699219 38.103516 19.999219 38.103516 17.074219 C 38.103516 16.424219 39.400391 10.574509 39.400391 9.5996094 C 39.400391 7.6494094 38.753188 0.5 33.242188 0.5 z M 32.59375 3.75 L 34.214844 3.75 C 35.187244 5.7 36.484375 9.6001 36.484375 11.875 C 36.484375 16.425 34.214844 17.400681 34.214844 19.675781 C 34.214844 20.325781 34.214962 20.650391 34.539062 20.650391 C 35.511562 21.300491 36.484431 20.975881 37.457031 21.300781 L 41.994141 21.300781 L 50.099609 21.300781 C 52.368909 21.625781 54.636931 21.950781 56.582031 22.925781 C 54.636931 27.800781 50.423828 24.549509 50.423828 27.474609 C 50.423828 28.124509 54.3125 29.750491 54.3125 30.400391 C 54.3125 34.625491 49.450941 32.349319 47.181641 34.949219 C 48.154141 36.574219 51.396484 38.200781 51.396484 39.175781 C 51.396484 41.125781 45.884609 41.450781 44.912109 42.425781 C 45.236309 43.400681 46.857578 44.050491 47.830078 45.025391 C 47.505878 45.675491 47.181503 46.974609 46.533203 46.974609 C 41.994703 47.624509 33.890469 48.275391 32.917969 48.275391 C 32.269669 48.275391 22.219984 46.9751 16.708984 46 C 16.384884 46 16.384747 45.674509 16.060547 45.349609 L 16.060547 27.474609 C 22.868347 25.849609 31.621075 14.799219 31.296875 8.9492188 C 30.972775 7.6491185 31.62115 4.7251 32.59375 3.75 z M 5.3632812 23.574219 L 11.845703 23.574219 L 12.818359 42.099609 C 11.845859 45.349609 13.466503 46.975591 11.845703 49.900391 L 4.7148438 49.900391 C 4.3905437 49.575491 3.7420686 49.250781 3.4179688 48.925781 L 3.4179688 24.875 C 3.7420688 24.2251 4.7149813 23.574219 5.3632812 23.574219 z M 9.2519531 45.025391 C 7.9553531 45.025391 7.9570312 45.999509 7.9570312 46.974609 C 7.9570312 47.624509 8.28125 48.274409 8.28125 48.599609 L 9.9003906 48.599609 C 10.548691 47.949509 11.197266 47.299219 11.197266 46.324219 C 11.197266 45.999219 10.548663 45.025391 9.2519531 45.025391 z ',
      style: { fill: '#8dc641', stroke: 'none', strokeOpacity: 1 }
    })
  );
};

var ThumbsDown = function ThumbsDown() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    {
      viewBox: '0 0 60 53',
      width: '60',
      height: '53',
      style: {
        marginTop: 21,
        marginBottom: -21
      }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
      style: { fill: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* colors */].red, stroke: 'none', strokeOpacity: 1 },
      d: 'm 33.242188,52.5 c -3.565902,0 -5.8358,-6.174219 -5.1875,-8.449219 0,-4.225 -3.889354,-10.401372 -8.751954,-13.326172 -0.9725,-0.3252 -1.621231,-1.625 -2.269531,-1.625 -0.9726,0 -1.621131,1.62471 -2.269531,2.59961 -2.5934,0.3249 -6.8085314,0.326172 -7.4570314,0.326172 -1.2966,0 -5.8341406,-0.32461 -6.8066406,-0.97461 v -29.25 C 0.5,1.150681 1.1484564,0.825 1.4726562,0.5 H 14.763672 c 0.6484,0.9751 0.972794,2.2749 1.621094,3.25 3.8901,-0.325 8.428159,-1.625781 12.318359,-1.300781 l 18.478516,0.326172 c 1.2967,0.3252 2.593787,1.624509 3.242187,2.599609 0.6483,0.9751 1.38e-4,2.925491 0.648438,3.900391 0.9725,1.9502 3.888672,2.599609 3.888672,4.224609 0,0.6499 -0.972657,1.300491 -0.972657,2.275391 0,2.2751 3.242188,2.599609 3.242188,5.849609 0,0.9751 -0.648438,1.949509 -0.648438,2.599609 0,1.2998 2.917969,3.250982 2.917969,4.550782 0,2.6001 -1.2973,4.87529 -5.1875,5.52539 h -8.103516 c -0.6483,0 -8.105468,-1.3 -8.105468,1.625 0,0.65 1.296875,6.49971 1.296875,7.47461 0,1.9502 -0.647203,9.099609 -6.158203,9.099609 z M 32.59375,49.25 h 1.621094 c 0.9724,-1.95 2.269531,-5.8501 2.269531,-8.125 0,-4.55 -2.269531,-5.525681 -2.269531,-7.800781 0,-0.65 1.18e-4,-0.97461 0.324218,-0.97461 0.9725,-0.6501 1.945369,-0.32549 2.917969,-0.65039 h 4.53711 8.105468 c 2.2693,-0.325 4.537322,-0.65 6.482422,-1.625 -1.9451,-4.875 -6.158203,-1.623728 -6.158203,-4.548828 0,-0.6499 3.888672,-2.275882 3.888672,-2.925782 0,-4.2251 -4.861559,-1.948928 -7.130859,-4.548828 0.9725,-1.625 4.214843,-3.251562 4.214843,-4.226562 0,-1.95 -5.511875,-2.275 -6.484375,-3.25 0.3242,-0.9749 1.945469,-1.62471 2.917969,-2.59961 -0.3242,-0.6501 -0.648575,-1.949218 -1.296875,-1.949218 -4.5385,-0.6499 -12.642734,-1.300782 -13.615234,-1.300782 -0.6483,0 -10.697985,1.300291 -16.208985,2.275391 -0.3241,0 -0.324237,0.325491 -0.648437,0.650391 v 17.875 c 6.8078,1.625 15.560528,12.67539 15.236328,18.52539 -0.3241,1.3001 0.324275,4.224119 1.296875,5.199219 z M 5.3632812,29.425781 h 6.4824218 l 0.972656,-18.52539 c -0.9725,-3.25 0.648144,-4.875982 -0.972656,-7.800782 H 4.7148438 c -0.3243001,0.3249 -0.9727752,0.64961 -1.296875,0.97461 V 28.125 c 0.3241,0.6499 1.2970125,1.300781 1.9453124,1.300781 z M 9.2519531,7.974609 c -1.2966,0 -1.2949219,-0.974118 -1.2949219,-1.949218 0,-0.6499 0.3242188,-1.2998 0.3242188,-1.625 h 1.6191406 c 0.6483004,0.6501 1.2968754,1.30039 1.2968754,2.27539 0,0.325 -0.648603,1.298828 -1.9453129,1.298828 z'
    })
  );
};

var PanacekBlack = function PanacekBlack() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    {
      style: {
        height: '1.4em',
        marginBottom: '-.2em'
      },
      height: '36.999947',
      width: '37',
      viewBox: '0 0 37 36.999947'
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
      style: { opacity: 0.87059996, fill: '#000000' },
      d: 'M 20.5717,6.2847 C 20.5717,2.0711 16.9371,0 13.4479,0 13.2299,0 11.776,0.1428 11.0491,0.2857 8.723,0.7142 6.0334,2.571 3.78,3.8565 3.2711,4.1422 0,5.7134 0,6.3561 c 0,0.2143 0.0727,0.3572 0.2181,0.5 2.7622,1.9996 4.3614,4.9992 5.8153,7.3559 0.4361,0.7142 0.945,1.4284 1.6719,2.1426 1.5266,1.4997 3.4165,2.1425 5.0884,2.1425 2.4715,0 5.67,-1.2856 5.67,-4.785 0,-0.1428 -0.0727,-0.5714 0,-0.857 0.8722,0.3571 3.4164,1.2141 3.4164,1.5712 0,0.1428 -4.8703,11.4268 -7.1964,17.1402 -0.0727,0.0714 -1.5992,3.4994 -1.5992,4.2136 0,1.1427 1.2357,1.214 1.9626,1.214 0.6543,0 1.2358,0.0715 2.0354,-0.5713 0.2908,-0.2142 0.5089,-0.4999 0.6543,-0.7856 0.6542,-1.3569 1.2357,-2.7853 1.7445,-4.0707 0.1454,-0.4286 0.4362,-0.8571 0.5089,-1.2141 0.2181,-0.6428 0.5088,-1.357 1.1631,-1.357 1.3083,0 4.1434,4.0708 4.2888,4.2851 0.7268,1.0712 1.3811,2.4996 2.3987,3.428 0.3635,0.3571 0.5816,0.2856 0.9451,0.2856 0.7269,0 2.7622,-0.5713 2.7622,-2.0711 0,-1.214 -3.78,-5.999 -4.0708,-6.2847 -1.1628,-1.3569 -2.9802,-3.0709 -4.2888,-4.0707 -0.218,-0.1429 -0.436,-0.2857 -0.5814,-0.4286 l 1.0177,-2.2853 c 1.163,1.2141 3.6345,3.4994 5.1611,3.4994 2.2534,0 3.053,-4.4993 3.9253,-5.9276 0.2181,0.0714 2.0354,1.2856 2.6169,1.2856 C 36.4185,20.7111 37,18.997 37,18.2828 37,17.8543 36.7819,17.283 36.4185,17.0687 30.5304,13.9978 24.6424,11.641 18.7544,9.927 15.7014,8.9986 12.2849,8.213 9.3045,7.5703 9.2319,7.5703 9.1591,7.4988 9.1591,7.4274 L 9.3045,7.2846 h 0.4362 c 1.6719,0 9.5225,1.8568 9.5952,1.8568 1.0904,0 1.2358,-2.4996 1.2358,-2.8567 z m 8.5777,11.9267 c 0,0.3571 -0.727,2.4282 -1.3813,2.4282 -0.2181,0 -0.4361,-0.2142 -0.5815,-0.2857 -1.1629,-0.6427 -1.8173,-1.3569 -1.8173,-2.1425 0,-0.7856 0.2909,-1.0713 0.6544,-1.9997 0.0725,0 3.1257,0.9998 3.1257,1.9997 z M 28.7131,7.4988 c 0,-1.4283 -0.945,-3.6423 -3.1984,-3.6423 -1.9627,0 -2.9803,1.8569 -2.9803,3.4281 0,1.2855 0.945,3.7136 3.1258,3.7136 1.9626,0 3.0529,-1.9282 3.0529,-3.4994 z'
    })
  );
};

var PanacekWhite = function PanacekWhite() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    {
      style: {
        height: '1.4em',
        marginBottom: '-.2em',
        marginRight: '.1em'
      },
      height: '22.000072',
      width: '22',
      viewBox: '0 0 22 22.000072'
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
      style: { fill: '#ffffff' },
      d: 'M 12.2318,3.7368 C 12.2318,1.2314 10.0707,0 7.996,0 7.8664,0 7.002,0.085 6.5698,0.1699 5.1866,0.4248 3.5874,1.5288 2.2476,2.293 1.945,2.4629 0,3.397 0,3.7793 0,3.9067 0.0432,3.9917 0.1296,4.0767 1.7721,5.2656 2.723,7.0491 3.5874,8.4504 c 0.2594,0.4246 0.562,0.8494 0.9941,1.274 0.9077,0.8918 2.0314,1.2739 3.0256,1.2739 1.4695,0 3.3713,-0.7644 3.3713,-2.8452 0,-0.085 -0.0432,-0.3396 0,-0.5095 0.5187,0.2124 2.0314,0.7219 2.0314,0.9343 0,0.085 -2.8958,6.7942 -4.2789,10.1911 -0.0433,0.043 -0.9509,2.0811 -0.9509,2.5057 0,0.6794 0.7348,0.7219 1.167,0.7219 0.3889,0 0.7347,0.043 1.2102,-0.3399 0.1729,-0.1274 0.3025,-0.2973 0.3889,-0.467 0.3891,-0.8069 0.7348,-1.656 1.0374,-2.4207 0.0864,-0.2546 0.2593,-0.5092 0.3025,-0.7216 0.1297,-0.3824 0.3026,-0.8067 0.6916,-0.8067 0.778,0 2.4637,2.4204 2.5501,2.5479 0.4322,0.6367 0.8212,1.4861 1.4263,2.0381 0.2161,0.2124 0.3458,0.1699 0.5619,0.1699 0.4322,0 1.6424,-0.3399 1.6424,-1.2315 0,-0.7219 -2.2475,-3.5671 -2.4204,-3.7368 -0.6915,-0.8071 -1.7721,-1.8262 -2.5501,-2.4204 -0.1297,-0.085 -0.2593,-0.1699 -0.3458,-0.2549 l 0.6051,-1.3589 c 0.6916,0.722 2.1612,2.0806 3.0688,2.0806 1.3398,0 1.8153,-2.675 2.334,-3.5244 0.1297,0.042 1.2103,0.7642 1.556,0.7642 C 21.6542,12.3145 22,11.2954 22,10.8708 22,10.6162 21.8704,10.2764 21.6542,10.1489 18.1532,8.323 14.6523,6.9216 11.1513,5.9026 9.3359,5.3506 7.3045,4.8833 5.5325,4.5012 5.4892,4.5012 5.446,4.4582 5.446,4.4162 l 0.0865,-0.085 h 0.2592 c 0.9941,0 5.6622,1.1042 5.7054,1.1042 0.6483,0 0.7347,-1.4863 0.7347,-1.6987 z m 5.1002,7.0916 c 0,0.2124 -0.4322,1.4438 -0.8212,1.4438 -0.1296,0 -0.2593,-0.1274 -0.3458,-0.1697 -0.6916,-0.3823 -1.0805,-0.8071 -1.0805,-1.2741 0,-0.4671 0.1728,-0.637 0.3889,-1.189 0.0433,0 1.8586,0.5945 1.8586,1.189 z M 17.0727,4.4587 c 0,-0.8493 -0.5619,-2.1657 -1.9018,-2.1657 -1.1669,0 -1.772,1.104 -1.772,2.0383 0,0.7644 0.5618,2.2083 1.8584,2.2083 1.1671,0 1.8154,-1.1465 1.8154,-2.0809 z'
    })
  );
};

var PanacekNoSupport = function PanacekNoSupport() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    {
      style: {
        height: '1.4em',
        marginBottom: '-.2em',
        marginRight: '.1em'
      },
      height: '50',
      width: '50',
      viewBox: '0 0 50 50'
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
      style: { opacity: 0.87059996, fill: '#000000' },
      d: 'M 27.799592,8.4928503 C 27.799592,2.7987879 22.887975,7.5336004e-8 18.17284,7.5336004e-8 17.878245,7.5336004e-8 15.913515,0.19297333 14.931218,0.38608172 11.787839,0.96513662 8.1532441,3.4743295 5.1081087,5.2114942 4.4204059,5.5975758 0,7.7208221 0,8.5893369 0,8.8789319 0.09824325,9.0720403 0.29472976,9.2650136 4.0274329,11.96718 6.1885142,16.020699 8.1532441,19.205433 c 0.5893244,0.965137 1.2770272,1.930274 2.2593249,2.89541 2.062973,2.026625 4.616892,2.895275 6.876217,2.895275 3.339865,0 7.662157,-1.7373 7.662157,-6.466226 0,-0.192973 -0.09824,-0.772163 0,-1.15811 1.178649,0.482568 4.616757,1.640678 4.616757,2.123246 0,0.192974 -6.581481,15.441645 -9.72486,23.162467 -0.09824,0.09649 -2.161081,4.728925 -2.161081,5.694062 0,1.544191 1.669865,1.640543 2.652162,1.640543 0.884189,0 1.67,0.09662 2.750536,-0.772028 0.392973,-0.28946 0.687702,-0.675542 0.884189,-1.061623 0.884054,-1.833652 1.669865,-3.763925 2.357433,-5.500954 0.196486,-0.57919 0.589459,-1.158245 0.687702,-1.640678 0.29473,-0.86865 0.687568,-1.833787 1.571757,-1.833787 1.767973,0 5.59919,5.501089 5.795677,5.790684 0.982162,1.44757 1.866351,3.377843 3.241486,4.632439 0.491217,0.482569 0.785946,0.385947 1.277163,0.385947 0.982297,0 3.732703,-0.772028 3.732703,-2.798788 0,-1.640543 -5.108109,-8.106768 -5.501082,-8.49285 -1.571351,-1.833651 -4.027298,-4.149871 -5.795676,-5.500954 -0.294595,-0.193108 -0.589189,-0.386082 -0.785676,-0.57919 l 1.37527,-3.088248 c 1.571622,1.640678 4.911487,4.728926 6.974461,4.728926 3.045135,0 4.125676,-6.080144 5.30446,-8.010282 0.294729,0.09649 2.750541,1.7373 3.536351,1.7373 C 49.214189,27.988014 50,25.671659 50,24.706523 50,24.127468 49.70527,23.35544 49.214189,23.065845 41.257296,18.915974 33.300539,15.731104 25.343781,13.414884 21.21811,12.160288 16.601218,11.098665 12.57365,10.23015 c -0.09811,0 -0.196486,-0.09662 -0.196486,-0.193108 L 12.57365,9.8440685 h 0.58946 c 2.259324,0 12.868239,2.5091925 12.966482,2.5091925 1.473514,0 1.67,-3.3778424 1.67,-3.8604107 z M 39.39108,24.610036 c 0,0.482568 -0.982433,3.281356 -1.866622,3.281356 -0.29473,0 -0.589324,-0.28946 -0.785811,-0.386082 -1.571486,-0.868514 -2.455811,-1.833651 -2.455811,-2.895274 0,-1.061623 0.393108,-1.447705 0.884325,-2.702301 0.09797,0 4.223919,1.351083 4.223919,2.702301 z M 38.801485,10.133528 c 0,-1.9301376 -1.277027,-4.9220338 -4.322162,-4.9220338 -2.652298,0 -4.027433,2.5093279 -4.027433,4.6325743 0,1.7371645 1.277027,5.0183855 4.224054,5.0183855 2.652163,0 4.125541,-2.605679 4.125541,-4.728926 z'
    }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', {
      transform: 'rotate(-44.930362)',
      y: '30.538225',
      x: '-32.534054',
      height: '7.9399705',
      width: '64.568436',
      id: 'rect4524',
      style: { fill: '#d22f3c' }
    })
  );
};

var Paragraph = function Paragraph() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#cccccc' : _ref$color,
      _ref$portion = _ref.portion,
      portion = _ref$portion === undefined ? 1 : _ref$portion,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { height: portion * 73, position: 'relative' } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'svg',
      {
        style: {
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        },
        height: portion * 73,
        width: '40',
        viewBox: '0 ' + 73 * offset + ' 40 ' + portion * 73
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
        style: { fill: color },
        d: 'M 32.8409,8.147 C 30.4199,6.0542 27.0945,5 22.8722,5 c -4.125,0 -7.3234,1.0464 -9.5949,3.1392 -2.2718,2.0927 -3.4077,4.655 -3.4077,7.6711 0,1.3003 0.2689,2.5774 0.807,3.824 0.5382,1.2541 1.3304,2.4851 2.3914,3.6931 C 10.9905,24.543 9.4586,26.082 8.4722,27.9592 7.4856,29.8367 7,31.8755 7,34.0684 c 0,2.6621 0.7548,5.0703 2.2642,7.2172 1.5096,2.1465 4.7605,4.8472 9.7671,8.1019 4.9992,3.2546 7.9136,5.2937 8.7507,6.1245 0.807,0.8234 1.218,1.7619 1.218,2.8161 0,1.0464 -0.4259,1.9466 -1.2628,2.6851 -0.8446,0.7388 -1.973,1.1079 -3.3927,1.1079 -1.6665,0 -3.0415,-0.5 -4.1323,-1.4849 C 19.1211,59.6438 18.3885,58.1665 18,56.2122 L 8.9132,57.197 c 0.4782,3.7239 2.025,6.7093 4.6406,8.9558 2.6153,2.2315 6.1051,3.355 10.4693,3.355 4.5285,0 8.0108,-1.1235 10.432,-3.355 2.4211,-2.2387 3.6317,-5.0166 3.6317,-8.3249 0,-1.5928 -0.3286,-3.093 -0.9713,-4.5164 -0.6502,-1.4157 -1.6366,-2.7546 -2.9518,-4.0088 1.943,-1.4311 3.4075,-3.0236 4.3793,-4.7778 0.9714,-1.7544 1.457,-3.678 1.457,-5.7632 0,-1.9389 -0.411,-3.7163 -1.2253,-5.3164 -0.8223,-1.6006 -2.1748,-3.2163 -4.0728,-4.855 -1.2257,-1.0695 -3.7367,-2.8545 -7.5328,-5.363 -3.7961,-2.5081 -6.038,-4.093 -6.7106,-4.7703 -1.0013,-1.0002 -1.502,-2.0542 -1.502,-3.1545 0,-0.7542 0.3588,-1.4236 1.076,-2.0237 0.7175,-0.5923 1.7713,-0.8926 3.146,-0.8926 1.4797,0 2.6457,0.4234 3.4825,1.262 0.837,0.8464 1.2929,2.062 1.3825,3.6623 l 9.0869,-0.9848 C 36.697,12.9712 35.2622,10.2397 32.8409,8.147 Z M 19.9878,38.6619 c -2.9218,-2.0313 -4.3792,-4.178 -4.3792,-6.44 0,-0.9387 0.2392,-1.8235 0.7249,-2.6545 0.486,-0.8311 1.0463,-1.4697 1.6814,-1.9158 l 8.6536,6.6477 c 2.1745,1.6773 3.5046,2.9082 3.9906,3.6931 0.4854,0.7849 0.7323,1.5467 0.7323,2.2852 0,0.7617 -0.1796,1.5542 -0.5308,2.3699 -0.3511,0.8154 -0.8816,1.6694 -1.5989,2.562 z'
      }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', {
        style: { fill: color },
        height: (portion + offset) * 73,
        width: '1'
      })
    )
  );
};

var RankIcon = function RankIcon(_ref2) {
  var _ref2$style = _ref2.style,
      style = _ref2$style === undefined ? {} : _ref2$style;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    { style: style, height: '33', width: '32', viewBox: '0 0 32 33' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'g',
      { transform: 'translate(-1340,-216)' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
        style: { fill: '#000' },
        d: 'm 1358.5454,218.7348 c 0,1.4586 -1.0908,2.5525 -2.5454,2.5525 -1.8181,0 -2.7273,-1.0939 -2.7273,-2.7349 0,-1.6408 1.4546,-2.5524 2.7273,-2.5524 1.6365,0 2.5454,1.4586 2.5454,2.7348 z M 1356,222.9282 c 5.2727,0 6.9091,-6.1989 8.3635,-6.1989 0.3638,0 0.5456,0.1823 0.9092,0.1823 0,1.2763 -0.1818,1.2763 -0.1818,1.8232 0,0.3647 -1.6363,3.0995 -2.909,4.558 -0.5454,0.7293 -1.8184,1.2762 -2.3638,2.3702 -0.5454,0.7293 -0.3635,2.3701 -0.3635,2.9171 v 7.6574 h -2.5455 v -4.011 c -0.1818,-0.1823 -0.5456,-0.7292 -0.9091,-0.7292 -0.5454,0 -0.5454,0.3646 -0.9091,0.7292 v 4.011 h -2.7274 v -9.2983 c -0.1816,-0.1823 0,-0.9116 -0.3635,-1.2762 -0.5454,-0.9116 -1.6365,-1.4586 -2.3635,-2.3702 -0.9092,-1.0939 -2.9092,-4.3757 -2.9092,-5.652 0,-0.3646 -0.1819,-0.9115 0.7273,-0.9115 1.0908,0 3.4545,6.1989 8.5454,6.1989 z m 4.7273,15.1326 v 8.0221 h 1.8181 v -3.2818 H 1372 V 249 h -32 v -8.0221 h 9.4546 v 5.105 h 1.8181 v -8.0221 z'
      })
    )
  );
};

var RankArrow = function RankArrow() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    {
      height: '17',
      width: '12',
      viewBox: '0 0 12 17',
      style: { position: 'absolute', transform: 'translate(-100%,-8.7489px)' }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
      style: { fill: '#696969' },
      d: 'M 0.0564,17 12,8.7489 0,0 4.3711,8.6938 Z'
    })
  );
};

var _ref4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z' });

var HamburgerMenu = function HamburgerMenu(_ref3) {
  var _ref3$style = _ref3.style,
      style = _ref3$style === undefined ? {} : _ref3$style;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'svg',
    {
      height: '40px',
      version: '1.1',
      viewBox: '0 0 32 32',
      width: '40px',
      style: style
    },
    _ref4
  );
};

/***/ }),

/***/ "KIZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("X5xa");
var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-left: -5px;\n  position: absolute;\n  transform: translate(\n    -', '%,\n    ', '%\n  );\n  z-index: ', ';\n'], ['\n  margin-left: -5px;\n  position: absolute;\n  transform: translate(\n    -', '%,\n    ', '%\n  );\n  z-index: ', ';\n']);



function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }




var TooltipBubble = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */])(function (_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === undefined ? null : _ref$children,
      height = _ref.height,
      width = _ref.width,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0.5 : _ref$offset,
      className = _ref.className,
      _ref$topArrow = _ref.topArrow,
      topArrow = _ref$topArrow === undefined ? false : _ref$topArrow;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: className },
    topArrow ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
      style: {
        width: 10,
        height: 10,
        borderBottom: 'solid black 10px',
        borderRight: 'solid transparent 5px',
        borderLeft: 'solid transparent 5px',
        left: 100 * offset + '%',
        position: 'absolute'
      }
    }) : null,
    topArrow ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { style: { height: 10 } }) : null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          padding: '10px 20px 10px 20px',
          borderRadius: 3,
          height: height,
          width: width,
          backgroundColor: '#222',
          opacity: 0.9,
          color: 'white'
        }
      },
      children
    ),
    !topArrow ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
      style: {
        width: 10,
        height: 10,
        borderTop: 'solid black 10px',
        borderRight: 'solid transparent 5px',
        borderLeft: 'solid transparent 5px',
        left: 100 * offset + '%',
        position: 'absolute'
      }
    }) : null,
    !topArrow ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { style: { height: 10 } }) : null
  );
})(_templateObject, function (props) {
  return 100 * props.offset;
}, function (props) {
  return props.topArrow ? 0 : -100;
}, function (props) {
  return props.zIndex || 10;
});

/* harmony default export */ __webpack_exports__["a"] = (TooltipBubble);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KMj6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Chevron__ = __webpack_require__("isZO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("Uyz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__("KuMu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visual__ = __webpack_require__("qyj1");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__Chevron__["a" /* default */], null);

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'a',
  { href: '/cs/zapoj-se/zasady-ochrany-udaju' },
  'dle t\u011Bchto podm\xEDnek'
);

var MailBlock = function (_Component) {
  _inherits(MailBlock, _Component);

  function MailBlock() {
    _classCallCheck(this, MailBlock);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      agree: false,
      email: '',
      submitted: false,
      submitting: false
    };
    return _this;
  }

  MailBlock.prototype.render = function render() {
    var _this2 = this;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          backgroundColor: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].yellow,
          paddingBottom: 40
        }
      },
      _ref,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_3____["a" /* Block */],
        { style: { textAlign: 'center', marginBottom: -80 } },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { style: { fontSize: 30, marginBottom: 25 } },
          'P\u0159e\u010Dt\u011Bte si jako prvn\xED, co skute\u010Dn\u011B d\u011Blaj\xED va\u0161i politici!'
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'form',
          {
            role: 'form',
            className: 'std form-newsletter',
            id: 'newsletter',
            method: 'post',
            encType: 'application/x-www-form-urlencoded',
            action: 'https://rekonstrukcestatu.us4.list-manage.com/subscribe/post?u=5d66fd73a6a5bb1624ddc06a0&id=d28014602a',
            onSubmit: function onSubmit(evt) {
              if (!_this2.state.agree || !_this2.state.email) {
                /* validation error */
                evt.preventDefault();
                _this2.setState({ submitted: true, submitting: false });
              } else {
                _this2.setState({ submitted: true, submitting: true });

                if (_this2.props.gaId && typeof dataLayer !== 'undefined') {
                  evt.preventDefault();
                  evt.persist();

                  window.dataLayer.push({
                    event: 'action.subscribe.newsletter',
                    action: {
                      subscribe: {
                        form: _this2.props.gaId
                      }
                    },
                    eventCallback: function eventCallback() {
                      evt.target.submit();
                    }
                  });
                }
              }
            },
            noValidate: true
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { style: { display: 'inline-block', marginRight: 15 } },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
              style: {
                height: 40,
                borderColor: this.state.submitted && !this.state.email ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].red : ''
              },
              type: 'text',
              name: 'EMAIL',
              id: 'EMAIL',
              className: 'text',
              placeholder: 'V\xE1\u0161 e-mail',
              value: this.state.email,
              onChange: function onChange(evt) {
                return _this2.setState({ email: evt.target.value });
              }
            })
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { style: { display: 'inline-block', marginBottom: 15 } },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'button',
              {
                style: { width: 230 },
                type: 'submit',
                id: 'send',
                name: 'send',
                className: 'btn',
                value: 'send'
              },
              'M\xE1m z\xE1jem!'
            )
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_4__visual__["b" /* Checkbox */],
            {
              id: 'mailblock-accept',
              checked: this.state.agree,
              onChange: function onChange(agree) {
                return _this2.setState({ agree: agree });
              }
            },
            'Souhlas\xEDm se zpracov\xE1n\xEDm osobn\xEDch \xFAdaj\u016F',
            ' ',
            _ref2,
            '.',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              {
                style: {
                  opacity: this.state.submitted && !this.state.agree ? 1 : 0,
                  pointerEvents: this.state.submitted && !this.state.agree ? 'all' : 'none',
                  position: 'absolute',
                  color: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].red
                }
              },
              'Pros\xEDm, za\u0161krtn\u011Bte souhlas s podm\xEDnkami.'
            )
          )
        )
      )
    );
  };

  return MailBlock;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MailBlock);

/***/ }),

/***/ "KuMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Block__ = __webpack_require__("Rhdh");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Block__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SectionHead__ = __webpack_require__("ojtX");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__SectionHead__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Separator__ = __webpack_require__("poto");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Separator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withDimensions__ = __webpack_require__("5wwt");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__withDimensions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MailBlock__ = __webpack_require__("KMj6");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__MailBlock__["a"]; });






/***/ }),

/***/ "LwpJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0bf3b36fbe2e995787c21324e030370c.png";

/***/ }),

/***/ "MMx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout__ = __webpack_require__("KuMu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visual__ = __webpack_require__("qyj1");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var compareByDisabled = function compareByDisabled(a, b) {
  if (a.disabled && !b.disabled) return 1;
  if (b.disabled && !a.disabled) return -1;
  return a.value.toLowerCase().localeCompare(b.value.toLowerCase());
};

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_1__layout__["b" /* Separator */],
  { packed: true },
  'nebo vyhledejte konkr\xE9tn\xEDho politika'
);

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var filters = _ref.filters,
      setFilter = _ref.setFilter,
      parties = _ref.parties,
      filterFunc = _ref.filterFunc,
      list = _ref.list;

  var disabled = function disabled(kv) {
    return !filterFunc(_extends({}, filters, kv, { name: '' }), list).some(function (p) {
      return !p.hidden;
    });
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_1__layout__["a" /* Block */],
    { alt: true, style: { padding: '20px 0 10px 0' } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          margin: '0 0 -20px -20px',
          textAlign: 'center'
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__visual__["c" /* Select */], {
        list: [{ key: '', value: 'Všichni politici' }, {
          key: 'MOP',
          value: 'Poslanec',
          disabled: disabled({ type: 'MOP' })
        }, {
          key: 'senator',
          value: 'Senátor',
          disabled: disabled({ type: 'senator' })
        }],
        value: filters.type,
        onChange: setFilter('type')
      }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__visual__["c" /* Select */], {
        list: [{ key: '', value: 'Všechny strany / kluby' }].concat(parties.map(function (v) {
          return {
            key: v,
            value: v,
            disabled: disabled({ party: v })
          };
        }).sort(compareByDisabled)),
        value: filters.party,
        onChange: setFilter('party')
      }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__visual__["c" /* Select */], {
        list: [{ key: '', value: 'Všechny kraje' }].concat([{ key: 'Praha', value: 'Praha' }, { key: 'Jihočeský kraj', value: 'Jihočeský kraj' }, { key: 'Jihomoravský kraj', value: 'Jihomoravský kraj' }, { key: 'Karlovarský kraj', value: 'Karlovarský kraj' }, { key: 'Vysočina', value: 'Vysočina' }, {
          key: 'Královéhradecký kraj',
          value: 'Královéhradecký kraj'
        }, { key: 'Liberecký kraj', value: 'Liberecký kraj' }, {
          key: 'Moravskoslezský kraj',
          value: 'Moravskoslezský kraj'
        }, { key: 'Olomoucký kraj', value: 'Olomoucký kraj' }, { key: 'Pardubický kraj', value: 'Pardubický kraj' }, { key: 'Plzeňský kraj', value: 'Plzeňský kraj' }, { key: 'Středočeský kraj', value: 'Středočeský kraj' }, { key: 'Ústecký kraj', value: 'Ústecký kraj' }, { key: 'Zlínský kraj', value: 'Zlínský kraj' }].map(function (v) {
          return _extends({}, v, {
            disabled: disabled({ region: v.value })
          });
        }).sort(compareByDisabled)),
        value: filters.region,
        onChange: setFilter('region')
      })
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      null,
      _ref2,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'form',
          {
            className: 'std form-filter alt-2',
            onSubmit: function onSubmit(evt) {
              return evt.preventDefault();
            }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { className: 'cell-set ib' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { className: 'cell' },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
                type: 'text',
                name: 'name',
                className: 'text',
                placeholder: 'Zadejte jm\xE9no politika',
                value: filters.name,
                onInput: function onInput(e) {
                  return setFilter('name')(e.target.value);
                }
              })
            )
          )
        )
      )
    )
  );
});

/***/ }),

/***/ "Ou8H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/* global google */

var loadingStarted = false;
var loaded = false;
var onLoad = [];

var Chart = function (_React$Component) {
  _inherits(Chart, _React$Component);

  function Chart() {
    _classCallCheck(this, Chart);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.drawn = false;
    if (typeof window !== 'undefined' && !loadingStarted) {
      google.charts.load('current', { packages: ['corechart'] });
      google.charts.setOnLoadCallback(function () {
        onLoad.forEach(function (f) {
          return f();
        });
        loaded = true;
      });
    }
    loadingStarted = true;
    return _this;
  }

  Chart.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (typeof window === 'undefined') return;
    var init = function init() {
      _this2.chart = new google.visualization.PieChart(_this2.div);
      _this2.dataTable = google.visualization.arrayToDataTable(_this2.props.data);
      _this2.draw();
      _this2.drawn = true;
    };
    if (loaded) init();else onLoad.push(init);
  };

  Chart.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.drawn && this.props.data !== prevProps.data) {
      this.dataTable = google.visualization.arrayToDataTable(this.props.data);
      this.draw();
    }
  };

  Chart.prototype.draw = function draw() {
    this.chart.draw(this.dataTable, this.props.options);
  };

  Chart.prototype.render = function render() {
    var _this3 = this;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
      style: {
        display: 'inline-block',
        width: this.props.options.width,
        height: this.props.options.height
      },
      ref: function ref(div) {
        _this3.div = div;
      },
      className: this.props.className
    });
  };

  return Chart;
}(__WEBPACK_IMPORTED_MODULE_1_react__["default"].Component);

Chart.defaultProps = {
  className: ''
};

/* harmony default export */ __webpack_exports__["a"] = (Chart);

/***/ }),

/***/ "QYBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_Header__ = __webpack_require__("YXHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Footer__ = __webpack_require__("B8h0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visual__ = __webpack_require__("qyj1");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/* global window */

var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__visual__["d" /* Spinner */], null);

var Page = function (_Component) {
  _inherits(Page, _Component);

  function Page() {
    _classCallCheck(this, Page);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.updateDimensions = _this.updateDimensions.bind(_this);
    _this.state = { width: 1900, height: 800, loading: true };
    return _this;
  }

  Page.prototype.getChildContext = function getChildContext() {
    return { hostname: this.props.hostname, windowDimensions: this.state };
  };

  Page.prototype.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined') {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
    }
  };

  Page.prototype.componentWillUnmount = function componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateDimensions);
    }
  };

  Page.prototype.updateDimensions = function updateDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  Page.prototype.render = function render() {
    var _this2 = this;

    if (typeof window !== 'undefined' && this.state.loading) {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          _this2.setState({ loading: false });
        });
      } else {
        setTimeout(function () {
          _this2.setState({ loading: false });
        }, 0);
      }
    }
    return this.state.loading ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'content' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            minHeight: 500,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        },
        _ref
      )
    ) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      null,
      this.props.children,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__layout_Footer__["a" /* default */], { gaSubscribeId: this.props.gaFooterSubscribeId })
    );
  };

  return Page;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

Page.childContextTypes = {
  hostname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (Page);

/***/ }),

/***/ "QZaE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
  if (getContent === null) return null; // Tip not exist and childern is null or undefined

  var regexp = /<br\s*\/?>/;
  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  }

  // Multiline tooltip content
  return tip.split(regexp).map(function (d, i) {
    return _react2.default.createElement('span', { key: i, className: 'multi-line' }, d);
  });
};

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),

/***/ "Rhdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Block = function Block(props) {
  var children = props.children,
      alt = props.alt,
      style = props.style;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    _extends({}, _extends({}, props, { children: undefined, alt: undefined }), {
      style: _extends({
        padding: '40px 0',
        background: alt ? '#e6e6e6' : undefined
      }, style)
    }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          position: 'relative',
          maxWidth: 960,
          margin: '0 auto'
        }
      },
      children
    )
  );
};
/* harmony default export */ __webpack_exports__["a"] = (Block);

/***/ }),

/***/ "SCgj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _withContentRect = __webpack_require__("g3jw");

var _withContentRect2 = _interopRequireDefault(_withContentRect);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function Measure(_ref) {
  var measure = _ref.measure,
      measureRef = _ref.measureRef,
      contentRect = _ref.contentRect,
      children = _ref.children;

  return children({ measure: measure, measureRef: measureRef, contentRect: contentRect });
}

exports.default = (0, _withContentRect2.default)()(Measure);
module.exports = exports['default'];

/***/ }),

/***/ "U9d9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

/***/ }),

/***/ "UQex":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "Uyz7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return transition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return administrationDisclaimer; });
var colors = {
  red: '#dc0d03', // ef412f
  green: '#8ec641',
  grey: '#e6e6e6',
  greyOnGrey: '#acacac',
  middleGrey: '#696969',
  darkGrey: '#32383a',
  orange: '#eba808',
  yellow: '#fff45f'
};

var supportColors = {
  'mimořádně podporuje': '#43711a',
  'aktivně podporuje': '#5c9d3e',
  podporuje: '#92c848',
  'pro i proti': '#eba808',
  nepodporuje: '#e35d16',
  blokuje: '#dd1e22',
  nehlasuje: '#888888'
};

var transition = 'all 0.5s ease-in-out';

var administrationDisclaimer = 'Toto hodnocení vychází pouze z návrhů a hlasování<br>' + 'v Parlamentu ČR. Pro členy vlády může být zavádějící,<br>' + 'neboť nezahrnuje jejich hlasování a aktivitu při<br>' + 'vyjednávání ve vládě a vládní koalici.';

/***/ }),

/***/ "W+bh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _class, _class2, _temp;

/* Decoraters */

/* Utils */

/* CSS */

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("eW0v");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _staticMethods = __webpack_require__("3Tsa");

var _staticMethods2 = _interopRequireDefault(_staticMethods);

var _windowListener = __webpack_require__("m3k2");

var _windowListener2 = _interopRequireDefault(_windowListener);

var _customEvent = __webpack_require__("xRcQ");

var _customEvent2 = _interopRequireDefault(_customEvent);

var _isCapture = __webpack_require__("rgnM");

var _isCapture2 = _interopRequireDefault(_isCapture);

var _getEffect = __webpack_require__("mqrf");

var _getEffect2 = _interopRequireDefault(_getEffect);

var _trackRemoval = __webpack_require__("pfHg");

var _trackRemoval2 = _interopRequireDefault(_trackRemoval);

var _getPosition = __webpack_require__("+TBW");

var _getPosition2 = _interopRequireDefault(_getPosition);

var _getTipContent = __webpack_require__("QZaE");

var _getTipContent2 = _interopRequireDefault(_getTipContent);

var _aria = __webpack_require__("vYDn");

var _nodeListToArray = __webpack_require__("/+BW");

var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);

var _style = __webpack_require__("/qIm");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(ReactTooltip, _Component);

  function ReactTooltip(props) {
    _classCallCheck(this, ReactTooltip);

    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));

    _this.state = {
      place: 'top', // Direction of tooltip
      type: 'dark', // Color theme of tooltip
      effect: 'float', // float or fixed
      show: false,
      border: false,
      placeholder: '',
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null, // Current mouse event
      currentTarget: null, // Current target of mouse event
      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
      isEmptyTip: false,
      disable: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.intervalUpdateContent = null;
    return _this;
  }

  /**
   * For unify the bind and unbind listener
   */

  _createClass(ReactTooltip, [{
    key: 'bind',
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          insecure = _props.insecure,
          resizeHide = _props.resizeHide;

      if (insecure) {
        this.setStyleHeader(); // Set the style to the <link>
      }
      this.bindListener(); // Bind listener for tooltip
      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var ariaProps = this.state.ariaProps;

      var newAriaProps = (0, _aria.parseAria)(props);

      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });
      if (isChanged) {
        this.setState({ ariaProps: newAriaProps });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mount = false;

      this.clearTimer();

      this.unbindListener();
      this.removeScrollListener();
      this.unbindWindowEvents();
    }

    /**
     * Pick out corresponded target elements
     */

  }, {
    key: 'getTargetArray',
    value: function getTargetArray(id) {
      var targetArray = void 0;
      if (!id) {
        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
      }
      // targetArray is a NodeList, convert it to a real array
      return (0, _nodeListToArray2.default)(targetArray);
    }

    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: 'bindListener',
    value: function bindListener() {
      var _this3 = this;

      var _props2 = this.props,
          id = _props2.id,
          globalEventOff = _props2.globalEventOff;

      var targetArray = this.getTargetArray(id);

      targetArray.forEach(function (target) {
        var isCaptureMode = _this3.isCapture(target);
        var effect = _this3.getEffect(target);
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }
        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customBindListener(target);
          return;
        }

        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
        if (effect === 'float') {
          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
        }
        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
      });

      // Global event to hide tooltip
      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, false);
      }

      // Track removal of targetArray elements from DOM
      this.bindRemovalTracker();
    }

    /**
     * Unbind listeners on target elements
     */

  }, {
    key: 'unbindListener',
    value: function unbindListener() {
      var _this4 = this;

      var _props3 = this.props,
          id = _props3.id,
          globalEventOff = _props3.globalEventOff;

      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        _this4.unbindBasicListener(target);
        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
      });

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }

    /**
     * Invoke this before bind listener and ummount the compont
     * it is necessary to invloke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: 'unbindBasicListener',
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }

    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: 'showTooltip',
    value: function showTooltip(e, isGlobalCall) {
      var _this5 = this;

      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || this.state.show) return;
      }
      // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected
      var _props4 = this.props,
          children = _props4.children,
          multiline = _props4.multiline,
          getContent = _props4.getContent;

      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;

      // Generate tootlip content
      var content = void 0;
      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0]();
        } else {
          content = getContent();
        }
      }
      var placeholder = (0, _getTipContent2.default)(originTooltip, children, content, isMultiline);
      var isEmptyTip = typeof placeholder === 'string' && placeholder === '' || placeholder === null;

      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;

      // if it need to skip adding hide listener to scroll
      var scrollHide = true;
      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      }

      // To prevent previously created timers from triggering
      this.clearTimer();

      this.setState({
        placeholder: placeholder,
        isEmptyTip: isEmptyTip,
        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false
      }, function () {
        if (scrollHide) _this5.addScrollListener(e);
        _this5.updateTooltip(e);

        if (getContent && Array.isArray(getContent)) {
          _this5.intervalUpdateContent = setInterval(function () {
            if (_this5.mount) {
              var _getContent = _this5.props.getContent;

              var _placeholder = (0, _getTipContent2.default)(originTooltip, _getContent[0](), isMultiline);
              var _isEmptyTip = typeof _placeholder === 'string' && _placeholder === '';
              _this5.setState({
                placeholder: _placeholder,
                isEmptyTip: _isEmptyTip
              });
            }
          }, getContent[1]);
        }
      });
    }

    /**
     * When mouse hover, updatetooltip
     */

  }, {
    key: 'updateTooltip',
    value: function updateTooltip(e) {
      var _this6 = this;

      var _state = this.state,
          delayShow = _state.delayShow,
          show = _state.show,
          isEmptyTip = _state.isEmptyTip,
          disable = _state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.state.placeholder;

      var delayTime = show ? 0 : parseInt(delayShow, 10);
      var eventTarget = e.currentTarget;

      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          (function () {
            var isInvisible = !_this6.state.show;
            _this6.setState({
              currentEvent: e,
              currentTarget: eventTarget,
              show: true
            }, function () {
              _this6.updatePosition();
              if (isInvisible && afterShow) afterShow();
            });
          })();
        }
      };

      clearTimeout(this.delayShowLoop);
      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }

    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: 'hideTooltip',
    value: function hideTooltip(e, hasTarget) {
      var _this7 = this;

      var _state2 = this.state,
          delayHide = _state2.delayHide,
          isEmptyTip = _state2.isEmptyTip,
          disable = _state2.disable;
      var afterHide = this.props.afterHide;

      if (!this.mount) return;
      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }
      var resetState = function resetState() {
        var isVisible = _this7.state.show;
        _this7.setState({
          show: false
        }, function () {
          _this7.removeScrollListener();
          if (isVisible && afterHide) afterHide();
        });
      };

      this.clearTimer();
      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }

    /**
     * Add scroll eventlistener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: 'addScrollListener',
    value: function addScrollListener(e) {
      var isCaptureMode = this.isCapture(e.currentTarget);
      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: 'removeScrollListener',
    value: function removeScrollListener() {
      window.removeEventListener('scroll', this.hideTooltip);
    }

    // Calculation the position

  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var _this8 = this;

      var _state3 = this.state,
          currentEvent = _state3.currentEvent,
          currentTarget = _state3.currentTarget,
          place = _state3.place,
          effect = _state3.effect,
          offset = _state3.offset;

      var node = _reactDom2.default.findDOMNode(this);
      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, effect, offset);

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this8.updatePosition();
        });
      }
      // Set tooltip position
      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }

    /**
     * Set style tag in header
     * in this way we can insert default css
     */

  }, {
    key: 'setStyleHeader',
    value: function setStyleHeader() {
      if (!document.getElementsByTagName('head')[0].querySelector('style[id="react-tooltip"]')) {
        var tag = document.createElement('style');
        tag.id = 'react-tooltip';
        tag.innerHTML = _style2.default;
        document.getElementsByTagName('head')[0].appendChild(tag);
      }
    }

    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state4 = this.state,
          placeholder = _state4.placeholder,
          extraClass = _state4.extraClass,
          html = _state4.html,
          ariaProps = _state4.ariaProps,
          disable = _state4.disable,
          isEmptyTip = _state4.isEmptyTip;

      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });

      var Wrapper = this.props.wrapper;
      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      if (html) {
        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass
        }, ariaProps, {
          'data-id': 'tooltip',
          dangerouslySetInnerHTML: { __html: placeholder } }));
      } else {
        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass
        }, ariaProps, {
          'data-id': 'tooltip' }), placeholder);
      }
    }
  }]);

  return ReactTooltip;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.any,
  place: _propTypes2.default.string,
  type: _propTypes2.default.string,
  effect: _propTypes2.default.string,
  offset: _propTypes2.default.object,
  multiline: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  insecure: _propTypes2.default.bool,
  class: _propTypes2.default.string,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  html: _propTypes2.default.bool,
  delayHide: _propTypes2.default.number,
  delayShow: _propTypes2.default.number,
  event: _propTypes2.default.string,
  eventOff: _propTypes2.default.string,
  watchWindow: _propTypes2.default.bool,
  isCapture: _propTypes2.default.bool,
  globalEventOff: _propTypes2.default.string,
  getContent: _propTypes2.default.any,
  afterShow: _propTypes2.default.func,
  afterHide: _propTypes2.default.func,
  disable: _propTypes2.default.bool,
  scrollHide: _propTypes2.default.bool,
  resizeHide: _propTypes2.default.bool,
  wrapper: _propTypes2.default.string
}, _class2.defaultProps = {
  insecure: true,
  resizeHide: true,
  wrapper: 'div'
}, _class2.supportedWrappers = ['div', 'span'], _temp)) || _class) || _class) || _class) || _class) || _class) || _class;

/* export default not fit for standalone, it will exports {default:...} */

module.exports = ReactTooltip;

/***/ }),

/***/ "X5xa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return css; });
/* unused harmony export keyframes */
/* unused harmony export injectGlobal */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__("6dK+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__("YOxv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_function__ = __webpack_require__("xIVz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_function___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_is_function__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__("2DKW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);







/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

//      
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) return [].concat(ruleSet, flatten(chunk, executionContext));

    /* Handle other components */
    // $FlowFixMe not sure how to make this pass
    if (chunk.hasOwnProperty('styledComponentId')) return [].concat(ruleSet, ['.' + chunk.styledComponentId]);

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    // $FlowFixMe have to add %checks somehow to isPlainObject
    return ruleSet.concat(__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

//      
var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: true
});

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

//      
var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
var charsLength = chars.length;

/* Some high number, usually 9-digit base-10. Map it to base-😎 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = chars[x % charsLength] + name;
  }

  return chars[x % charsLength] + name;
};

//      


var interleave = function interleave(strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
};

//      
var css = function css(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  return flatten(interleave(strings, interpolations));
};

//      
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//mg;

var extractCompsFromCSS = function extractCompsFromCSS(maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
};

//      
/* eslint-disable camelcase, no-undef */

var getNonce = function getNonce() {
  return  true ? __webpack_require__.nc : null;
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

//      
/* eslint-disable no-underscore-dangle */
/*
 * Browser Style Sheet with Rehydration
 *
 * <style data-styled-components="x y z"
 *        data-styled-components-is-local="true">
 *   /· sc-component-id: a ·/
 *   .sc-a { ... }
 *   .x { ... }
 *   /· sc-component-id: b ·/
 *   .sc-b { ... }
 *   .y { ... }
 *   .z { ... }
 * </style>
 *
 * Note: replace · with * in the above snippet.
 * */
var COMPONENTS_PER_TAG = 40;

var BrowserTag = function () {
  function BrowserTag(el, isLocal) {
    var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    classCallCheck(this, BrowserTag);

    this.el = el;
    this.isLocal = isLocal;
    this.ready = false;

    var extractedComps = extractCompsFromCSS(existingSource);

    this.size = extractedComps.length;
    this.components = extractedComps.reduce(function (acc, obj) {
      acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
      return acc;
    }, {});
  }

  BrowserTag.prototype.isFull = function isFull() {
    return this.size >= COMPONENTS_PER_TAG;
  };

  BrowserTag.prototype.addComponent = function addComponent(componentId) {
    if (!this.ready) this.replaceElement();
    if (this.components[componentId]) throw new Error('Trying to add Component \'' + componentId + '\' twice!');

    var comp = { componentId: componentId, textNode: document.createTextNode('') };
    this.el.appendChild(comp.textNode);

    this.size += 1;
    this.components[componentId] = comp;
  };

  BrowserTag.prototype.inject = function inject(componentId, css, name) {
    if (!this.ready) this.replaceElement();
    var comp = this.components[componentId];

    if (!comp) throw new Error('Must add a new component before you can inject css into it');
    if (comp.textNode.data === '') comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');

    comp.textNode.appendData(css);
    if (name) {
      var existingNames = this.el.getAttribute(SC_ATTR);
      this.el.setAttribute(SC_ATTR, existingNames ? existingNames + ' ' + name : name);
    }

    var nonce = getNonce();

    if (nonce) {
      this.el.setAttribute('nonce', nonce);
    }
  };

  BrowserTag.prototype.toHTML = function toHTML() {
    return this.el.outerHTML;
  };

  BrowserTag.prototype.toReactElement = function toReactElement() {
    throw new Error('BrowserTag doesn\'t implement toReactElement!');
  };

  BrowserTag.prototype.clone = function clone() {
    throw new Error('BrowserTag cannot be cloned!');
  };

  /* Because we care about source order, before we can inject anything we need to
   * create a text node for each component and replace the existing CSS. */

  BrowserTag.prototype.replaceElement = function replaceElement() {
    var _this = this;

    this.ready = true;
    // We have nothing to inject. Use the current el.
    if (this.size === 0) return;

    // Build up our replacement style tag
    var newEl = this.el.cloneNode();
    newEl.appendChild(document.createTextNode('\n'));

    Object.keys(this.components).forEach(function (key) {
      var comp = _this.components[key];

      // eslint-disable-next-line no-param-reassign
      comp.textNode = document.createTextNode(comp.cssFromDOM);
      newEl.appendChild(comp.textNode);
    });

    if (!this.el.parentNode) throw new Error("Trying to replace an element that wasn't mounted!");

    // The ol' switcheroo
    this.el.parentNode.replaceChild(newEl, this.el);
    this.el = newEl;
  };

  return BrowserTag;
}();

/* Factory function to separate DOM operations from logical ones*/

var BrowserStyleSheet = {
  create: function create() {
    var tags = [];
    var names = {};

    /* Construct existing state from DOM */
    var nodes = document.querySelectorAll('[' + SC_ATTR + ']');
    var nodesLength = nodes.length;

    for (var i = 0; i < nodesLength; i += 1) {
      var el = nodes[i];

      tags.push(new BrowserTag(el, el.getAttribute(LOCAL_ATTR) === 'true', el.innerHTML));

      var attr = el.getAttribute(SC_ATTR);
      if (attr) {
        attr.trim().split(/\s+/).forEach(function (name) {
          names[name] = true;
        });
      }
    }

    /* Factory for making more tags */
    var tagConstructor = function tagConstructor(isLocal) {
      var el = document.createElement('style');
      el.type = 'text/css';
      el.setAttribute(SC_ATTR, '');
      el.setAttribute(LOCAL_ATTR, isLocal ? 'true' : 'false');
      if (!document.head) throw new Error('Missing document <head>');
      document.head.appendChild(el);
      return new BrowserTag(el, isLocal);
    };

    return new StyleSheet(tagConstructor, tags, names);
  }
};

//      
var SC_ATTR = 'data-styled-components';
var LOCAL_ATTR = 'data-styled-components-is-local';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var instance = null;
// eslint-disable-next-line no-use-before-define
var clones = [];

var StyleSheet = function () {
  function StyleSheet(tagConstructor) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, StyleSheet);
    this.hashes = {};
    this.deferredInjections = {};

    this.tagConstructor = tagConstructor;
    this.tags = tags;
    this.names = names;
    this.constructComponentTagMap();
  }

  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
    var _this = this;

    this.componentTags = {};

    this.tags.forEach(function (tag) {
      Object.keys(tag.components).forEach(function (componentId) {
        _this.componentTags[componentId] = tag;
      });
    });
  };

  /* Best level of caching—get the name from the hash straight away. */

  StyleSheet.prototype.getName = function getName(hash) {
    return this.hashes[hash.toString()];
  };

  /* Second level of caching—if the name is already in the dom, don't
   * inject anything and record the hash for getName next time. */

  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
    if (!this.names[name]) return false;

    this.hashes[hash.toString()] = name;
    return true;
  };

  /* Third type of caching—don't inject components' componentId twice. */

  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
    return !!this.componentTags[componentId];
  };

  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.deferredInject(componentId, isLocal, css);
      });
    }

    this.getOrCreateTag(componentId, isLocal);
    this.deferredInjections[componentId] = css;
  };

  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.inject(componentId, isLocal, css);
      });
    }

    var tag = this.getOrCreateTag(componentId, isLocal);

    var deferredInjection = this.deferredInjections[componentId];
    if (deferredInjection) {
      tag.inject(componentId, deferredInjection);
      delete this.deferredInjections[componentId];
    }

    tag.inject(componentId, css, name);

    if (hash && name) {
      this.hashes[hash.toString()] = name;
    }
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    return this.tags.map(function (tag, i) {
      return tag.toReactElement('sc-' + i);
    });
  };

  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
    var existingTag = this.componentTags[componentId];
    if (existingTag) {
      return existingTag;
    }

    var lastTag = this.tags[this.tags.length - 1];
    var componentTag = !lastTag || lastTag.isFull() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
    this.componentTags[componentId] = componentTag;
    componentTag.addComponent(componentId);
    return componentTag;
  };

  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
    var newTag = this.tagConstructor(isLocal);
    this.tags.push(newTag);
    return newTag;
  };

  StyleSheet.reset = function reset(isServer) {
    instance = StyleSheet.create(isServer);
  };

  /* We can make isServer totally implicit once Jest 20 drops and we
   * can change environment on a per-test basis. */

  StyleSheet.create = function create() {
    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof document === 'undefined';

    return (isServer ? ServerStyleSheet : BrowserStyleSheet).create();
  };

  StyleSheet.clone = function clone(oldSheet) {
    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
      return tag.clone();
    }), _extends({}, oldSheet.names));

    newSheet.hashes = _extends({}, oldSheet.hashes);
    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
    clones.push(newSheet);

    return newSheet;
  };

  createClass(StyleSheet, null, [{
    key: 'instance',
    get: function get$$1() {
      return instance || (instance = StyleSheet.create());
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

//      
var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.props.sheet, _ref;
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_2_react__["default"].Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet).isRequired, _StyleSheetManager$ch);

StyleSheetManager.propTypes = {
  sheet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet).isRequired
};

//      
/* eslint-disable no-underscore-dangle */
var ServerTag = function () {
  function ServerTag(isLocal) {
    classCallCheck(this, ServerTag);

    this.isLocal = isLocal;
    this.components = {};
    this.size = 0;
    this.names = [];
  }

  ServerTag.prototype.isFull = function isFull() {
    return false;
  };

  ServerTag.prototype.addComponent = function addComponent(componentId) {
    if (this.components[componentId]) throw new Error('Trying to add Component \'' + componentId + '\' twice!');
    this.components[componentId] = { componentId: componentId, css: '' };
    this.size += 1;
  };

  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
    var _this = this;

    return Object.keys(this.components).reduce(function (styles, k) {
      return styles + _this.components[k].css;
    }, '');
  };

  ServerTag.prototype.inject = function inject(componentId, css, name) {
    var comp = this.components[componentId];

    if (!comp) throw new Error('Must add a new component before you can inject css into it');
    if (comp.css === '') comp.css = '/* sc-component-id: ' + componentId + ' */\n';

    comp.css += css.replace(/\n*$/, '\n');

    if (name) this.names.push(name);
  };

  ServerTag.prototype.toHTML = function toHTML() {
    var attrs = ['type="text/css"', SC_ATTR + '="' + this.names.join(' ') + '"', LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];

    var nonce = getNonce();

    if (nonce) {
      attrs.push('nonce="' + nonce + '"');
    }

    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
  };

  ServerTag.prototype.toReactElement = function toReactElement(key) {
    var _attrs;

    var attrs = (_attrs = {}, _attrs[SC_ATTR] = this.names.join(' '), _attrs[LOCAL_ATTR] = this.isLocal.toString(), _attrs);

    var nonce = getNonce();

    if (nonce) {
      attrs.nonce = nonce;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react__["default"].createElement('style', _extends({
      key: key, type: 'text/css' }, attrs, {
      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
    }));
  };

  ServerTag.prototype.clone = function clone() {
    var _this2 = this;

    var copy = new ServerTag(this.isLocal);
    copy.names = [].concat(this.names);
    copy.size = this.size;
    copy.components = Object.keys(this.components).reduce(function (acc, key) {
      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
      return acc;
    }, {});

    return copy;
  };

  return ServerTag;
}();

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    this.instance = StyleSheet.clone(StyleSheet.instance);
  }

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) throw new Error("Can't collect styles once you've called getStyleTags!");
    return __WEBPACK_IMPORTED_MODULE_2_react__["default"].createElement(StyleSheetManager, { sheet: this.instance }, children);
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toReactElements();
  };

  ServerStyleSheet.create = function create() {
    return new StyleSheet(function (isLocal) {
      return new ServerTag(isLocal);
    });
  };

  return ServerStyleSheet;
}();

//      

var LIMIT = 200;

var createWarnTooManyClasses = function createWarnTooManyClasses(displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. ' + 'Consider using style property for frequently changed styles.\n' + 'Example:\n' + '  const StyledComp = styled.div`width: 100%;`\n' + '  <StyledComp style={{ background: background }} />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
};

//      
/* Trying to avoid the unknown-prop errors on styled components
 by filtering by React's attribute whitelist.
 */

/* Logic copied from ReactDOMUnknownPropertyHook */
var reactProps = {
  children: true,
  dangerouslySetInnerHTML: true,
  key: true,
  ref: true,
  autoFocus: true,
  defaultValue: true,
  valueLink: true,
  defaultChecked: true,
  checkedLink: true,
  innerHTML: true,
  suppressContentEditableWarning: true,
  onFocusIn: true,
  onFocusOut: true,
  className: true,

  /* List copied from https://facebook.github.io/react/docs/events.html */
  onCopy: true,
  onCut: true,
  onPaste: true,
  onCompositionEnd: true,
  onCompositionStart: true,
  onCompositionUpdate: true,
  onKeyDown: true,
  onKeyPress: true,
  onKeyUp: true,
  onFocus: true,
  onBlur: true,
  onChange: true,
  onInput: true,
  onSubmit: true,
  onClick: true,
  onContextMenu: true,
  onDoubleClick: true,
  onDrag: true,
  onDragEnd: true,
  onDragEnter: true,
  onDragExit: true,
  onDragLeave: true,
  onDragOver: true,
  onDragStart: true,
  onDrop: true,
  onMouseDown: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseMove: true,
  onMouseOut: true,
  onMouseOver: true,
  onMouseUp: true,
  onSelect: true,
  onTouchCancel: true,
  onTouchEnd: true,
  onTouchMove: true,
  onTouchStart: true,
  onScroll: true,
  onWheel: true,
  onAbort: true,
  onCanPlay: true,
  onCanPlayThrough: true,
  onDurationChange: true,
  onEmptied: true,
  onEncrypted: true,
  onEnded: true,
  onError: true,
  onLoadedData: true,
  onLoadedMetadata: true,
  onLoadStart: true,
  onPause: true,
  onPlay: true,
  onPlaying: true,
  onProgress: true,
  onRateChange: true,
  onSeeked: true,
  onSeeking: true,
  onStalled: true,
  onSuspend: true,
  onTimeUpdate: true,
  onVolumeChange: true,
  onWaiting: true,
  onLoad: true,
  onAnimationStart: true,
  onAnimationEnd: true,
  onAnimationIteration: true,
  onTransitionEnd: true,

  onCopyCapture: true,
  onCutCapture: true,
  onPasteCapture: true,
  onCompositionEndCapture: true,
  onCompositionStartCapture: true,
  onCompositionUpdateCapture: true,
  onKeyDownCapture: true,
  onKeyPressCapture: true,
  onKeyUpCapture: true,
  onFocusCapture: true,
  onBlurCapture: true,
  onChangeCapture: true,
  onInputCapture: true,
  onSubmitCapture: true,
  onClickCapture: true,
  onContextMenuCapture: true,
  onDoubleClickCapture: true,
  onDragCapture: true,
  onDragEndCapture: true,
  onDragEnterCapture: true,
  onDragExitCapture: true,
  onDragLeaveCapture: true,
  onDragOverCapture: true,
  onDragStartCapture: true,
  onDropCapture: true,
  onMouseDownCapture: true,
  onMouseEnterCapture: true,
  onMouseLeaveCapture: true,
  onMouseMoveCapture: true,
  onMouseOutCapture: true,
  onMouseOverCapture: true,
  onMouseUpCapture: true,
  onSelectCapture: true,
  onTouchCancelCapture: true,
  onTouchEndCapture: true,
  onTouchMoveCapture: true,
  onTouchStartCapture: true,
  onScrollCapture: true,
  onWheelCapture: true,
  onAbortCapture: true,
  onCanPlayCapture: true,
  onCanPlayThroughCapture: true,
  onDurationChangeCapture: true,
  onEmptiedCapture: true,
  onEncryptedCapture: true,
  onEndedCapture: true,
  onErrorCapture: true,
  onLoadedDataCapture: true,
  onLoadedMetadataCapture: true,
  onLoadStartCapture: true,
  onPauseCapture: true,
  onPlayCapture: true,
  onPlayingCapture: true,
  onProgressCapture: true,
  onRateChangeCapture: true,
  onSeekedCapture: true,
  onSeekingCapture: true,
  onStalledCapture: true,
  onSuspendCapture: true,
  onTimeUpdateCapture: true,
  onVolumeChangeCapture: true,
  onWaitingCapture: true,
  onLoadCapture: true,
  onAnimationStartCapture: true,
  onAnimationEndCapture: true,
  onAnimationIterationCapture: true,
  onTransitionEndCapture: true
};

/* From HTMLDOMPropertyConfig */
var htmlProps = {
  /**
   * Standard Properties
   */
  accept: true,
  acceptCharset: true,
  accessKey: true,
  action: true,
  allowFullScreen: true,
  allowTransparency: true,
  alt: true,
  // specifies target context for links with `preload` type
  as: true,
  async: true,
  autoComplete: true,
  // autoFocus is polyfilled/normalized by AutoFocusUtils
  // autoFocus: true,
  autoPlay: true,
  capture: true,
  cellPadding: true,
  cellSpacing: true,
  charSet: true,
  challenge: true,
  checked: true,
  cite: true,
  classID: true,
  className: true,
  cols: true,
  colSpan: true,
  content: true,
  contentEditable: true,
  contextMenu: true,
  controls: true,
  coords: true,
  crossOrigin: true,
  data: true, // For `<object />` acts as `src`.
  dateTime: true,
  default: true,
  defer: true,
  dir: true,
  disabled: true,
  download: true,
  draggable: true,
  encType: true,
  form: true,
  formAction: true,
  formEncType: true,
  formMethod: true,
  formNoValidate: true,
  formTarget: true,
  frameBorder: true,
  headers: true,
  height: true,
  hidden: true,
  high: true,
  href: true,
  hrefLang: true,
  htmlFor: true,
  httpEquiv: true,
  icon: true,
  id: true,
  inputMode: true,
  integrity: true,
  is: true,
  keyParams: true,
  keyType: true,
  kind: true,
  label: true,
  lang: true,
  list: true,
  loop: true,
  low: true,
  manifest: true,
  marginHeight: true,
  marginWidth: true,
  max: true,
  maxLength: true,
  media: true,
  mediaGroup: true,
  method: true,
  min: true,
  minLength: true,
  // Caution; `option.selected` is not updated if `select.multiple` is
  // disabled with `removeAttribute`.
  multiple: true,
  muted: true,
  name: true,
  nonce: true,
  noValidate: true,
  open: true,
  optimum: true,
  pattern: true,
  placeholder: true,
  playsInline: true,
  poster: true,
  preload: true,
  profile: true,
  radioGroup: true,
  readOnly: true,
  referrerPolicy: true,
  rel: true,
  required: true,
  reversed: true,
  role: true,
  rows: true,
  rowSpan: true,
  sandbox: true,
  scope: true,
  scoped: true,
  scrolling: true,
  seamless: true,
  selected: true,
  shape: true,
  size: true,
  sizes: true,
  span: true,
  spellCheck: true,
  src: true,
  srcDoc: true,
  srcLang: true,
  srcSet: true,
  start: true,
  step: true,
  style: true,
  summary: true,
  tabIndex: true,
  target: true,
  title: true,
  // Setting .type throws on non-<input> tags
  type: true,
  useMap: true,
  value: true,
  width: true,
  wmode: true,
  wrap: true,

  /**
   * RDFa Properties
   */
  about: true,
  datatype: true,
  inlist: true,
  prefix: true,
  // property is also supported for OpenGraph in meta tags.
  property: true,
  resource: true,
  typeof: true,
  vocab: true,

  /**
   * Non-standard Properties
   */
  // autoCapitalize and autoCorrect are supported in Mobile Safari for
  // keyboard hints.
  autoCapitalize: true,
  autoCorrect: true,
  // autoSave allows WebKit/Blink to persist values of input fields on page reloads
  autoSave: true,
  // color is for Safari mask-icon link
  color: true,
  // itemProp, itemScope, itemType are for
  // Microdata support. See http://schema.org/docs/gs.html
  itemProp: true,
  itemScope: true,
  itemType: true,
  // itemID and itemRef are for Microdata support as well but
  // only specified in the WHATWG spec document. See
  // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
  itemID: true,
  itemRef: true,
  // results show looking glass icon and recent searches on input
  // search fields in WebKit/Blink
  results: true,
  // IE-only attribute that specifies security restrictions on an iframe
  // as an alternative to the sandbox attribute on IE<10
  security: true,
  // IE-only attribute that controls focus behavior
  unselectable: 0
};

var svgProps = {
  accentHeight: true,
  accumulate: true,
  additive: true,
  alignmentBaseline: true,
  allowReorder: true,
  alphabetic: true,
  amplitude: true,
  arabicForm: true,
  ascent: true,
  attributeName: true,
  attributeType: true,
  autoReverse: true,
  azimuth: true,
  baseFrequency: true,
  baseProfile: true,
  baselineShift: true,
  bbox: true,
  begin: true,
  bias: true,
  by: true,
  calcMode: true,
  capHeight: true,
  clip: true,
  clipPath: true,
  clipRule: true,
  clipPathUnits: true,
  colorInterpolation: true,
  colorInterpolationFilters: true,
  colorProfile: true,
  colorRendering: true,
  contentScriptType: true,
  contentStyleType: true,
  cursor: true,
  cx: true,
  cy: true,
  d: true,
  decelerate: true,
  descent: true,
  diffuseConstant: true,
  direction: true,
  display: true,
  divisor: true,
  dominantBaseline: true,
  dur: true,
  dx: true,
  dy: true,
  edgeMode: true,
  elevation: true,
  enableBackground: true,
  end: true,
  exponent: true,
  externalResourcesRequired: true,
  fill: true,
  fillOpacity: true,
  fillRule: true,
  filter: true,
  filterRes: true,
  filterUnits: true,
  floodColor: true,
  floodOpacity: true,
  focusable: true,
  fontFamily: true,
  fontSize: true,
  fontSizeAdjust: true,
  fontStretch: true,
  fontStyle: true,
  fontVariant: true,
  fontWeight: true,
  format: true,
  from: true,
  fx: true,
  fy: true,
  g1: true,
  g2: true,
  glyphName: true,
  glyphOrientationHorizontal: true,
  glyphOrientationVertical: true,
  glyphRef: true,
  gradientTransform: true,
  gradientUnits: true,
  hanging: true,
  horizAdvX: true,
  horizOriginX: true,
  ideographic: true,
  imageRendering: true,
  in: true,
  in2: true,
  intercept: true,
  k: true,
  k1: true,
  k2: true,
  k3: true,
  k4: true,
  kernelMatrix: true,
  kernelUnitLength: true,
  kerning: true,
  keyPoints: true,
  keySplines: true,
  keyTimes: true,
  lengthAdjust: true,
  letterSpacing: true,
  lightingColor: true,
  limitingConeAngle: true,
  local: true,
  markerEnd: true,
  markerMid: true,
  markerStart: true,
  markerHeight: true,
  markerUnits: true,
  markerWidth: true,
  mask: true,
  maskContentUnits: true,
  maskUnits: true,
  mathematical: true,
  mode: true,
  numOctaves: true,
  offset: true,
  opacity: true,
  operator: true,
  order: true,
  orient: true,
  orientation: true,
  origin: true,
  overflow: true,
  overlinePosition: true,
  overlineThickness: true,
  paintOrder: true,
  panose1: true,
  pathLength: true,
  patternContentUnits: true,
  patternTransform: true,
  patternUnits: true,
  pointerEvents: true,
  points: true,
  pointsAtX: true,
  pointsAtY: true,
  pointsAtZ: true,
  preserveAlpha: true,
  preserveAspectRatio: true,
  primitiveUnits: true,
  r: true,
  radius: true,
  refX: true,
  refY: true,
  renderingIntent: true,
  repeatCount: true,
  repeatDur: true,
  requiredExtensions: true,
  requiredFeatures: true,
  restart: true,
  result: true,
  rotate: true,
  rx: true,
  ry: true,
  scale: true,
  seed: true,
  shapeRendering: true,
  slope: true,
  spacing: true,
  specularConstant: true,
  specularExponent: true,
  speed: true,
  spreadMethod: true,
  startOffset: true,
  stdDeviation: true,
  stemh: true,
  stemv: true,
  stitchTiles: true,
  stopColor: true,
  stopOpacity: true,
  strikethroughPosition: true,
  strikethroughThickness: true,
  string: true,
  stroke: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeLinecap: true,
  strokeLinejoin: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true,
  surfaceScale: true,
  systemLanguage: true,
  tableValues: true,
  targetX: true,
  targetY: true,
  textAnchor: true,
  textDecoration: true,
  textRendering: true,
  textLength: true,
  to: true,
  transform: true,
  u1: true,
  u2: true,
  underlinePosition: true,
  underlineThickness: true,
  unicode: true,
  unicodeBidi: true,
  unicodeRange: true,
  unitsPerEm: true,
  vAlphabetic: true,
  vHanging: true,
  vIdeographic: true,
  vMathematical: true,
  values: true,
  vectorEffect: true,
  version: true,
  vertAdvY: true,
  vertOriginX: true,
  vertOriginY: true,
  viewBox: true,
  viewTarget: true,
  visibility: true,
  widths: true,
  wordSpacing: true,
  writingMode: true,
  x: true,
  xHeight: true,
  x1: true,
  x2: true,
  xChannelSelector: true,
  xlinkActuate: true,
  xlinkArcrole: true,
  xlinkHref: true,
  xlinkRole: true,
  xlinkShow: true,
  xlinkTitle: true,
  xlinkType: true,
  xmlBase: true,
  xmlns: true,
  xmlnsXlink: true,
  xmlLang: true,
  xmlSpace: true,
  y: true,
  y1: true,
  y2: true,
  yChannelSelector: true,
  z: true,
  zoomAndPan: true
};

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var hasOwnProperty = {}.hasOwnProperty;
var validAttr = function validAttr(name) {
  return hasOwnProperty.call(htmlProps, name) || hasOwnProperty.call(svgProps, name) || isCustomAttribute(name.toLowerCase()) || hasOwnProperty.call(reactProps, name);
};

//      


function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

//      


function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

//      

/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

//      
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

//      
// Helper to call a given function, only once
var once = function once(cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
};

var _ThemeProvider$childC;
var _ThemeProvider$contex;

//      
/* globals React$Element */
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});

var warnChannelDeprecated = once(function () {
  // eslint-disable-next-line no-console
  console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
});
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;
      });
    }
    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      warnChannelDeprecated();

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) this.broadcast.publish(this.getTheme(nextProps.theme));
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (__WEBPACK_IMPORTED_MODULE_4_is_function___default()(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(mergedTheme)) {
        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
      }
      return mergedTheme;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(theme)) {
      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_2_react__["default"].Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

//      

var escapeRegex = /[[\].#*$><+~=|^:(),"'`]/g;
var multiDashRegex = /--+/g;

var _StyledComponent = function _StyledComponent(ComponentStyle, constructWithOptions) {
  /* We depend on components having unique IDs */
  var identifiers = {};
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : _displayName.replace(escapeRegex, '-') // Replace all possible CSS selectors
    .replace(multiDashRegex, '-'); // Replace multiple -- with single -

    var nr = (identifiers[displayName] || 0) + 1;
    identifiers[displayName] = nr;

    var hash = ComponentStyle.generateName(displayName + nr);
    var componentId = displayName + '-' + hash;
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  var BaseStyledComponent = function (_Component) {
    inherits(BaseStyledComponent, _Component);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var executionContext = this.buildExecutionContext(theme, props);
      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.instance;
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (warnTooManyClasses !== undefined) warnTooManyClasses(className);

      return className;
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
      var styledContext = this.context[CHANNEL_NEXT];
      if (styledContext !== undefined) {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          // This will be called once immediately

          // Props should take precedence over ThemeProvider, which should take precedence over
          // defaultProps, but React automatically puts defaultProps on props.
          var defaultProps = _this2.constructor.defaultProps;
          /* eslint-disable react/prop-types */

          var isDefaultTheme = defaultProps && _this2.props.theme === defaultProps.theme;
          var theme = _this2.props.theme && !isDefaultTheme ? _this2.props.theme : nextTheme;
          /* eslint-enable */
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        // eslint-disable-next-line react/prop-types
        var theme = this.props.theme || {};
        var generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.setState(function (oldState) {
        // Props should take precedence over ThemeProvider, which should take precedence over
        // defaultProps, but React automatically puts defaultProps on props.
        var defaultProps = _this3.constructor.defaultProps;
        /* eslint-disable react/prop-types */

        var isDefaultTheme = defaultProps && nextProps.theme === defaultProps.theme;
        var theme = nextProps.theme && !isDefaultTheme ? nextProps.theme : oldState.theme;
        /* eslint-enable */
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromContext();
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;

      var isTargetTag = isTag(target);

      var className = [
      // eslint-disable-next-line react/prop-types
      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')' : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;

    var styledComponentId = options.displayName && options.componentId ? options.displayName + '-' + options.componentId : componentId;

    var warnTooManyClasses = void 0;
    if (false) {
      warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);

        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : getComponentName(tag));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);

          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), _StyledComponent$cont);
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.warnTooManyClasses = warnTooManyClasses;
    StyledComponent.target = target;

    return StyledComponent;
  };

  return createStyledComponent;
};

// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

//      
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = function _ComponentStyle(nameGenerator, flatten, stringifyRules) {
  var ComponentStyle = function () {
    function ComponentStyle(rules, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.componentId = componentId;
      if (!StyleSheet.instance.hasInjectedComponent(this.componentId)) {
        var placeholder =  false ? '.' + componentId + ' {}' : '';
        StyleSheet.instance.deferredInject(componentId, true, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */

    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var flatCSS = flatten(this.rules, executionContext);
      var hash = doHash(this.componentId + flatCSS.join(''));

      var existingName = styleSheet.getName(hash);
      if (existingName) return existingName;

      var name = nameGenerator(hash);
      if (styleSheet.alreadyInjected(hash, name)) return name;

      var css = '\n' + stringifyRules(flatCSS, '.' + name);
      styleSheet.inject(this.componentId, true, css, hash, name);
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return nameGenerator(doHash(str));
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
};

//      
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

//      

var _styled = function _styled(styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
};

//      
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = function _keyframes(nameGenerator, stringifyRules, css) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(replaceWhitespace(JSON.stringify(rules)));

    var existingName = StyleSheet.instance.getName(hash);
    if (existingName) return existingName;

    var name = nameGenerator(hash);
    if (StyleSheet.instance.alreadyInjected(hash, name)) return name;

    var generatedCSS = stringifyRules(rules, name, '@keyframes');
    StyleSheet.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
    return name;
  };
};

//      
var _injectGlobal = function _injectGlobal(stringifyRules, css) {
  var injectGlobal = function injectGlobal(strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(JSON.stringify(rules));

    var componentId = 'sc-global-' + hash;
    if (StyleSheet.instance.hasInjectedComponent(componentId)) return;

    StyleSheet.instance.inject(componentId, false, stringifyRules(rules));
  };

  return injectGlobal;
};

//      


var _constructWithOptions = function _constructWithOptions(css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (typeof tag !== 'string' && typeof tag !== 'function') {
      // $FlowInvalidInputTest
      throw new Error('Cannot create styled-component for component: ' + tag);
    }

    /* This is callable directly as a template function */
    var templateFunction = function templateFunction(strings) {
      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }

      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs) }));
    };

    return templateFunction;
  };

  return constructWithOptions;
};

//      
/* globals ReactClass */

var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';

  var isStyledComponent$$1 = isStyledComponent(Component$$1);

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var styledContext = this.context[CHANNEL_NEXT];
      if (styledContext === undefined) {
        // eslint-disable-next-line no-console
        console.error('[withTheme] Please use ThemeProvider to be able to use withTheme');
        return;
      }

      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (theme) {
        _this2.setState({ theme: theme });
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var theme = this.state.theme;

      return __WEBPACK_IMPORTED_MODULE_2_react__["default"].createElement(Component$$1, _extends({
        theme: theme
      }, this.props, {
        innerRef: isStyledComponent$$1 ? innerRef : undefined,
        ref: isStyledComponent$$1 ? undefined : innerRef
      }));
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_2_react__["default"].Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);

  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

//      

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["a"] = (styled);

/***/ }),

/***/ "XkNw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("X5xa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media__ = __webpack_require__("s647");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flag_en_png__ = __webpack_require__("DVzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flag_en_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flag_en_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  left: 0;\n  line-height: 42px;\n  width: 60px;\n  opacity: 0;\n  pointer-events: none;\n  width: 60px;\n  text-align: center;\n'], ['\n  position: absolute;\n  left: 0;\n  line-height: 42px;\n  width: 60px;\n  opacity: 0;\n  pointer-events: none;\n  width: 60px;\n  text-align: center;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  right: 0;\n  top: 22px;\n  z-index: 3000;\n  background: #039 url(', ') right 0 no-repeat;\n  width: 42px;\n  height: 42px;\n  color: white;\n\n  :hover {\n    width: 100px;\n    background-position: right -42px;\n  }\n\n  :hover ', ' {\n    opacity: 1;\n    pointer-events: all;\n  }\n\n  ', ';\n'], ['\n  position: fixed;\n  right: 0;\n  top: 22px;\n  z-index: 3000;\n  background: #039 url(', ') right 0 no-repeat;\n  width: 42px;\n  height: 42px;\n  color: white;\n\n  :hover {\n    width: 100px;\n    background-position: right -42px;\n  }\n\n  :hover ', ' {\n    opacity: 1;\n    pointer-events: all;\n  }\n\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }






var EnText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */])(function (p) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    p,
    'EN'
  );
})(_templateObject);

var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(EnText, null);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */])(function (_Component) {
  _inherits(LanguageSwitcher, _Component);

  function LanguageSwitcher() {
    _classCallCheck(this, LanguageSwitcher);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  LanguageSwitcher.prototype.render = function render() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      _extends({ href: '/en' }, this.props),
      _ref
    );
  };

  return LanguageSwitcher;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]))(_templateObject2, __WEBPACK_IMPORTED_MODULE_3__flag_en_png___default.a, EnText, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__media__["a" /* screenLessThan930 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(_templateObject3))));

/***/ }),

/***/ "Xoaw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Link = function Link(props, context) {
  var other = _extends({}, props);
  delete other.localhref;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'a',
    _extends({}, other, { // pass other properties
      href: function () {
        if (props.directhref) return props.directhref;
        if (!context.hostname) return props.href;
        if (/:\/\//.exec(props.href)) return props.href;
        if (props.localhref) return context.hostname + props.localhref;
        return context.hostname + '/' + props.href;
      }()
    }),
    props.children
  );
};

Link.contextTypes = {
  hostname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),

/***/ "YOxv":
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {
	/* eslint-disable */
	 true ? module['exports'] = factory(null) : typeof define === 'function' && define['amd'] ? define(factory(null)) : window['stylis'] = factory(null);
})( /** @param {*=} options */function factory(options) {
	/* eslint-disable */

	'use strict';

	/**
  * Notes
  *
  * The ['<method name>'] pattern is used to support closure compiler
  * the jsdoc signatures are also used to the same effect
  *
  * ---- 
  *
  * int + int + int === n4 [faster]
  *
  * vs
  *
  * int === n1 && int === n2 && int === n3
  *
  * ----
  *
  * switch (int) { case ints...} [faster]
  *
  * vs
  *
  * if (int == 1 && int === 2 ...)
  *
  * ----
  *
  * The (first*n1 + second*n2 + third*n3) format used in the property parser
  * is a simple way to hash the sequence of characters
  * taking into account the index they occur in
  * since any number of 3 character sequences could produce duplicates.
  *
  * On the other hand sequences that are directly tied to the index of the character
  * resolve a far more accurate measure, it's also faster
  * to evaluate one condition in a switch statement
  * than three in an if statement regardless of the added math.
  *
  * This allows the vendor prefixer to be both small and fast.
  */

	var nullptn = /^\0+/g; /* matches leading null characters */
	var formatptn = /[\0\r\f]/g; /* matches new line, null and formfeed characters */
	var colonptn = /: */g; /* splits animation rules */
	var cursorptn = /zoo|gra/; /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g; /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g; /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g; /* animation properties */
	var elementptn = / *[\0] */g; /* selector elements */
	var selectorptn = /,\r+?/g; /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g; /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g; /* matches :global(.*) */
	var invalidptn = /\W+/g; /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/; /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g; /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g; /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g; /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g; /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g; /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g; /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g; /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/; /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g; /* match *gradient property */
	var supportsptn = /\(\s*([^]*?)\s*\)/g; /* match supports (groups) */
	var propertyptn = /([^]*?);/g; /* match properties leading semicolon */
	var selfptn = /-self|flex-/g; /* match flex- and -self in align-self: flex-*; */

	/* vendors */
	var webkit = '-webkit-';
	var moz = '-moz-';
	var ms = '-ms-';

	/* character codes */
	var SEMICOLON = 59; /* ; */
	var CLOSEBRACES = 125; /* } */
	var OPENBRACES = 123; /* { */
	var OPENPARENTHESES = 40; /* ( */
	var CLOSEPARENTHESES = 41; /* ) */
	var OPENBRACKET = 91; /* [ */
	var CLOSEBRACKET = 93; /* ] */
	var NEWLINE = 10; /* \n */
	var CARRIAGE = 13; /* \r */
	var TAB = 9; /* \t */
	var AT = 64; /* @ */
	var SPACE = 32; /*   */
	var AND = 38; /* & */
	var DASH = 45; /* - */
	var UNDERSCORE = 95; /* _ */
	var STAR = 42; /* * */
	var COMMA = 44; /* , */
	var COLON = 58; /* : */
	var SINGLEQUOTE = 39; /* ' */
	var DOUBLEQUOTE = 34; /* " */
	var FOWARDSLASH = 47; /* / */
	var GREATERTHAN = 62; /* > */
	var PLUS = 43; /* + */
	var TILDE = 126; /* ~ */
	var NULL = 0; /* \0 */
	var FORMFEED = 12; /* \f */
	var VERTICALTAB = 11; /* \v */

	/* special identifiers */
	var KEYFRAME = 107; /* k */
	var MEDIA = 109; /* m */
	var SUPPORTS = 115; /* s */
	var PLACEHOLDER = 112; /* p */
	var READONLY = 111; /* o */
	var IMPORT = 169; /* <at>i */
	var CHARSET = 163; /* <at>c */
	var DOCUMENT = 100; /* <at>d */

	var column = 1; /* current column */
	var line = 1; /* current line numebr */
	var pattern = 0; /* :pattern */

	var cascade = 1; /* #id h1 h2 vs h1#id h2#id  */
	var vendor = 1; /* vendor prefix */
	var escape = 1; /* escape :global() pattern */
	var compress = 0; /* compress output */
	var semicolon = 0; /* no/semicolon option */
	var preserve = 0; /* preserve empty selectors */

	/* empty reference */
	var array = [];

	/* plugins */
	var plugins = [];
	var plugged = 0;

	/* plugin context */
	var POSTS = -2;
	var PREPS = -1;
	var UNKWN = 0;
	var PROPS = 1;
	var BLCKS = 2;
	var ATRUL = 3;

	/* plugin newline context */
	var unkwn = 0;

	/* keyframe animation */
	var keyed = 1;
	var key = '';

	/* selector namespace */
	var nscopealt = '';
	var nscope = '';

	/**
  * Compile
  *
  * @param {Array<string>} parent
  * @param {Array<string>} current
  * @param {string} body
  * @param {number} id
  * @return {string}
  */
	function compile(parent, current, body, id) {
		var bracket = 0; /* brackets [] */
		var comment = 0; /* comments /* // or /* */
		var parentheses = 0; /* functions () */
		var quote = 0; /* quotes '', "" */

		var first = 0; /* first character code */
		var second = 0; /* second character code */
		var code = 0; /* current character code */
		var tail = 0; /* previous character code */
		var trail = 0; /* character before previous code */
		var peak = 0; /* previous non-whitespace code */

		var counter = 0; /* count sequence termination */
		var context = 0; /* track current context */
		var atrule = 0; /* track @at-rule context */
		var pseudo = 0; /* track pseudo token index */
		var caret = 0; /* current character index */
		var format = 0; /* control character formating context */
		var insert = 0; /* auto semicolon insertion */
		var invert = 0; /* inverted selector pattern */
		var length = 0; /* generic length address */
		var eof = body.length; /* end of file(length) */
		var eol = eof - 1; /* end of file(characters) */

		var char = ''; /* current character */
		var chars = ''; /* current buffer of characters */
		var child = ''; /* next buffer of characters */
		var out = ''; /* compiled body */
		var children = ''; /* compiled children */
		var flat = ''; /* compiled leafs */
		var selector; /* generic selector address */
		var result; /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret);

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '');
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE:
								{
									break;
								}
							default:
								{
									chars += body.charAt(caret);
								}
						}

						code = SEMICOLON;
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case COMMA:
							{
								insert = 0;
								break;
							}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE:
							{
								break;
							}
						// valid
						default:
							{
								caret--;
								code = SEMICOLON;
							}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES:
						{
							chars = chars.trim();
							first = chars.charCodeAt(0);
							counter = 1;
							length = ++caret;

							while (caret < eof) {
								code = body.charCodeAt(caret);

								switch (code) {
									case OPENBRACES:
										{
											counter++;
											break;
										}
									case CLOSEBRACES:
										{
											counter--;
											break;
										}
								}

								if (counter === 0) {
									break;
								}

								caret++;
							}

							child = body.substring(length, caret);

							if (first === NULL) {
								first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
							}

							switch (first) {
								// @at-rule
								case AT:
									{
										if (format > 0) {
											chars = chars.replace(formatptn, '');
										}

										second = chars.charCodeAt(1);

										switch (second) {
											case DOCUMENT:
											case MEDIA:
											case SUPPORTS:
												{
													selector = current;
													break;
												}
											default:
												{
													selector = array;
												}
										}

										child = compile(current, selector, child, second);
										length = child.length;

										// preserve empty @at-rule
										if (preserve > 0 && length === 0) {
											length = chars.length;
										}

										// execute plugins, @at-rule context
										if (plugged > 0) {
											selector = select(array, chars, invert);
											result = proxy(ATRUL, child, selector, current, line, column, length, second);
											chars = selector.join('');

											if (result !== void 0) {
												if ((length = (child = result.trim()).length) === 0) {
													second = 0;
													child = '';
												}
											}
										}

										if (length > 0) {
											switch (second) {
												case SUPPORTS:
													{
														chars = chars.replace(supportsptn, supports);
													}
												case DOCUMENT:
												case MEDIA:
													{
														child = chars + '{' + child + '}';
														break;
													}
												case KEYFRAME:
													{
														chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
														child = chars + '{' + child + '}';
														child = '@' + (vendor > 0 ? webkit + child + '@' + child : child);
														break;
													}
												default:
													{
														child = chars + child;
													}
											}
										} else {
											child = '';
										}

										break;
									}
								// selector
								default:
									{
										child = compile(current, select(current, chars, invert), child, id);
									}
							}

							children += child;

							// reset
							context = 0;
							insert = 0;
							pseudo = 0;
							format = 0;
							invert = 0;
							atrule = 0;
							chars = '';
							child = '';
							code = body.charCodeAt(++caret);
							break;
						}
					case CLOSEBRACES:
					case SEMICOLON:
						{
							chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();

							if ((length = chars.length) > 1) {
								// monkey-patch missing colon
								if (pseudo === 0) {
									first = chars.charCodeAt(0);

									// first character is a letter or dash, buffer has a space character
									if (first === DASH || first > 96 && first < 123) {
										length = (chars = chars.replace(' ', ':')).length;
									}
								}

								// execute plugins, property context
								if (plugged > 0) {
									if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id)) !== void 0) {
										if ((length = (chars = result.trim()).length) === 0) {
											chars = '\0\0';
										}
									}
								}

								first = chars.charCodeAt(0);
								second = chars.charCodeAt(1);

								switch (first + second) {
									case NULL:
										{
											break;
										}
									case IMPORT:
									case CHARSET:
										{
											flat += chars + body.charAt(caret);
											break;
										}
									default:
										{
											if (chars.charCodeAt(length - 1) === COLON) break;

											out += property(chars, first, second, chars.charCodeAt(2));
										}
								}
							}

							// reset
							context = 0;
							insert = 0;
							pseudo = 0;
							format = 0;
							invert = 0;
							chars = '';
							code = body.charCodeAt(++caret);
							break;
						}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE:
					{
						// auto insert semicolon
						if (comment + quote + parentheses + bracket + semicolon === 0) {
							// valid non-whitespace characters that
							// may precede a newline
							switch (peak) {
								case CLOSEPARENTHESES:
								case SINGLEQUOTE:
								case DOUBLEQUOTE:
								case AT:
								case TILDE:
								case GREATERTHAN:
								case STAR:
								case PLUS:
								case FOWARDSLASH:
								case DASH:
								case COLON:
								case COMMA:
								case SEMICOLON:
								case OPENBRACES:
								case CLOSEBRACES:
									{
										break;
									}
								default:
									{
										// current buffer has a colon
										if (pseudo > 0) {
											insert = 1;
										}
									}
							}
						}

						// terminate line comment
						if (comment === FOWARDSLASH) {
							comment = 0;
						}

						// execute plugins, newline context
						if (plugged * unkwn > 0) {
							proxy(UNKWN, chars, current, parent, line, column, out.length, id);
						}

						// next line, reset column position
						column = 1;
						line++;
						break;
					}
				case SEMICOLON:
				case CLOSEBRACES:
					{
						if (comment + quote + parentheses + bracket === 0) {
							column++;
							break;
						}
					}
				default:
					{
						// increment column position
						column++;

						// current character
						char = body.charAt(caret);

						// remove comments, escape functions, strings, attributes and prepare selectors
						switch (code) {
							case TAB:
							case SPACE:
								{
									if (quote + bracket === 0) {
										switch (tail) {
											case COMMA:
											case COLON:
											case TAB:
											case SPACE:
												{
													char = '';
													break;
												}
											default:
												{
													if (code !== SPACE) {
														char = ' ';
													}
												}
										}
									}
									break;
								}
							// escape breaking control characters
							case NULL:
								{
									char = '\\0';
									break;
								}
							case FORMFEED:
								{
									char = '\\f';
									break;
								}
							case VERTICALTAB:
								{
									char = '\\v';
									break;
								}
							// &
							case AND:
								{
									// inverted selector pattern i.e html &
									if (quote + comment + bracket === 0 && cascade > 0) {
										invert = 1;
										format = 1;
										char = '\f' + char;
									}
									break;
								}
							// ::p<l>aceholder, l
							// :read-on<l>y, l
							case 108:
								{
									if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
										switch (caret - pseudo) {
											// ::placeholder
											case 2:
												{
													if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) {
														pattern = tail;
													}
												}
											// :read-only
											case 8:
												{
													if (trail === READONLY) {
														pattern = trail;
													}
												}
										}
									}
									break;
								}
							// :<pattern>
							case COLON:
								{
									if (quote + comment + bracket === 0) {
										pseudo = caret;
									}
									break;
								}
							// selectors
							case COMMA:
								{
									if (comment + parentheses + quote + bracket === 0) {
										format = 1;
										char += '\r';
									}
									break;
								}
							// quotes
							case DOUBLEQUOTE:
								{
									if (comment === 0) {
										quote = quote === code ? 0 : quote === 0 ? code : quote;
										// " last character, add synthetic padding
										if (caret === eol) {
											eol++;
											eof++;
										}
									}
									break;
								}
							case SINGLEQUOTE:
								{
									if (comment === 0) {
										quote = quote === code ? 0 : quote === 0 ? code : quote;
										// ' last character, add synthetic padding
										if (caret === eol) {
											eol++;
											eof++;
										}
									}
									break;
								}
							// attributes
							case OPENBRACKET:
								{
									if (quote + comment + parentheses === 0) {
										bracket++;
									}
									break;
								}
							case CLOSEBRACKET:
								{
									if (quote + comment + parentheses === 0) {
										bracket--;
									}
									break;
								}
							// functions
							case CLOSEPARENTHESES:
								{
									if (quote + comment + bracket === 0) {
										// ) last character, add synthetic padding
										if (caret === eol) {
											eol++;
											eof++;
										}

										parentheses--;
									}
									break;
								}
							case OPENPARENTHESES:
								{
									if (quote + comment + bracket === 0) {
										if (context === 0) {
											switch (tail * 2 + trail * 3) {
												// :matches
												case 533:
													{
														break;
													}
												// :global, :not, :nth-child etc...
												default:
													{
														counter = 0;
														context = 1;
													}
											}
										}

										parentheses++;
									}
									break;
								}
							case AT:
								{
									if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
										atrule = 1;
									}
									break;
								}
							// block/line comments
							case STAR:
							case FOWARDSLASH:
								{
									if (quote + bracket + parentheses > 0) {
										break;
									}

									switch (comment) {
										// initialize line/block comment context
										case 0:
											{
												switch (code * 2 + body.charCodeAt(caret + 1) * 3) {
													// //
													case 235:
														{
															comment = FOWARDSLASH;
															break;
														}
													// /*
													case 220:
														{
															comment = STAR;
															break;
														}
												}
												break;
											}
										// end block comment context
										case STAR:
											{
												if (code === FOWARDSLASH && tail === STAR) {
													char = '';
													comment = 0;
												}
											}
									}
								}
						}

						// ignore comment blocks
						if (comment === 0) {
							// aggressive isolation mode, divide each individual selector
							// including selectors in :not function but excluding selectors in :global function
							if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
								switch (code) {
									case COMMA:
									case TILDE:
									case GREATERTHAN:
									case PLUS:
									case CLOSEPARENTHESES:
									case OPENPARENTHESES:
										{
											if (context === 0) {
												// outside of an isolated context i.e nth-child(<...>)
												switch (tail) {
													case TAB:
													case SPACE:
													case NEWLINE:
													case CARRIAGE:
														{
															char = char + '\0';
															break;
														}
													default:
														{
															char = '\0' + char + (code === COMMA ? '' : '\0');
														}
												}
												format = 1;
											} else {
												// within an isolated context, sleep untill it's terminated
												switch (code) {
													case OPENPARENTHESES:
														{
															context = ++counter;
															break;
														}
													case CLOSEPARENTHESES:
														{
															if ((context = --counter) === 0) {
																format = 1;
																char += '\0';
															}
															break;
														}
												}
											}
											break;
										}
									case SPACE:
										{
											switch (tail) {
												case NULL:
												case OPENBRACES:
												case CLOSEBRACES:
												case SEMICOLON:
												case COMMA:
												case FORMFEED:
												case TAB:
												case SPACE:
												case NEWLINE:
												case CARRIAGE:
													{
														break;
													}
												default:
													{
														// ignore in isolated contexts
														if (context === 0) {
															format = 1;
															char += '\0';
														}
													}
											}
										}
								}
							}

							// concat buffer of characters
							chars += char;

							// previous non-whitespace character code
							if (code !== SPACE) {
								peak = code;
							}
						}
					}
			}

			// tail character codes
			trail = tail;
			tail = code;

			// visit every character
			caret++;
		}

		length = out.length;

		// preserve empty selector
		if (preserve > 0) {
			if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
				if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) {
					length = current.join(',').length + 2;
				}
			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id);

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children;
				}
			}

			out = selector.join(',') + '{' + out + '}';

			if (vendor * pattern > 0) {
				switch (pattern) {
					// ::read-only
					case READONLY:
						{
							out = out.replace(readonlyptn, ':' + moz + '$1') + out;
							break;
						}
					// ::placeholder
					case PLACEHOLDER:
						{
							out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
							break;
						}
				}
				pattern = 0;
			}
		}

		return flat + out + children;
	}

	/**
  * Select
  *
  * @param {Array<string>} parent
  * @param {string} current
  * @param {number} invert
  * @return {Array<string>}
  */
	function select(parent, current, invert) {
		var selectors = current.trim().split(selectorptn);
		var out = selectors;

		var length = selectors.length;
		var l = parent.length;

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1:
				{
					for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
						out[i] = scope(selector, out[i], invert, l).trim();
					}
					break;
				}
			// >2 parent selectors, nested
			default:
				{
					for (var i = 0, j = 0, out = []; i < length; ++i) {
						for (var k = 0; k < l; ++k) {
							out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
						}
					}
				}
		}

		return out;
	}

	/**
  * Scope
  *
  * @param {string} parent
  * @param {string} current
  * @param {number} invert
  * @param {number} level
  * @return {string}
  */
	function scope(parent, current, invert, level) {
		var selector = current;
		var code = selector.charCodeAt(0);

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0);
		}

		switch (code) {
			// &
			case AND:
				{
					switch (cascade + level) {
						case 0:
						case 1:
							{
								if (parent.trim().length === 0) {
									break;
								}
							}
						default:
							{
								return selector.replace(andptn, '$1' + parent.trim());
							}
					}
					break;
				}
			// :
			case COLON:
				{
					switch (selector.charCodeAt(1)) {
						// g in :global
						case 103:
							{
								if (escape > 0 && cascade > 0) {
									return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
								}
								break;
							}
						default:
							{
								// :hover
								return parent.trim() + selector;
							}
					}
				}
			default:
				{
					// html &
					if (invert * cascade > 0 && selector.indexOf('\f') > 0) {
						return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
					}
				}
		}

		return parent + selector;
	}

	/**
  * Property
  *
  * @param {string} input
  * @param {number} first
  * @param {number} second
  * @param {number} third
  * @return {string}
  */
	function property(input, first, second, third) {
		var index = 0;
		var out = input + ';';
		var hash = first * 2 + second * 3 + third * 4;
		var cache;

		// animation: a, n, i characters
		if (hash === 944) {
			out = animation(out);
		} else if (vendor > 0) {
			// vendor prefix
			switch (hash) {
				// mask
				case 969:
					{
						out = webkit + out.replace(gradientptn, webkit + '$1') + out;
						break;
					}
				// filter/fill f, i, l
				case 951:
					{
						// filter, t
						if (out.charCodeAt(3) === 116) {
							out = webkit + out + out;
						}
						break;
					}
				// color/column, c, o, l
				case 963:
					{
						// column
						if (out.charCodeAt(5) === 110) {
							out = webkit + out + out;
						}
						break;
					}
				// appearance: a, p, p
				case 978:
					{
						out = webkit + out + moz + out + out;
						break;
					}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983:
					{
						out = webkit + out + moz + out + ms + out + out;
						break;
					}
				// background/backface-visibility, b, a, c
				case 883:
					{
						// backface-visibility, -
						if (out.charCodeAt(8) === DASH) {
							out = webkit + out + out;
						}
						break;
					}
				// flex: f, l, e
				case 932:
					{
						out = webkit + out + ms + out + out;
						break;
					}
				// order: o, r, d
				case 964:
					{
						out = webkit + out + ms + 'flex' + '-' + out + out;
						break;
					}
				// justify-content, j, u, s
				case 1023:
					{
						cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
						out = webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
						break;
					}
				// position: sticky
				case 1017:
					{
						if (out.indexOf('sticky', 9) === -1) {
							break;
						}
					}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975:
					{
						index = (out = input).length - 10;
						cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();

						switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)) {
							// inline-
							case 203:
								{
									// inline-box
									if (cache.charCodeAt(8) < 111) {
										break;
									}
								}
							// inline-box/sticky
							case 115:
								{
									out = out.replace(cache, webkit + cache) + ';' + out;
									break;
								}
							// inline-flex
							// flex
							case 207:
							case 102:
								{
									out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
								}
						}

						out += ';';
						break;
					}
				// align-items, align-center, align-self: a, l, i, -
				case 938:
					{
						if (out.charCodeAt(5) === DASH) {
							switch (out.charCodeAt(6)) {
								// align-items, i
								case 105:
									{
										cache = out.replace('-items', '');
										out = webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
										break;
									}
								// align-self, s
								case 115:
									{
										out = webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
										break;
									}
								// align-content
								default:
									{
										out = webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '') + out;
									}
							}
						}
						break;
					}
				// cursor, c, u, r
				case 1005:
					{
						if (cursorptn.test(out)) {
							out = out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out;
						}
						break;
					}
				// width: min-content / width: max-content
				case 953:
					{
						if ((index = out.indexOf('-content', 9)) > 0) {
							// width: min-content / width: max-content
							if (out.charCodeAt(index - 3) === 109 && out.charCodeAt(index - 4) !== 45) {
								cache = out.substring(index - 3);
								out = 'width:' + webkit + cache + 'width:' + moz + cache + 'width:' + cache;
							}
						}
						break;
					}
				// text-size-adjust: t, e, x
				case 1015:
					{
						if (input.charCodeAt(9) !== DASH) {
							break;
						}
					}
				// transform, transition: t, r, a
				case 962:
					{
						out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;

						// transitions
						if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
							out = out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
						}

						break;
					}
				// writing-mode, w, r, i
				case 1000:
					{
						cache = out.substring(13).trim();
						index = cache.indexOf('-') + 1;

						switch (cache.charCodeAt(0) + cache.charCodeAt(index)) {
							// vertical-lr
							case 226:
								{
									cache = out.replace(writingptn, 'tb');
									break;
								}
							// vertical-rl
							case 232:
								{
									cache = out.replace(writingptn, 'tb-rl');
									break;
								}
							// horizontal-tb
							case 220:
								{
									cache = out.replace(writingptn, 'lr');
									break;
								}
							default:
								{
									return out;
								}
						}

						out = webkit + out + ms + cache + out;
						break;
					}
			}
		}

		return out;
	}

	/**
  * @param {string} match
  * @param {string} group
  * @return {string}
  */
	function supports(match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));

		return out !== group + ';' ? out.replace(propertyptn, 'or($1)').substring(2) : '(' + group + ')';
	}

	/**
  * Animation
  *
  * @param {string} input
  * @return {string}
  */
	function animation(input) {
		var length = input.length;
		var index = input.indexOf(':', 9) + 1;
		var declare = input.substring(0, index).trim();
		var body = input.substring(index, length - 1).trim();
		var out = '';

		// shorthand
		if (input.charCodeAt(9) !== DASH) {
			// split in case of multiple animations
			var list = body.split(animationptn);

			for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
				var value = list[i];
				var items = value.split(propertiesptn);

				while (value = items[index]) {
					var peak = value.charCodeAt(0);

					if (keyed === 1 && (
					// letters
					peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE ||
					// dash but not in sequence i.e --
					peak === DASH && value.charCodeAt(1) !== DASH)) {
						// not a number/function
						switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
							case 1:
								{
									switch (value) {
										// not a valid reserved keyword
										case 'infinite':case 'alternate':case 'backwards':case 'running':
										case 'normal':case 'forwards':case 'both':case 'none':case 'linear':
										case 'ease':case 'ease-in':case 'ease-out':case 'ease-in-out':
										case 'paused':case 'reverse':case 'alternate-reverse':case 'inherit':
										case 'initial':case 'unset':case 'step-start':case 'step-end':
											{
												break;
											}
										default:
											{
												value += key;
											}
									}
								}
						}
					}

					items[index++] = value;
				}

				out += (i === 0 ? '' : ',') + items.join(' ');
			}
		} else {
			// animation-name, n
			out += input.charCodeAt(10) === 110 ? body + (keyed === 1 ? key : '') : body;
		}

		out = declare + out + ';';

		return vendor > 0 ? webkit + out + out : out;
	}

	/**
  * Isolate
  *
  * @param {Array<string>} current
  */
	function isolate(current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn);
			var out = '';

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue;
				}

				tail = out.charCodeAt(out.length - 1);
				code = element.charCodeAt(0);
				padding = '';

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:
							{
								break;
							}
						default:
							{
								padding = ' ';
							}
					}
				}

				switch (code) {
					case AND:
						{
							element = padding + nscopealt;
						}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES:
						{
							break;
						}
					case OPENBRACKET:
						{
							element = padding + element + nscopealt;
							break;
						}
					case COLON:
						{
							switch (element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3) {
								// :global
								case 530:
									{
										if (escape > 0) {
											element = padding + element.substring(8, size - 1);
											break;
										}
									}
								// :hover, :nth-child(), ...
								default:
									{
										if (j < 1 || elements[j - 1].length < 1) {
											element = padding + nscopealt + element;
										}
									}
							}
							break;
						}
					case COMMA:
						{
							padding = '';
						}
					default:
						{
							if (size > 1 && element.indexOf(':') > 0) {
								element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
							} else {
								element = padding + element + nscopealt;
							}
						}
				}

				out += element;
			}

			selector[i] = out.replace(formatptn, '').trim();
		}

		return selector;
	}

	/**
  * Proxy
  *
  * @param {number} context
  * @param {string} content
  * @param {Array<string>} selectors
  * @param {Array<string>} parents
  * @param {number} line
  * @param {number} column
  * @param {number} length
  * @param {number} id
  * @return {(string|void|*)}
  */
	function proxy(context, content, selectors, parents, line, column, length, id) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id)) {
				case void 0:
				case false:
				case true:
				case null:
					{
						break;
					}
				default:
					{
						out = next;
					}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content:
				{
					break;
				}
			default:
				{
					return out;
				}
		}
	}

	/**
  * Minify
  *
  * @param {(string|*)} output
  * @return {string}
  */
	function minify(output) {
		return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
	}

	/**
  * Use
  *
  * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
  */
	function use(plugin) {
		switch (plugin) {
			case void 0:
			case null:
				{
					plugged = plugins.length = 0;
					break;
				}
			default:
				{
					switch (plugin.constructor) {
						case Array:
							{
								for (var i = 0, length = plugin.length; i < length; ++i) {
									use(plugin[i]);
								}
								break;
							}
						case Function:
							{
								plugins[plugged++] = plugin;
								break;
							}
						case Boolean:
							{
								unkwn = !!plugin | 0;
							}
					}
				}
		}

		return use;
	}

	/**
  * Set
  *
  * @param {*} options
  */
	function set(options) {
		for (var name in options) {
			var value = options[name];
			switch (name) {
				case 'keyframe':
					keyed = value | 0;break;
				case 'global':
					escape = value | 0;break;
				case 'cascade':
					cascade = value | 0;break;
				case 'compress':
					compress = value | 0;break;
				case 'prefix':
					vendor = value | 0;break;
				case 'semicolon':
					semicolon = value | 0;break;
				case 'preserve':
					preserve = value | 0;break;
			}
		}

		return set;
	}

	/**
  * Stylis
  *
  * @param {string} selector
  * @param {string} input
  * @return {*}
  */
	function stylis(selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector);
		}

		// setup
		var ns = selector;
		var code = ns.charCodeAt(0);

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0);
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1;

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns;
		} else {
			nscopealt = ns;
		}

		var selectors = [nscope];
		var result;

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0);

			if (result !== void 0 && typeof result === 'string') {
				input = result;
			}
		}

		// build
		var output = compile(array, selectors, input, 0);

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0);

			// bypass minification
			if (result !== void 0 && typeof (output = result) !== 'string') {
				code = 0;
			}
		}

		// reset
		key = '';
		nscope = '';
		nscopealt = '';
		pattern = 0;
		line = 1;
		column = 1;

		return compress * code === 0 ? output : minify(output);
	}

	stylis['use'] = use;
	stylis['set'] = set;

	if (options !== void 0) {
		set(options);
	}

	return stylis;
});

/***/ }),

/***/ "YXHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("X5xa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LanguageSwitcher__ = __webpack_require__("XkNw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svgs__ = __webpack_require__("Jv3S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("Uyz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__visual__ = __webpack_require__("qyj1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media__ = __webpack_require__("s647");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__arrows_png__ = __webpack_require__("vr7o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__arrows_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__arrows_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__header_png__ = __webpack_require__("LwpJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__header_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__header_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logo_png__ = __webpack_require__("b6lA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TooltipBubble__ = __webpack_require__("KIZG");
var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 104px;\n  background: url(', ') 0 0 repeat-x;\n  width: 100%;\n  top: 0;\n'], ['\n  height: 104px;\n  background: url(', ') 0 0 repeat-x;\n  width: 100%;\n  top: 0;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 100px;\n  display: flex;\n  flex-direction: row;\n  max-width: 950px;\n  margin: auto;\n'], ['\n  height: 100px;\n  display: flex;\n  flex-direction: row;\n  max-width: 950px;\n  margin: auto;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  flex-grow: 1;\n'], ['\n  flex-grow: 1;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: block;\n  margin-top: 17px;\n  margin-left: 5px;\n'], ['\n  display: block;\n  margin-top: 17px;\n  margin-left: 5px;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  flex-basis: 100px;\n  padding: 30px;\n  border-left: 1px solid #c8bf4b;\n  cursor: pointer;\n  ', ';\n'], ['\n  flex-basis: 100px;\n  padding: 30px;\n  border-left: 1px solid #c8bf4b;\n  cursor: pointer;\n  ', ';\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  font-size: 20px;\n  line-height: 20px;\n  border-left: 1px solid #c8bf4b;\n  padding: 40px 20px 60px 20px;\n'], ['\n  font-size: 20px;\n  line-height: 20px;\n  border-left: 1px solid #c8bf4b;\n  padding: 40px 20px 60px 20px;\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-right: 1px solid #c8bf4b;\n'], ['\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-right: 1px solid #c8bf4b;\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n  font-size: 18px;\n  margin-left: -5px;\n  display: block;\n  height: 29px;\n  padding: 0;\n  :hover {\n    color: white;\n    background: #32383a;\n  }\n'], ['\n  font-size: 18px;\n  margin-left: -5px;\n  display: block;\n  height: 29px;\n  padding: 0;\n  :hover {\n    color: white;\n    background: #32383a;\n  }\n']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n  line-height: 27px;\n  padding: 0 30px 2px 40px;\n  background: url(', ') 4px -7px no-repeat;\n  margin: 0;\n  :hover {\n    background: url(', ') 4px -47px no-repeat;\n  }\n'], ['\n  line-height: 27px;\n  padding: 0 30px 2px 40px;\n  background: url(', ') 4px -7px no-repeat;\n  margin: 0;\n  :hover {\n    background: url(', ') 4px -47px no-repeat;\n  }\n']),
    _templateObject12 = _taggedTemplateLiteralLoose(['\n  opacity: ', ';\n  pointer-events: ', ';\n  background: #32383a;\n  line-height: 3em;\n  font-size: 20px;\n  width: 200px;\n  position: absolute;\n  top: 100px;\n  right: 0;\n  transition: opacity 0.2s ease-in-out;\n  ', ';\n'], ['\n  opacity: ', ';\n  pointer-events: ', ';\n  background: #32383a;\n  line-height: 3em;\n  font-size: 20px;\n  width: 200px;\n  position: absolute;\n  top: 100px;\n  right: 0;\n  transition: opacity 0.2s ease-in-out;\n  ', ';\n']),
    _templateObject13 = _taggedTemplateLiteralLoose(['\n  color: #fff45f;\n  text-align: right;\n  padding-right: 20px;\n  border-bottom: solid 1px ', ';\n  display: block;\n'], ['\n  color: #fff45f;\n  text-align: right;\n  padding-right: 20px;\n  border-bottom: solid 1px ', ';\n  display: block;\n']),
    _templateObject14 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  opacity: ', ';\n  pointer-events: ', ';\n  transition: opacity 1s ease-in-out;\n  z-index: 123456;\n'], ['\n  text-align: center;\n  opacity: ', ';\n  pointer-events: ', ';\n  transition: opacity 1s ease-in-out;\n  z-index: 123456;\n']),
    _templateObject15 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  top: 0;\n'], ['\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  top: 0;\n']);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }













var HeaderBar = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject, __WEBPACK_IMPORTED_MODULE_8__header_png___default.a);

var HeaderBarInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject2);

var Spacer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject3);

var Logo = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].img(_templateObject4);

var HamburgerWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__media__["b" /* screenMoreThan930 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(_templateObject6)));

var MenuItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__visual__["a" /* Link */])(_templateObject7);
var MenuItemMobile = MenuItem.extend(_templateObject8, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__media__["b" /* screenMoreThan930 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(_templateObject6)));
var MenuItemDesktop = MenuItem.extend(_templateObject8, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__media__["a" /* screenLessThan930 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(_templateObject6)));
var MenuItemDesktopSecondaryContainer = MenuItemDesktop.withComponent('div').extend(_templateObject9);

var MenuItemSecondaryOuter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__visual__["a" /* Link */])(_templateObject10);
var MenuItemSecondaryInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject11, __WEBPACK_IMPORTED_MODULE_7__arrows_png___default.a, __WEBPACK_IMPORTED_MODULE_7__arrows_png___default.a);
var MenuItemSecondary = function MenuItemSecondary(props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    MenuItemSecondaryOuter,
    props,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      MenuItemSecondaryInner,
      null,
      props.children
    )
  );
};

var Dropdown = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject12, function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.visible ? 'all' : 'none';
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__media__["b" /* screenMoreThan930 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(_templateObject6)));

var DropdownItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].a(_templateObject13, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* colors */].middleGrey);

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_10__TooltipBubble__["a" /* default */],
  { topArrow: true, offset: 0.5, width: 250, zIndex: 500000 },
  'Prohl\xE9dn\u011Bte si hodnocen\xED ostatn\xEDch politik\u016F'
);

var Tooltip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */])(function (_ref) {
  var className = _ref.className;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: className },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { display: 'inline-block' } },
      _ref2
    )
  );
})(_templateObject14, function (props) {
  return props.visible ? 0.7 : 0;
}, function (props) {
  return props.visible ? 'initial' : 'none';
});

var HeaderImpl = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject15);

var _ref3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  DropdownItem,
  { href: '/cs/zapoj-se' },
  'Zapoj se'
);

var _ref4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  DropdownItem,
  { href: '/cs/o-projektu' },
  'O n\xE1s'
);

var _ref5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  DropdownItem,
  { href: '/cs/pro-media' },
  'Pro m\xE9dia'
);

var _ref6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  DropdownItem,
  { href: '/cs/archiv-novinek' },
  'Aktuality'
);

var _ref7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'a',
  { href: '/cs' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Logo, { src: __WEBPACK_IMPORTED_MODULE_9__logo_png___default.a, alt: 'Rekonstrukce st\xE1tu' })
);

var _ref8 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Spacer, null);

var _ref9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__svgs__["a" /* HamburgerMenu */], null);

var _ref10 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  MenuItemDesktopSecondaryContainer,
  null,
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    MenuItemSecondary,
    { directhref: '/cs/o-projektu' },
    'O n\xE1s'
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    MenuItemSecondary,
    { directhref: '/cs/pro-media' },
    'Pro m\xE9dia'
  ),
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    MenuItemSecondary,
    { directhref: '/cs/archiv-novinek' },
    'Aktuality'
  )
);

var _ref11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__LanguageSwitcher__["a" /* default */], null);

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = { menu: false, laws: false, tooltip: false };
    return _this;
  }

  Header.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2.setState({ tooltip: true });
      setTimeout(function () {
        _this2.setState({ tooltip: false });
      }, 10000);
    }, 3000);
  };

  Header.prototype.render = function render() {
    var _this3 = this;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      HeaderImpl,
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        Dropdown,
        { visible: this.state.menu },
        _ref3,
        _ref4,
        _ref5,
        _ref6
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        HeaderBar,
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          HeaderBarInner,
          null,
          _ref7,
          _ref8,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            MenuItemMobile,
            { localhref: '/', href: '/cs/seznam-politiku' },
            'Politici',
            this.props.hasTooltip ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Tooltip, { visible: this.state.tooltip }) : null
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            HamburgerWrapper,
            {
              onClick: function onClick() {
                return _this3.setState({ menu: !_this3.state.menu });
              }
            },
            _ref9
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            MenuItemDesktop,
            { localhref: '/', href: '/cs/seznam-politiku' },
            'Politici',
            this.props.hasTooltip ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Tooltip, { visible: this.state.tooltip }) : null
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            MenuItemDesktop,
            {
              directhref: '/cs/zapoj-se',
              style: { background: '#8DC641' }
            },
            'Zapoj se'
          ),
          _ref10
        )
      ),
      _ref11,
      _ref12
    );
  };

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);




var _ref13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { className: 'share-nav gt1000' },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'ul',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'li',
      { className: 'top' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'a',
        { href: '#top', className: 'to-anchor' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          null,
          'Nahoru'
        )
      )
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'li',
      { className: 'fb' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'a',
        {
          href: 'http://www.facebook.com/RekonstrukceStatu',
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          null,
          'P\u0159ipoj se na'
        )
      )
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'li',
      { className: 'twitter' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'a',
        {
          href: 'https://twitter.com/share',
          'data-lang': 'en',
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          null,
          'Sd\xEDlej na twitteru'
        )
      )
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'li',
      { className: 'mail' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'a',
        {
          className: 'to-anchor',
          href: '#zapojte-se',
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          null,
          'Newsletter'
        )
      )
    )
  )
),
    SideMenu = function SideMenu() {
  return _ref13;
},
    _ref12 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(SideMenu, null);

/***/ }),

/***/ "Zcn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");



var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "svg",
  {
    className: "spinner",
    width: "65px",
    height: "65px",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  },
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("circle", {
    className: "path",
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round",
    cx: "33",
    cy: "33",
    r: "30"
  })
);

var Spinner = function Spinner() {
  return _ref;
};
/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),

/***/ "aEuF":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    result++;
  }
  return result;
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeFloor = Math.floor;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
  return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? remainder ? result - remainder : result : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = toString(string);
  length = toInteger(length);

  var strLength = length ? stringSize(string) : 0;
  return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
}

module.exports = padStart;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "am7w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Explainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PoliticianListIntro; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__("X5xa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media__ = __webpack_require__("s647");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout__ = __webpack_require__("KuMu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PoliticianDetail_Support__ = __webpack_require__("FIjd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PoliticianDetail_Charts__ = __webpack_require__("928Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_panacek_rest_no_support_png__ = __webpack_require__("sfeO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_panacek_rest_no_support_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_panacek_rest_no_support_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_Separator__ = __webpack_require__("poto");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_arrow_down_png__ = __webpack_require__("ygdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_arrow_down_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_arrow_down_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__("Uyz7");
var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  text-align: left;\n  border-top: 1px solid #ccc;\n  padding: 30px 0;\n  vertical-align: middle;\n  align-items: center;\n  line-height: 22px;\n  ', ';\n'], ['\n  display: flex;\n  text-align: left;\n  border-top: 1px solid #ccc;\n  padding: 30px 0;\n  vertical-align: middle;\n  align-items: center;\n  line-height: 22px;\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    flex-direction: column;\n    padding: 30px 10px 30px 10px;\n  '], ['\n    flex-direction: column;\n    padding: 30px 10px 30px 10px;\n  ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  display: block;\n'], ['\n  text-align: center;\n  display: block;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  flex: 0 0 408px;\n  position: relative;\n  height: ', 'px;\n  text-align: center;\n  ', ';\n  > div {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n'], ['\n  flex: 0 0 408px;\n  position: relative;\n  height: ', 'px;\n  text-align: center;\n  ', ';\n  > div {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n    flex: 0 0 ', 'px;\n  '], ['\n    flex: 0 0 ', 'px;\n  ']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-size: 20px;\n  line-height: 20px;\n  cursor: pointer;\n  text-decoration: underline;\n  :hover {\n    text-decoration: none;\n  }\n  img {\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 5px;\n    transform: ', ';\n    transition: transform 0.2s ease-in-out;\n  }\n  div {\n    display: inline-block;\n  }\n'], ['\n  font-size: 20px;\n  line-height: 20px;\n  cursor: pointer;\n  text-decoration: underline;\n  :hover {\n    text-decoration: none;\n  }\n  img {\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 5px;\n    transform: ', ';\n    transition: transform 0.2s ease-in-out;\n  }\n  div {\n    display: inline-block;\n  }\n']);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }













var HintContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__media__["a" /* screenLessThan930 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(_templateObject2)));

var MultilineHint = HintContainer.extend(_templateObject3);

var Illustration = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject4, function (props) {
  return props.height;
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__media__["a" /* screenLessThan930 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(_templateObject5, function (props) {
  return props.height;
})));

var Hint = function Hint(_ref) {
  var ilustration = _ref.ilustration,
      img = _ref.img,
      children = _ref.children,
      height = _ref.height;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    HintContainer,
    null,
    ilustration ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      Illustration,
      { height: height },
      ilustration
    ) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { alt: '', src: img, height: height, width: 408 }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { verticalAlign: 'middle' } },
      children
    )
  );
};

var ShowMore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__layout_Separator__["a" /* default */])(_templateObject6, function (props) {
  return props.expanded ? 'rotate(180deg)' : 'rotate(0deg)';
});

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  null,
  'Tady je jedn\xEDm slovem shrnuto co zobrazuj\xED \u010D\xEDsla a grafy.'
);

var _ref4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  MultilineHint,
  null,
  'Pokud V\xE1s zaj\xEDmaj\xED detaily na\u0161eho hodnocen\xED, nev\xE1hejte se pono\u0159it do',
  ' ',
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'a',
    { href: 'https://pimcore.rekonstrukcestatu.cz/na-stazeni/metodika_hodnoceni.pdf' },
    'metodiky pro geeky'
  ),
  '.'
);

var _ref5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  null,
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: __WEBPACK_IMPORTED_MODULE_8__assets_arrow_down_png___default.a, alt: '' }),
  'Jak jsme hodnotili'
);

var Explainer = function (_Component) {
  _inherits(Explainer, _Component);

  function Explainer() {
    var _temp, _this, _ret;

    _classCallCheck(this, Explainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { expanded: false }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Explainer.prototype.render = function render() {
    var _this2 = this;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            textAlign: 'center',
            maxHeight: this.state.expanded ? 1700 : 0,
            transition: 'max-height 1s ease-in-out',
            overflow: 'hidden',
            marginBottom: -20
          }
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: 'subhead', style: { marginBottom: 30 } },
          'Jak jsme hodnotili?'
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          Hint,
          {
            ilustration: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'span',
              {
                style: {
                  color: '#6a6a6a',
                  fontFamily: 'bariol,arial',
                  backgroundColor: 'transparent',
                  backgroundImage: 'url(' + __WEBPACK_IMPORTED_MODULE_6__assets_panacek_rest_no_support_png___default.a,
                  backgroundPosition: 'right',
                  backgroundRepeat: 'no-repeat',
                  backgroundPositionY: 0,
                  backgroundSize: 'contain',
                  paddingRight: 30,
                  fontSize: 25
                }
              },
              '3x poru\u0161il slib'
            ),
            height: 25
          },
          '165 poslanc\u016F p\u0159isl\xEDbilo podporovat 9 z\xE1kon\u016F, kter\xE9 by zlep\u0161ili legislativn\xED prost\u0159ed\xED v \u010CR. Tady vid\xEDte, kte\u0159\xED sv\u016Fj slib dodr\u017Eeli.'
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          Hint,
          {
            ilustration: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__PoliticianDetail_Charts__["a" /* PieChart */], {
              data: { green: 47.2, grey: 15.8, red: 37 },
              gender: 'M',
              title: 'Hlasov\xE1n\xED'
            }),
            height: 150
          },
          'O ka\u017Ed\xE9m z\xE1kon\u011B se hlasuje mnohokr\xE1t. Od toho zda se z\xE1kon dnes bude projedn\xE1vat, p\u0159es pozm\u011B\u0148uj\xEDc\xED n\xE1vrhy, a\u017E po p\u0159ehlasov\xE1n\xED Sen\xE1tu. Zde vid\xEDte v kolika procentech politik podporovat a kdy naopak hlasoval pro jeho oslaben\xED, nebo proti jeho p\u0159ijet\xED.',
          _ref2,
          'Ka\u017Ed\xE9 hlasov\xE1n\xED je samoz\u0159ejm\u011B v legislativn\xEDm procesu jinak d\u016Fle\u017Eit\xE9. Proto jinak promlouv\xE1 do v\xFDsledku hodnocen\xED. V\xE1hu jednotliv\xFDch hlasov\xE1n\xED si v\u017Edy m\u016F\u017Eete prohl\xE9dnout dole v tabulce \u201Ehlasov\xE1n\xED podrobn\u011B\u201C.'
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          Hint,
          {
            ilustration: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__PoliticianDetail_Charts__["b" /* ActivityChart */], { nospace: true, data: { green: 20, red: 10 } }),
            height: 130
          },
          'Pr\xE1ce parlamentn\xEDch politik\u016F ale nen\xED jen o hlasov\xE1n\xED. Kdo z\xE1kony opravdu aktivn\u011B prosazoval (nebo naopak blokoval) je dob\u0159e vid\u011Bt pr\xE1v\u011B na dal\u0161\xED aktivit\u011B. Tam spad\xE1 hlavn\u011B navrhov\xE1n\xED jednotliv\xFDch tisk\u016F a pozm\u011B\u0148uj\xEDc\xEDch n\xE1vrh\u016F, ale i vyjedn\xE1v\xE1n\xED podpory u opozice \u010Di ve vl\xE1d\u011B, navrhov\xE1n\xED, \u010Di blokov\xE1n\xED projedn\xE1v\xE1n\xED na pl\xE9nu a podobn\u011B.'
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          Hint,
          {
            ilustration: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__PoliticianDetail_Charts__["a" /* PieChart */], {
              data: { green: 25.8, grey: 51.2, red: 23 },
              gender: 'M',
              title: 'Celkov\u011B'
            }),
            height: 150
          },
          'Celkov\xE9 hodnocen\xED shrnuje hodnocen\xED za aktivitu i hlasov\xE1n\xED. U poslanc\u016F maj\xED ob\u011B slo\u017Eky vliv 50%. U sen\xE1tor\u016F m\xE1 hlasov\xE1n\xED vliv 75% co\u017E odr\xE1\u017E\xED jinou roli horn\xED komory v legislativn\xEDm procesu.'
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          MultilineHint,
          { height: 52 },
          _ref3,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            null,
            Object.keys(__WEBPACK_IMPORTED_MODULE_9__constants__["c" /* supportColors */]).map(function (k) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__PoliticianDetail_Support__["a" /* default */], { small: true, support: k });
            })
          )
        ),
        _ref4
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        ShowMore,
        {
          bg: 'white',
          expanded: this.state.expanded,
          onClick: function onClick() {
            return console.log('ShowMore') || _this2.setState({ expanded: !_this2.state.expanded });
          }
        },
        _ref5
      )
    );
  };

  return Explainer;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var _ref6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_3__layout__["c" /* SectionHead */],
  { head: 'Kte\u0159\xED politici dodr\u017Eeli slovo?' },
  'Podrobn\xE9 hodnocen\xED v\u0161ech poslanc\u016F za volebn\xED obdob\xED',
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null),
  '2013-2017'
);

var _ref7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'p',
  null,
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'span',
    null,
    'Poslanci p\u0159ed volbami 2013 sl\xEDbili, \u017Ee prosad\xED protikorup\u010Dn\xED z\xE1kony, kter\xE9 u\u0161et\u0159\xED miliardy. N\xE1sleduj\xEDc\xED 4 roky jsme sledovali ka\u017Ed\xE9 jejich hlasov\xE1n\xED a m\xE1me data o tom, kdo svoje slovo dodr\u017Eel.'
  )
);

var _ref8 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'p',
  null,
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'span',
    null,
    'Pod\xEDvejte se, jak si vedli politici. A p\u0159e\u010Dt\u011Bte si tak\xE9',
    ' ',
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: 'http://pimcore.rekonstrukcestatu.cz/cs/archiv-novinek/11777-protikorupcni-zakony-jak-si-vedla-vlada-' },
      'zhodnocen\xED vl\xE1dy'
    ),
    '.'
  )
);

var _ref9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Explainer, null);

var PoliticianListIntro = function (_Component2) {
  _inherits(PoliticianListIntro, _Component2);

  function PoliticianListIntro() {
    _classCallCheck(this, PoliticianListIntro);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  PoliticianListIntro.prototype.render = function render() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_3__layout__["a" /* Block */],
      { style: { padding: 0 } },
      _ref6,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { textAlign: 'center' } },
        _ref7,
        _ref8
      ),
      _ref9
    );
  };

  return PoliticianListIntro;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "b6lA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "847c1e969e79f367a31a386df337a488.png";

/***/ }),

/***/ "c9yq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("Uyz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visual__ = __webpack_require__("qyj1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Support__ = __webpack_require__("FIjd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svgs__ = __webpack_require__("Jv3S");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Image = function Image(_ref) {
  var partyLogo = _ref.partyLogo,
      img = _ref.img,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 170 : _ref$height;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          position: 'relative',
          margin: '21px 21px 0 0',
          display: 'inline-block'
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
        style: {
          width: height / 170 * 140,
          height: height,
          backgroundImage: 'url(https://rekonstrukcestatu.cz/' + img + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          WebkitFilter: 'grayscale(100%)',
          filter: 'grayscale(100%)'
        }
      }),
      partyLogo ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'object',
        {
          data: 'https://rekonstrukcestatu.cz/' + partyLogo,
          type: 'image/jpg',
          className: 'party-logo',
          width: '52',
          height: '52',
          style: {
            position: 'absolute',
            top: 0,
            right: 0,
            transform: 'translate(40%, -40%)'
          }
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
          alt: '',
          src: 'https://rekonstrukcestatu.cz/' + partyLogo,
          type: 'image/jpg',
          className: 'party-logo',
          width: '52',
          height: '52',
          style: {
            borderRadius: 26,
            position: 'absolute',
            top: 0,
            right: 0,
            transform: 'translate(40%, -40%)'
          }
        })
      ) : null
    )
  );
};

var Name = function Name(_ref2) {
  var name = _ref2.name,
      center = _ref2.center;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'h1',
    { style: { marginBottom: 0 } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_2__visual__["f" /* AnimatedCenterOrLeft */],
      { animate: false, center: center },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        name.firstname
      ),
      ' ',
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        name.surname
      )
    )
  );
};

var InfoLine = function InfoLine(_ref3) {
  var person = _ref3.person,
      center = _ref3.center;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: 'light last' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_2__visual__["f" /* AnimatedCenterOrLeft */],
      { animate: false, center: center },
      person.affiliationType[0].toUpperCase() + person.affiliationType.slice(1),
      ' ',
      person.party,
      ', ',
      person.region,
      ',',
      ' ',
      function () {
        if (person.gender === 'M') return person.type === 'senator' ? 'Senátor' : 'Poslanec';else return person.type === 'senator' ? 'Senátorka' : 'Poslankyně';
      }()
    )
  );
};

var NameAndInfo = function NameAndInfo(_ref4) {
  var person = _ref4.person,
      center = _ref4.center;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        fontSize: '22px',
        lineHeight: '36px'
      }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Name, { name: person.name, center: center }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(InfoLine, { person: person, center: center })
  );
};

var _ref6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__svgs__["h" /* Bubble */], null);

var Statement = function Statement(_ref5) {
  var link = _ref5.link,
      gender = _ref5.gender,
      inline = _ref5.inline;
  return !link ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      style: {
        height: 40,
        display: 'inline-block',
        margin: '15px 0 0 0'
      }
    },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      {
        href: link,
        style: {
          display: inline ? 'block' : 'inline-block',
          height: inline ? 50 : 'auto',
          marginTop: 10,
          position: 'relative',
          width: 150
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 150
          }
        },
        _ref6,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            style: {
              display: 'inline-block',
              width: 100,
              lineHeight: '1em'
            }
          },
          'vyj\xE1d\u0159en\xED ',
          gender === 'M' ? 'politika' : 'političky'
        )
      )
    )
  );
};

var StatementAndSupport = function StatementAndSupport(_ref7) {
  var administration = _ref7.administration,
      support = _ref7.support,
      small = _ref7.small,
      link = _ref7.link,
      gender = _ref7.gender;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2__visual__["f" /* AnimatedCenterOrLeft */],
    { animate: false, center: !small },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Support__["a" /* default */], {
      support: support,
      margin: !!link,
      administration: administration
    }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Statement, { link: link, gender: gender })
  );
};

var _ref9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', null);

var _ref10 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__svgs__["i" /* RankArrow */], null);

var RankBar = function RankBar(_ref8) {
  var _val = _ref8.val,
      outOf = _ref8.outOf,
      color = _ref8.color,
      _ref8$bgcolor = _ref8.bgcolor,
      bgcolor = _ref8$bgcolor === undefined ? __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* colors */].grey : _ref8$bgcolor;

  var val = void 0;
  if (!Number.isFinite(_val)) return _ref9;else val = _val;
  var height = 100;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { height: height, position: 'relative', width: 70, textAlign: 'left' } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          fontFamily: 'bariol,arial,sans-serif',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '2em',
          color: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* colors */].middleGrey,
          textAlign: 'right',
          right: 30
        }
      },
      val,
      '.'
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          width: 10,
          display: 'inline-block',
          position: 'absolute',
          right: 0
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
        style: { backgroundColor: bgcolor, height: height * val / outOf }
      }),
      _ref10,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
        style: { backgroundColor: color, height: height * (1 - val / outOf) }
      })
    )
  );
};

var Disclaimer = function Disclaimer(_ref11) {
  var show = _ref11.show,
      left = _ref11.left;
  return !show ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2__visual__["f" /* AnimatedCenterOrLeft */],
    { center: !left, animate: false },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: { maxWidth: 500, margin: left ? 0 : '0 auto' },
        className: 'lt930'
      },
      __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* administrationDisclaimer */].replace(/<br>/g, ' ')
    )
  );
};

var _ref12 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__svgs__["j" /* RankIcon */], null);

var HeaderSection = function (_Component) {
  _inherits(HeaderSection, _Component);

  function HeaderSection() {
    _classCallCheck(this, HeaderSection);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  HeaderSection.prototype.render = function render() {
    var _props = this.props,
        person = _props.person,
        all = _props.all,
        pledge = _props.pledge,
        party = _props.party,
        small = _props.small;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            position: 'relative',
            marginBottom: 15,
            minHeight: 220
          }
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            style: {
              display: 'inline-block',
              verticalAlign: 'middle',
              transform: 'translate(20px, ' + (small ? 30 : 30) + 'px)',
              position: 'absolute',
              width: '20%'
            }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Image, { img: person.img, partyLogo: party.logoURL, height: 169 })
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            style: {
              verticalAlign: 'middle',
              paddingLeft: small ? 200 : 0
            }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(NameAndInfo, { person: person, center: !small }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(StatementAndSupport, {
            support: all.category,
            small: small,
            link: pledge.link,
            gender: person.gender,
            administration: person.administration
          }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Disclaimer, { show: person.administration, left: small })
        ),
        Number.isFinite(all.rank.total) && !small ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            style: {
              position: 'absolute',
              top: 30,
              right: 20,
              width: 120,
              textAlign: 'right'
            }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              style: {
                fontSize: '1.5em',
                marginBottom: 5,
                position: 'relative'
              }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { style: { position: 'absolute', top: -6 } },
              _ref12
            ),
            'Po\u0159ad\xED'
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { style: { display: 'inline-block' } },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(RankBar, {
              val: all.rank.total,
              outOf: person.type === 'MOP' ? 200 : 81,
              color: __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* supportColors */][all.category] || __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* supportColors */].nehlasuje
            })
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            null,
            person.type === 'MOP' ? 'z 200 poslanců ve sněmovně' : 'z 81 senátorů'
          )
        ) : null
      ),
      Number.isFinite(all.rank.total) && small ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { padding: 10, textAlign: 'center' } },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { style: { background: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* colors */].grey } },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              style: {
                width: '30%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'left'
              }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { style: { display: 'inline-block', fontSize: '1.5em' } },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__svgs__["j" /* RankIcon */], {
                style: { transform: 'scale(1.5)', marginRight: 15 }
              }),
              'Po\u0159ad\xED'
            )
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              style: {
                width: '20%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'right',
                padding: 10
              }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { style: { display: 'inline-block' } },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(RankBar, {
                bgcolor: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* colors */].greyOnGrey,
                val: all.rank.total,
                outOf: person.type === 'MOP' ? 200 : 81,
                color: __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* supportColors */][all.category] || __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* supportColors */].nehlasuje
              })
            )
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            {
              style: {
                width: '33%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'left',
                padding: 20
              }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { style: { display: 'inline-block' } },
              person.type === 'MOP' ? 'z 200 poslanců ve sněmovně' : 'z 81 senátorů'
            )
          )
        )
      ) : null
    );
  };

  return HeaderSection;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HeaderSection);

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });



var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process === 'undefined' || !process.env || "production" !== 'production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, elementProps, element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && component.base || component;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps();
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "g3jw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__("C4qV");

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _getTypes = __webpack_require__("Iq6+");

var _getTypes2 = _interopRequireDefault(_getTypes);

var _getContentRect = __webpack_require__("932e");

var _getContentRect2 = _interopRequireDefault(_getContentRect);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function withContentRect(types) {
  return function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        }, _this.measure = function (entries) {
          var contentRect = (0, _getContentRect2.default)(_this._node, types || (0, _getTypes2.default)(_this.props));

          if (entries) {
            contentRect.entry = entries[0].contentRect;
          }

          _this.setState({ contentRect: contentRect });

          if (typeof _this.props.onResize === 'function') {
            _this.props.onResize(contentRect);
          }
        }, _this._handleRef = function (node) {
          if (_this._resizeObserver) {
            if (node) {
              _this._resizeObserver.observe(node);
            } else {
              _this._resizeObserver.disconnect(_this._node);
            }
          }
          _this._node = node;

          if (typeof _this.props.innerRef === 'function') {
            _this.props.innerRef(node);
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(_class, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this._resizeObserver = new _resizeObserverPolyfill2.default(this.measure);
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              innerRef = _props.innerRef,
              onResize = _props.onResize,
              props = _objectWithoutProperties(_props, ['innerRef', 'onResize']);

          return (0, _react.createElement)(WrappedComponent, _extends({}, props, {
            measureRef: this._handleRef,
            measure: this.measure,
            contentRect: this.state.contentRect
          }));
        }
      }]);

      return _class;
    }(_react.Component), _class.propTypes = {
      client: _propTypes2.default.bool,
      offset: _propTypes2.default.bool,
      scroll: _propTypes2.default.bool,
      bounds: _propTypes2.default.bool,
      margin: _propTypes2.default.bool,
      innerRef: _propTypes2.default.func,
      onResize: _propTypes2.default.func,
      children: _propTypes2.default.func
    }, _temp2;
  };
}

exports.default = withContentRect;
module.exports = exports['default'];

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "ieDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var hoverable = function hoverable(Component) {
  return function (_React$PureComponent) {
    _inherits(Hoverable, _React$PureComponent);

    function Hoverable() {
      _classCallCheck(this, Hoverable);

      var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this));

      _this.state = { hover: false, recentlyTouched: false };
      _this.onmouseenter = _this.onmouseenter.bind(_this);
      _this.onmouseleave = _this.onmouseleave.bind(_this);
      _this.ontouchend = _this.ontouchend.bind(_this);
      _this.onclick = _this.onclick.bind(_this);
      return _this;
    }

    Hoverable.prototype.onmouseenter = function onmouseenter() {
      if (!this.state.recentlyTouched) this.setState(_extends({}, this.state, { hover: true }));
      return typeof this.props.onMouseEnter === 'function' && this.props.onMouseEnter();
    };

    Hoverable.prototype.onmouseleave = function onmouseleave() {
      this.setState(_extends({}, this.state, { hover: false }));
      return typeof this.props.onMouseLeave === 'function' && this.props.onMouseLeave();
    };

    Hoverable.prototype.ontouchend = function ontouchend() {
      var _this2 = this;

      if (this.state.recentlyTouched) clearTimeout(this.state.recentlyTouched);
      var handle = setTimeout(function () {
        _this2.setState(_extends({}, _this2.state, { recentlyTouched: false }));
      }, 1000);
      this.setState(_extends({}, this.state, { recentlyTouched: handle }));
      if (typeof this.props.onClick === 'function') this.props.onClick();
      return typeof this.props.onTouchEnd === 'function' && this.props.onTouchEnd();
    };

    Hoverable.prototype.onclick = function onclick() {
      if (!this.state.recentlyTouched && typeof this.props.onClick === 'function') {
        this.props.onClick();
      }
    };

    Hoverable.prototype.render = function render() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Component, _extends({
        hover: this.state.hover
      }, this.props, {
        onMouseEnter: this.onmouseenter,
        onMouseLeave: this.onmouseleave,
        onTouchEnd: this.ontouchend,
        onClick: this.onclick
      }));
    };

    return Hoverable;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["default"].PureComponent);
};

/* harmony default export */ __webpack_exports__["a"] = (hoverable);

/***/ }),

/***/ "isZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");



var Chevron = function Chevron() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 20 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 60 : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'white' : _ref$color;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { position: 'relative' } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
      style: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        height: height,
        borderTop: 'solid ' + color + ' ' + height + 'px',
        borderRight: 'solid transparent ' + width / 2 + 'px',
        borderLeft: 'solid transparent ' + width / 2 + 'px',
        width: width
      }
    })
  );
};
/* harmony default export */ __webpack_exports__["a"] = (Chevron);

/***/ }),

/***/ "kfd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimatedCenterOrLeft; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_measure__ = __webpack_require__("oC98");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_measure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_measure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("Uyz7");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/* global window */

var AnimatedCenterOrLeftContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_measure__["withContentRect"])('bounds')(function (_React$PureComponent) {
  _inherits(_class, _React$PureComponent);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this));

    _this.state = {
      starting: true
    };
    return _this;
  }

  _class.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        measureRef = _props.measureRef,
        contentRect = _props.contentRect,
        center = _props.center,
        children = _props.children,
        container = _props.container,
        animate = _props.animate;

    var content = contentRect.bounds;
    var ready = content.width && container.width;
    if (this.props.starting && ready && typeof window !== 'undefined') {
      window.requestAnimationFrame(function () {
        _this2.props.setStarting(false);
      });
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        className: 'content',
        style: _extends({}, function () {
          if (ready && center) {
            var tx = (container.width - content.width) / 2;
            return {
              transform: 'translateX(' + tx + 'px)'
            };
          } else if (center) {
            return {};
          }
          return {};
        }(), {
          display: 'inline-block',
          transition: this.state.starting || !animate ? undefined : __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* transition */]
        }),
        ref: measureRef
      },
      children
    );
  };

  return _class;
}(__WEBPACK_IMPORTED_MODULE_1_react__["default"].PureComponent));

var AnimatedCenterOrLeftContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_measure__["withContentRect"])('bounds')(function (_React$PureComponent2) {
  _inherits(_class2, _React$PureComponent2);

  function _class2() {
    _classCallCheck(this, _class2);

    var _this3 = _possibleConstructorReturn(this, _React$PureComponent2.call(this));

    _this3.state = {
      starting: true
    };
    return _this3;
  }

  _class2.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        measureRef = _props2.measureRef,
        contentRect = _props2.contentRect,
        center = _props2.center,
        children = _props2.children,
        animate = _props2.animate;
    var starting = this.state.starting;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        ref: measureRef,
        style: {
          position: 'relative',
          textAlign: center && starting ? 'center' : 'left'
        },
        className: 'container'
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        AnimatedCenterOrLeftContent,
        {
          center: center,
          container: contentRect.bounds,
          starting: starting,
          setStarting: function setStarting(val) {
            return _this4.setState({ starting: val });
          },
          animate: animate
        },
        children
      )
    );
  };

  return _class2;
}(__WEBPACK_IMPORTED_MODULE_1_react__["default"].PureComponent));

var AnimatedCenterOrLeft = function (_React$Component) {
  _inherits(AnimatedCenterOrLeft, _React$Component);

  function AnimatedCenterOrLeft() {
    _classCallCheck(this, AnimatedCenterOrLeft);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  AnimatedCenterOrLeft.prototype.render = function render() {
    var _props3 = this.props,
        _props3$animate = _props3.animate,
        animate = _props3$animate === undefined ? true : _props3$animate,
        _props3$center = _props3.center,
        center = _props3$center === undefined ? false : _props3$center;

    return animate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      AnimatedCenterOrLeftContainer,
      { center: center, animate: animate },
      this.props.children
    ) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { textAlign: center ? 'center' : 'left' } },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { style: { display: 'inline-block' } },
        this.props.children
      )
    );
  };

  return AnimatedCenterOrLeft;
}(__WEBPACK_IMPORTED_MODULE_1_react__["default"].Component);



/***/ }),

/***/ "m3k2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);

    // ReactTooltip.rebuild
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);

    // ReactTooltip.show
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);

    // Resize
    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };

  /**
   * invoked by resize event of window
   */
  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
};

var _constant = __webpack_require__("4ISx");

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),

/***/ "mqrf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
};

/***/ }),

/***/ "mzXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip__ = __webpack_require__("W+bh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("Uyz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout__ = __webpack_require__("KuMu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visual__ = __webpack_require__("qyj1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoverable__ = __webpack_require__("ieDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_panacek_rest_png__ = __webpack_require__("F6cP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_panacek_rest_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_panacek_rest_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_panacek_rest_no_support_png__ = __webpack_require__("sfeO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_panacek_rest_no_support_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_panacek_rest_no_support_png__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var toLowerIfString = function toLowerIfString(s) {
  return typeof s === 'string' ? s.toLowerCase() : s;
};

var PoliticianImage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hoverable__["a" /* default */])(function (_Component) {
  _inherits(PoliticianImageImpl, _Component);

  function PoliticianImageImpl() {
    _classCallCheck(this, PoliticianImageImpl);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PoliticianImageImpl.prototype.render = function render() {
    var _props = this.props,
        data = _props.data,
        hover = _props.hover,
        party = _props.party;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: { position: 'relative', background: '#000' },
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_4__visual__["a" /* Link */],
        { href: data.person.url },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
          alt: '',
          style: {
            width: '100%',
            height: 138,
            backgroundImage: 'url(https://rekonstrukcestatu.cz' + data.person.img + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            WebkitFilter: 'grayscale(100%)',
            Filter: 'grayscale(100%)',
            transition: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* transition */],
            opacity: hover ? 0.5 : 1
          }
        }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', {
          style: {
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            transition: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* transition */],
            height: hover ? 30 : 5,
            background: function () {
              if (party.stripeColor) return party.stripeColor;
              if (party.stripeURL) return 'url(https://rekonstrukcestatu.cz' + party.stripeURL + ') 0 0 repeat-y';
              return 'transparent';
            }()
          }
        }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          {
            style: {
              color: '#fff',
              position: 'absolute',
              left: 0,
              bottom: 60,
              width: '100%',
              display: hover ? 'block' : 'none'
            }
          },
          data.person.party
        )
      )
    );
  };

  return PoliticianImageImpl;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]));

var Politician = function (_Component2) {
  _inherits(Politician, _Component2);

  function Politician() {
    _classCallCheck(this, Politician);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  Politician.prototype.render = function render() {
    var _props2 = this.props,
        data = _props2.data,
        party = _props2.party,
        hidden = _props2.hidden;

    var fullf = toLowerIfString(data.pledge.fullfillment[0]);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          letterSpacing: 0,
          width: 120,
          paddingLeft: 5,
          margin: '0 0 0 0',
          textAlign: 'center',
          display: hidden ? 'none' : 'inline-block',
          verticalAlign: 'middle'
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            margin: 0,
            height: 55,
            position: 'relative'
          }
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'h3',
          {
            style: {
              fontSize: 16,
              lineHeight: '22px',
              margin: '0 0 5px 0',
              width: '100%',
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)'
            }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_4__visual__["a" /* Link */],
            { href: data.person.url },
            data.person.name.firstname,
            ' ',
            data.person.name.surname
          )
        )
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(PoliticianImage, { data: data, party: party }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            backgroundColor: data.person.administration ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* colors */].darkGrey : __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* supportColors */][data.all.category],
            fontSize: 15,
            fontFamily: 'bariol,arial',
            fontWeight: 'bold',
            padding: 10,
            borderRadius: '0 0 0 5px',
            lineHeight: '18px',
            height: 54,
            verticalAlign: 'middle',
            display: 'table-cell',
            width: 120,
            color: '#fff',
            textAlign: 'center'
          },
          'data-tip': data.person.administration ? __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* administrationDisclaimer */] : ''
        },
        data.person.administration ? 'člen vlády' : data.all.category
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            color: '#6a6a6a',
            fontFamily: 'bariol,arial',
            height: 45,
            lineHeight: '1.2em'
          }
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          {
            style: {
              backgroundColor: 'transparent',
              // backgroundImage: "url('/static/img/panacek_rest_no_support.png')",
              backgroundImage: function () {
                if (fullf === 'plní slib') return 'url(' + __WEBPACK_IMPORTED_MODULE_6__assets_panacek_rest_png___default.a + ')';
                if (fullf === 0) return undefined;
                return 'url(' + __WEBPACK_IMPORTED_MODULE_7__assets_panacek_rest_no_support_png___default.a + ')';
              }(),
              backgroundPosition: 'right',
              backgroundRepeat: 'no-repeat',
              backgroundPositionY: 0,
              backgroundSize: 'contain',
              paddingRight: fullf === 0 ? 0 : 20,
              fontSize: '15px'
              // backgroundSize: 'contain',
            }
          },
          (data.pledge.fullfillment[0] || (data.person.gender === 'M' ? 'Nezavázal se' : 'Nezavázala se')).replace('porušil', data.person.gender === 'M' ? 'porušil' : 'porušila')
        ),
        ' '
      )
    );
  };

  return Politician;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_react_tooltip___default.a, { multiline: true, effect: 'solid', 'class': 'tooltip' });

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var list = _ref.list,
      parties = _ref.parties;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_3__layout__["a" /* Block */],
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: { minHeight: 311, textAlign: 'center' } },
      list.length > 0 ? list.map(function (p) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Politician, {
          party: parties[p.person.party] || {},
          data: p,
          key: p.person.name.firstname + ' ' + p.person.name.surname,
          hidden: p.hidden
        });
      }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            letterSpacing: 0,
            textAlign: 'center',
            width: '100%'
          }
        },
        'Tomuto v\xFDb\u011Bru neodpov\xEDd\xE1 \u017E\xE1dn\xFD politik'
      )
    ),
    _ref2
  );
});

/***/ }),

/***/ "oC98":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContentRect = exports.default = undefined;

var _Measure = __webpack_require__("SCgj");

var _Measure2 = _interopRequireDefault(_Measure);

var _withContentRect = __webpack_require__("g3jw");

var _withContentRect2 = _interopRequireDefault(_withContentRect);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _Measure2.default;
exports.withContentRect = _withContentRect2.default;

/***/ }),

/***/ "ojtX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("eW0v");



var SectionHead = function SectionHead(_ref) {
  var head = _ref.head,
      subhead = _ref.subhead,
      children = _ref.children;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    { className: "section-head" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "h1",
      { className: "last" },
      head
    ),
    subhead || children ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "p",
      { className: "subhead" },
      subhead || children
    ) : null
  );
};
/* harmony default export */ __webpack_exports__["a"] = (SectionHead);

/***/ }),

/***/ "pfHg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;

    var observer = new MutationObserver(function (mutations) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var mutation = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = mutation.removedNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var element = _step2.value;

              if (element === _this.state.currentTarget) {
                _this.hideTooltip();
                return;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });

    observer.observe(window.document, { childList: true, subtree: true });

    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
};

/**
 * Tracking target removing from DOM.
 * It's nessesary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */

// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

/***/ }),

/***/ "poto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Separator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Separator = function (_Component) {
  _inherits(Separator, _Component);

  function Separator() {
    _classCallCheck(this, Separator);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Separator.prototype.render = function render() {
    var _props = this.props,
        packed = _props.packed,
        bg = _props.bg;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        className: this.props.className,
        style: {
          fontSize: 22,
          position: 'relative',
          top: 20,
          textAlign: 'center',
          margin: packed ? '0' : '20px 0'
        },
        onClick: this.props.onClick
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
        style: {
          width: '100%',
          height: 1,
          background: '#ccc',
          position: 'absolute',
          top: packed ? 8 : -2,
          left: 0
        }
      }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          style: {
            display: 'inline',
            background: bg || '#e6e6e6',
            color: '#9b9b9b',
            padding: '0 10px',
            position: 'relative',
            top: packed ? -6 : -16
          }
        },
        this.props.children
      )
    );
  };

  return Separator;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if ('serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register('/sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default || m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "qyj1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__("DsvJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkbox__ = __webpack_require__("wdbO");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Chart__ = __webpack_require__("Ou8H");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__Chart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__("/7Sf");
/* unused harmony reexport Icon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Link__ = __webpack_require__("Xoaw");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnimatedCenterOrLeft__ = __webpack_require__("kfd9");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__AnimatedCenterOrLeft__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Spinner__ = __webpack_require__("Zcn4");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Spinner__["a"]; });








/***/ }),

/***/ "rgnM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCapture = function (currentTarget) {
    var dataIsCapture = currentTarget.getAttribute('data-iscapture');
    return dataIsCapture && dataIsCapture === 'true' || this.props.isCapture || false;
  };
};

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s647":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return screenLessThan930; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return screenMoreThan930; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("X5xa");
var _templateObject = _taggedTemplateLiteralLoose(['\n  @media only screen and (max-width: 929px) {\n    ', ';\n  }\n'], ['\n  @media only screen and (max-width: 929px) {\n    ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  @media only screen and (min-width: 930px) {\n    ', ';\n  }\n'], ['\n  @media only screen and (min-width: 930px) {\n    ', ';\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }



var screenLessThan930 = function screenLessThan930() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject, __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */].apply(undefined, arguments));
};
var screenMoreThan930 = function screenMoreThan930() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2, __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */].apply(undefined, arguments));
};

/***/ }),

/***/ "sfeO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5ece04226e31e53ccb990d568392da65.png";

/***/ }),

/***/ "vYDn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAria = parseAria;
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return (/(^aria-\w+$|^role$)/.test(prop)
    );
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });

  return ariaObj;
}

/***/ }),

/***/ "vr7o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "33831b1d8a6418394a5b7e39566610a8.png";

/***/ }),

/***/ "wRU+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("UQex");
var invariant = __webpack_require__("wRU+");
var ReactPropTypesSecret = __webpack_require__("Asjh");

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "wdbO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_sprite_png__ = __webpack_require__("EmMn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_sprite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_sprite_png__);




var CheckboxVisual = function CheckboxVisual(_ref) {
  var checked = _ref.checked;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
    style: {
      display: 'inline-block',
      zoom: 1,
      textAlign: 'center',
      background: checked ? 'url(' + __WEBPACK_IMPORTED_MODULE_1__assets_sprite_png___default.a + ') -327px -408px no-repeat' : 'url(' + __WEBPACK_IMPORTED_MODULE_1__assets_sprite_png___default.a + ') -327px -368px no-repeat',
      position: 'absolute',
      left: 0,
      top: 0,
      width: 25,
      height: 25
    }
  });
};

var Checkbox = function Checkbox(_ref2) {
  var checked = _ref2.checked,
      _onChange = _ref2.onChange,
      children = _ref2.children,
      id = _ref2.id;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { style: { height: 45 } },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        style: {
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: 21,
          lineHeight: '1.5em',
          paddingLeft: 40,
          whiteSpace: 'nowrap'
        }
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'label',
        { htmlFor: id, style: { userSelect: 'none', fontWeight: 'normal' } },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
          checked: checked,
          type: 'checkbox',
          id: id,
          onChange: function onChange(evt) {
            return _onChange(evt.target.checked);
          },
          style: { display: 'none' }
        }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(CheckboxVisual, { checked: checked }),
        children
      )
    )
  );
};
/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),

/***/ "xIVz":
/***/ (function(module, exports) {

module.exports = isFunction;

var toString = Object.prototype.toString;

function isFunction(fn) {
  var string = toString.call(fn);
  return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && (
  // IE8 and below
  fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
};

/***/ }),

/***/ "xRcQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;

    return event || !!ele.getAttribute('data-event');
  };

  /* Bind listener for custom event */
  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _state = this.state,
        event = _state.event,
        eventOff = _state.eventOff;

    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;

    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListener);
      customListener = checkStatus.bind(_this, dataEventOff);
      ele.addEventListener(event, customListener, false);
    });
    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };

  /* Unbind listener for custom event */
  target.prototype.customUnbindListener = function (ele) {
    var _state2 = this.state,
        event = _state2.event,
        eventOff = _state2.eventOff;

    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');

    ele.removeEventListener(dataEvent, customListener);
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
};

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */

var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;

  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
  var currentItem = e.currentTarget.getAttribute('currentItem');

  if (!isCapture) e.stopPropagation();
  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListener = void 0;

/***/ }),

/***/ "xkb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var watching = false;
var hoverDisable = false;
var listeners = [];

function watchForHover() {
  if (watching) return;
  watching = true;
  var lastTouchTime = 0;

  function enableHover() {
    // filter emulated events coming from touch events
    if (new Date() - lastTouchTime < 500) return;

    if (hoverDisable) {
      hoverDisable = false;
      listeners.forEach(function (l) {
        return l(false);
      });
    }
  }

  function disableHover() {
    if (!hoverDisable) {
      hoverDisable = true;
      listeners.forEach(function (l) {
        return l(true);
      });
    }
  }

  function updateLastTouchTime() {
    lastTouchTime = new Date();
  }
  if (typeof document !== 'undefined') {
    document.addEventListener('touchstart', updateLastTouchTime, true);
    document.addEventListener('touchstart', disableHover, true);
    document.addEventListener('mousemove', enableHover, true);
  }

  enableHover();
}

watchForHover();

var HoverDisablerComp = function (_Component) {
  _inherits(HoverDisablerComp, _Component);

  function HoverDisablerComp() {
    var _temp, _this, _ret;

    _classCallCheck(this, HoverDisablerComp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.lastDisableListener = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  HoverDisablerComp.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (this.props.onHoverDisable !== nextProps.onHoverDisable) {
      var last = this.props.onHoverDisable;
      var cur = nextProps.onHoverDisable;
      if (last) {
        listeners = listeners.filter(function (l) {
          return l !== last;
        });
      }
      if (cur) {
        listeners.push(cur);
      }
    }
    return true;
  };

  HoverDisablerComp.prototype.render = function render() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      this.props.children
    );
  };

  return HoverDisablerComp;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (function (C) {
  return function (_Component2) {
    _inherits(HoverDisabler, _Component2);

    function HoverDisabler() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, HoverDisabler);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = { hoverDisable: hoverDisable }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    HoverDisabler.prototype.render = function render() {
      var _this3 = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        HoverDisablerComp,
        {
          onHoverDisable: function onHoverDisable() {
            return _this3.setState({ hoverDisable: hoverDisable });
          }
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(C, _extends({}, this.props, { hoverDisable: this.state.hoverDisable }))
      );
    };

    return HoverDisabler;
  }(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);
});

/***/ }),

/***/ "ygdx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0ad597b5a16e7075b73fe8a71aea0d57.png";

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.3d49a.js